webpackJsonp([525],{

/***/ 1194:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1195:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1196:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1197:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1198:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1199:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1200:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1201:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1202:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1203:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1205:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 430,
	"./af.js": 430,
	"./ar": 437,
	"./ar-dz": 431,
	"./ar-dz.js": 431,
	"./ar-kw": 432,
	"./ar-kw.js": 432,
	"./ar-ly": 433,
	"./ar-ly.js": 433,
	"./ar-ma": 434,
	"./ar-ma.js": 434,
	"./ar-sa": 435,
	"./ar-sa.js": 435,
	"./ar-tn": 436,
	"./ar-tn.js": 436,
	"./ar.js": 437,
	"./az": 438,
	"./az.js": 438,
	"./be": 439,
	"./be.js": 439,
	"./bg": 440,
	"./bg.js": 440,
	"./bm": 441,
	"./bm.js": 441,
	"./bn": 443,
	"./bn-bd": 442,
	"./bn-bd.js": 442,
	"./bn.js": 443,
	"./bo": 444,
	"./bo.js": 444,
	"./br": 445,
	"./br.js": 445,
	"./bs": 446,
	"./bs.js": 446,
	"./ca": 447,
	"./ca.js": 447,
	"./cs": 448,
	"./cs.js": 448,
	"./cv": 449,
	"./cv.js": 449,
	"./cy": 450,
	"./cy.js": 450,
	"./da": 451,
	"./da.js": 451,
	"./de": 454,
	"./de-at": 452,
	"./de-at.js": 452,
	"./de-ch": 453,
	"./de-ch.js": 453,
	"./de.js": 454,
	"./dv": 455,
	"./dv.js": 455,
	"./el": 456,
	"./el.js": 456,
	"./en-au": 457,
	"./en-au.js": 457,
	"./en-ca": 458,
	"./en-ca.js": 458,
	"./en-gb": 459,
	"./en-gb.js": 459,
	"./en-ie": 460,
	"./en-ie.js": 460,
	"./en-il": 461,
	"./en-il.js": 461,
	"./en-in": 462,
	"./en-in.js": 462,
	"./en-nz": 463,
	"./en-nz.js": 463,
	"./en-sg": 464,
	"./en-sg.js": 464,
	"./eo": 465,
	"./eo.js": 465,
	"./es": 469,
	"./es-do": 466,
	"./es-do.js": 466,
	"./es-mx": 467,
	"./es-mx.js": 467,
	"./es-us": 468,
	"./es-us.js": 468,
	"./es.js": 469,
	"./et": 470,
	"./et.js": 470,
	"./eu": 471,
	"./eu.js": 471,
	"./fa": 472,
	"./fa.js": 472,
	"./fi": 473,
	"./fi.js": 473,
	"./fil": 474,
	"./fil.js": 474,
	"./fo": 475,
	"./fo.js": 475,
	"./fr": 478,
	"./fr-ca": 476,
	"./fr-ca.js": 476,
	"./fr-ch": 477,
	"./fr-ch.js": 477,
	"./fr.js": 478,
	"./fy": 479,
	"./fy.js": 479,
	"./ga": 480,
	"./ga.js": 480,
	"./gd": 481,
	"./gd.js": 481,
	"./gl": 482,
	"./gl.js": 482,
	"./gom-deva": 483,
	"./gom-deva.js": 483,
	"./gom-latn": 484,
	"./gom-latn.js": 484,
	"./gu": 485,
	"./gu.js": 485,
	"./he": 486,
	"./he.js": 486,
	"./hi": 487,
	"./hi.js": 487,
	"./hr": 488,
	"./hr.js": 488,
	"./hu": 489,
	"./hu.js": 489,
	"./hy-am": 490,
	"./hy-am.js": 490,
	"./id": 491,
	"./id.js": 491,
	"./is": 492,
	"./is.js": 492,
	"./it": 494,
	"./it-ch": 493,
	"./it-ch.js": 493,
	"./it.js": 494,
	"./ja": 495,
	"./ja.js": 495,
	"./jv": 496,
	"./jv.js": 496,
	"./ka": 497,
	"./ka.js": 497,
	"./kk": 498,
	"./kk.js": 498,
	"./km": 499,
	"./km.js": 499,
	"./kn": 500,
	"./kn.js": 500,
	"./ko": 501,
	"./ko.js": 501,
	"./ku": 502,
	"./ku.js": 502,
	"./ky": 503,
	"./ky.js": 503,
	"./lb": 504,
	"./lb.js": 504,
	"./lo": 505,
	"./lo.js": 505,
	"./lt": 506,
	"./lt.js": 506,
	"./lv": 507,
	"./lv.js": 507,
	"./me": 508,
	"./me.js": 508,
	"./mi": 509,
	"./mi.js": 509,
	"./mk": 510,
	"./mk.js": 510,
	"./ml": 511,
	"./ml.js": 511,
	"./mn": 512,
	"./mn.js": 512,
	"./mr": 513,
	"./mr.js": 513,
	"./ms": 515,
	"./ms-my": 514,
	"./ms-my.js": 514,
	"./ms.js": 515,
	"./mt": 516,
	"./mt.js": 516,
	"./my": 517,
	"./my.js": 517,
	"./nb": 518,
	"./nb.js": 518,
	"./ne": 519,
	"./ne.js": 519,
	"./nl": 521,
	"./nl-be": 520,
	"./nl-be.js": 520,
	"./nl.js": 521,
	"./nn": 522,
	"./nn.js": 522,
	"./oc-lnc": 523,
	"./oc-lnc.js": 523,
	"./pa-in": 524,
	"./pa-in.js": 524,
	"./pl": 525,
	"./pl.js": 525,
	"./pt": 527,
	"./pt-br": 526,
	"./pt-br.js": 526,
	"./pt.js": 527,
	"./ro": 528,
	"./ro.js": 528,
	"./ru": 529,
	"./ru.js": 529,
	"./sd": 530,
	"./sd.js": 530,
	"./se": 531,
	"./se.js": 531,
	"./si": 532,
	"./si.js": 532,
	"./sk": 533,
	"./sk.js": 533,
	"./sl": 534,
	"./sl.js": 534,
	"./sq": 535,
	"./sq.js": 535,
	"./sr": 537,
	"./sr-cyrl": 536,
	"./sr-cyrl.js": 536,
	"./sr.js": 537,
	"./ss": 538,
	"./ss.js": 538,
	"./sv": 539,
	"./sv.js": 539,
	"./sw": 540,
	"./sw.js": 540,
	"./ta": 541,
	"./ta.js": 541,
	"./te": 542,
	"./te.js": 542,
	"./tet": 543,
	"./tet.js": 543,
	"./tg": 544,
	"./tg.js": 544,
	"./th": 545,
	"./th.js": 545,
	"./tk": 546,
	"./tk.js": 546,
	"./tl-ph": 547,
	"./tl-ph.js": 547,
	"./tlh": 548,
	"./tlh.js": 548,
	"./tr": 549,
	"./tr.js": 549,
	"./tzl": 550,
	"./tzl.js": 550,
	"./tzm": 552,
	"./tzm-latn": 551,
	"./tzm-latn.js": 551,
	"./tzm.js": 552,
	"./ug-cn": 553,
	"./ug-cn.js": 553,
	"./uk": 554,
	"./uk.js": 554,
	"./ur": 555,
	"./ur.js": 555,
	"./uz": 557,
	"./uz-latn": 556,
	"./uz-latn.js": 556,
	"./uz.js": 557,
	"./vi": 558,
	"./vi.js": 558,
	"./x-pseudo": 559,
	"./x-pseudo.js": 559,
	"./yo": 560,
	"./yo.js": 560,
	"./zh-cn": 561,
	"./zh-cn.js": 561,
	"./zh-hk": 562,
	"./zh-hk.js": 562,
	"./zh-mo": 563,
	"./zh-mo.js": 563,
	"./zh-tw": 564,
	"./zh-tw.js": 564
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1205;

/***/ }),

/***/ 1215:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_org_tree_vue__ = __webpack_require__(303);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5de75ec8_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_org_tree_vue__ = __webpack_require__(1226);
function injectStyle (ssrContext) {
  __webpack_require__(1202)
}
var normalizeComponent = __webpack_require__(72)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_org_tree_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5de75ec8_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_org_tree_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1216:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menuTree_vue__ = __webpack_require__(306);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e673d1c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_menuTree_vue__ = __webpack_require__(1224);
function injectStyle (ssrContext) {
  __webpack_require__(1198)
}
var normalizeComponent = __webpack_require__(72)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4e673d1c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_menuTree_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e673d1c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_menuTree_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1217:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tabNav_vue__ = __webpack_require__(307);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dd38a4a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tabNav_vue__ = __webpack_require__(1227);
function injectStyle (ssrContext) {
  __webpack_require__(1203)
}
var normalizeComponent = __webpack_require__(72)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6dd38a4a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tabNav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dd38a4a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tabNav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1218:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_emptyContainer_vue__ = __webpack_require__(309);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4958da4b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_emptyContainer_vue__ = __webpack_require__(1223);
function injectStyle (ssrContext) {
  __webpack_require__(1197)
}
var normalizeComponent = __webpack_require__(72)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4958da4b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_emptyContainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4958da4b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_emptyContainer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1219:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_exportFile_vue__ = __webpack_require__(310);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12c340c0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_exportFile_vue__ = __webpack_require__(1221);
function injectStyle (ssrContext) {
  __webpack_require__(1195)
}
var normalizeComponent = __webpack_require__(72)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-12c340c0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_exportFile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12c340c0_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_exportFile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1220:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1221:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.existTask)?_c('div',[_c('router-link',{staticClass:"f messages el-badge",attrs:{"to":""}},[_c('div',{attrs:{"id":"showExportBtn"},on:{"click":_vm.shrink}},[_c('i',{staticClass:"el-icon-download"}),_vm._v("\n      下载列表\n      "),_c('sup',{directives:[{name:"show",rawName:"v-show",value:(_vm.existTask),expression:"existTask"}],staticClass:"el-badge__content el-badge__content&#45;&#45;undefined is-fixed",staticStyle:{"top":"17px"}},[_vm._v(_vm._s(_vm.tasks? _vm.tasks.length : 0))])])]),_vm._v(" "),_c('el-popover',{staticStyle:{"margin-top":"15px"},attrs:{"placement":"bottom","width":"300","trigger":"manual","id":"exportFilePopover"},model:{value:(_vm.isHidden),callback:function ($$v) {_vm.isHidden=$$v},expression:"isHidden"}},[_c('el-row',{staticStyle:{"padding-top":"10px","font-weight":"bold"}},[_c('el-col',{staticStyle:{"color":"#909399"},attrs:{"span":12}},[_vm._v("\n        文件下载列表\n      ")]),_vm._v(" "),(_vm.existTask)?_c('el-col',{staticStyle:{"text-align":"right"},attrs:{"span":12}},[_c('el-popconfirm',{attrs:{"title":"确定清空全部任务吗？"},on:{"onConfirm":function($event){return _vm.closeAll()}}},[_c('el-button',{staticStyle:{"padding":"0px"},attrs:{"slot":"reference","type":"text"},slot:"reference"},[_vm._v("清空全部")])],1)],1):_vm._e(),_vm._v(" "),_c('el-divider',{staticStyle:{"margin":"0px !important"}})],1),_vm._v(" "),(_vm.existTask)?_c('div',{attrs:{"id":"tasksDiv"}},_vm._l((this.tasks),function(row){return _c('p',{staticClass:"df",staticStyle:{"margin-bottom":"10px"}},[_c('img',{staticClass:"list_round",attrs:{"src":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAASUlEQVQYV3XNwQmAMBAEwMnHtxVqB/rSInwZS7DBWIIcGpCA+znY4diEDhsGT06sCTvmt6wnBxT0DVx/UAIypubjCKjj42d8uQErigsRrcHQ3gAAAABJRU5ErkJggg=="}}),_vm._v(" "),_c('span',[_c('span',{staticClass:"flexdc",staticStyle:{"font-size":"14px","line-height":"14px","margin-bottom":"6px"},domProps:{"innerHTML":_vm._s(row.fileName)}},[_vm._v("2021_企业培训档案")]),_vm._v(" "),_c('span',[(row.taskState ==  _vm.exportFileConstant.taskStatus.processing)?[_c('span',{staticStyle:{"color":"#e6a23c"}},[_vm._v("处理中")])]:_vm._e(),_vm._v(" "),(row.taskState ==  _vm.exportFileConstant.taskStatus.sucess)?[_c('span',{staticClass:"success_color"},[_vm._v("已完成")]),_vm._v(" "),_c('span',{staticClass:"load_fail_btn"},[_c('a',{staticClass:"nodrag el-link el-link--primary is-underline",staticStyle:{"margin-left":"10px"},attrs:{"href":row.downloadURL}},[_c('span',{staticClass:"el-link--inner"},[_vm._v("下载")])])])]:_vm._e(),_vm._v(" "),(row.taskState == _vm.exportFileConstant.taskStatus.failure)?[_c('span',{staticStyle:{"color":"#f56c6c"}},[_vm._v("失败")]),_vm._v(" "),_c('span',{staticClass:"load_fail_btn"},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":row.errorMsg,"placement":"top-start"}},[_c('el-link',{attrs:{"type":"danger","underline":false}},[_vm._v("失败描述")])],1)],1)]:_vm._e()],2)])])}),0):_vm._e(),_vm._v(" "),(!_vm.existTask)?_c('emptyContainer'):_vm._e()],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1222:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{ref:"selectRef",attrs:{"disabled":_vm.disabled,"value":_vm.valueTitle,"clearable":_vm.clearable,"filterable":"","filter-method":_vm.selectFilter,"placeholder":_vm.placeholder},on:{"clear":_vm.clearHandle},nativeOn:{"click":function($event){return _vm.reLoadTree($event)}}},[_c('el-option',{attrs:{"value":_vm.valueTitle,"label":_vm.valueTitle,"filterable":""}},[_c('el-tree',{ref:"selectTree",attrs:{"id":"tree-option","accordion":_vm.accordion,"data":_vm.deptTree,"props":_vm.props,"node-key":_vm.props.value,"default-expanded-keys":_vm.defaultExpandedKey,"filter-node-method":_vm.treeFilter},on:{"node-click":_vm.handleNodeClick}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1223:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-container"},[_c('div',{staticClass:"empty-image"},[_c('svg',{attrs:{"width":_vm.width,"height":_vm.height,"viewBox":"0 0 64 41","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"transform":"translate(0 1)","fill":"none","fillRule":"evenodd"}},[_c('ellipse',{attrs:{"fill":"#F5F5F5","cx":"32","cy":"33","rx":"32","ry":"7"}}),_vm._v(" "),_c('g',{attrs:{"fillRule":"nonzero","stroke":"#D9D9D9"}},[_c('path',{attrs:{"d":"M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"}}),_c('path',{attrs:{"d":"M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z","fill":"#FAFAFA"}})])])])]),_vm._v(" "),_c('div',{staticClass:"empty-text",domProps:{"innerHTML":_vm._s(_vm.text)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.menuData),function(child,index){return [(child.children.length > 0)?_c('el-submenu',{class:_vm.$route.path==child.path?'is-active':'',attrs:{"index":child.id+'-'+index}},[_c('template',{slot:"title"},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(child.name))])]),_vm._v(" "),_c('menu-tree',{attrs:{"menuData":child.children}})],2):_vm._e(),_vm._v(" "),(child.menuType < 2 && child.children.length == 0)?_c('el-menu-item',{attrs:{"index":child.path}},[_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(child.name))])]):_vm._e()]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1225:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"container",staticStyle:{"height":"100%"}},[_c('el-col',{staticClass:"f fb topbar-wrap",attrs:{"span":24}},[_c('div',{staticClass:"f topbar-left"},[_c('a',{staticClass:"f topbar-logo",attrs:{"href":"/"}},[(_vm.logo.length > 0)?_c('img',{staticStyle:{"width":"60px","height":"60px"},attrs:{"src":_vm.logo}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"topbar-title"},[_vm._v("\n            珠海市金品创业共享平台安全管控平台\n            "),(_vm.version)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.version)}}):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"f topbar-search"},[_c('el-select',{staticClass:"custom-select",attrs:{"clearable":"","filterable":"","placeholder":"快捷搜索您想找的菜单名称"},on:{"change":function($event){return _vm.toPage(_vm.selectUrl)}},model:{value:(_vm.selectUrl),callback:function ($$v) {_vm.selectUrl=$$v},expression:"selectUrl"}},[_c('div',{staticStyle:{"max-height":"300px"}},_vm._l((_vm.menuList),function(item){return _c('el-option',{key:item.path,attrs:{"value":item.path,"label":item.name}},[_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(item.path))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right","color":"#8492a6","font-size":"13px"}},[_vm._v(_vm._s(item.name))])])}),1)])],1),_vm._v(" "),_c('div',{staticClass:"f topbar-account topbar-btn"},[_c('div',{directives:[{name:"has",rawName:"v-has",value:('home:home:sjkb'),expression:"'home:home:sjkb'"}],staticClass:"headerBOX data-board"},[_c('router-link',{staticClass:"f sise",attrs:{"to":"/datastatic"}},[_c('i',{staticClass:"icon_fn icon_fn1x1"}),_vm._v("\n            数据看板\n          ")])],1),_vm._v(" "),_c('div',{directives:[{name:"has",rawName:"v-has",value:('home:home:work'),expression:"'home:home:work'"}],staticClass:"headerBOX four-color"},[_c('router-link',{staticClass:"f sise",attrs:{"to":"/operationSupervision"}},[_c('i',{staticClass:"fa fa-wrench",staticStyle:{"font-size":"20px"}}),_vm._v("\n            作业一张图\n          ")])],1),_vm._v(" "),_c('div',{directives:[{name:"has",rawName:"v-has",value:('home:home:gass'),expression:"'home:home:gass'"}],staticClass:"headerBOX data-board"},[_c('router-link',{staticClass:"f fourfigure",attrs:{"to":"/gassAlarm"}},[_c('i',{staticClass:"fa fa-skyatlas"}),_vm._v("\n            气体监测一张图\n          ")])],1),_vm._v(" "),_c('div',{directives:[{name:"has",rawName:"v-has",value:('home:home:sst'),expression:"'home:home:sst'"}],staticClass:"headerBOX four-color"},[_c('router-link',{staticClass:"f sise",attrs:{"to":'/sisetu?enterpriseId='+_vm.enterpriseId}},[_c('i',{staticClass:"icon_fn icon_fn2x1"}),_vm._v("\n            四色图\n          ")])],1),_vm._v(" "),_c('router-link',{staticClass:"f messages",attrs:{"to":"/messageList"}},[_c('i',{staticClass:"el-icon-message-solid"}),_vm._v("\n          消息通知"),(_vm.messageCount>0)?_c('span',[_vm._v("("+_vm._s(_vm.messageCount)+")")]):_vm._e()]),_vm._v(" "),_c('exportFile',{ref:"exportFile"}),_vm._v(" "),_c('router-link',{staticClass:"f helper",attrs:{"to":"/static/企业安全生产管理平台操作手册.pdf","target":"_blank"}},[_c('i',{staticClass:"el-icon-s-management ",staticStyle:{"font-size":"23px"}}),_vm._v("\n          帮助手册\n        ")]),_vm._v(" "),_c('el-dropdown',{attrs:{"trigger":"click"}},[_c('span',{staticClass:"el-dropdown-link userinfo-inner"},[_c('i',{staticClass:"el-icon-user-solid"}),_vm._v("\n            "+_vm._s(_vm.nickname)+"\n            "),_c('i',{staticClass:"el-icon-arrow-down"})]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',[_c('div',{on:{"click":function($event){return _vm.toPage('/user/profile')}}},[_c('span',{staticStyle:{"color":"#555","font-size":"14px"}},[_vm._v("个人信息")])])]),_vm._v(" "),_c('el-dropdown-item',[_c('div',{on:{"click":function($event){return _vm.toPage('/user/changepwd')}}},[_c('span',{staticStyle:{"color":"#555","font-size":"14px"}},[_vm._v("修改密码")])])])],1)],1),_vm._v(" "),_c('a',{staticClass:"message2",attrs:{"title":"退出登录"},on:{"click":_vm.logout}},[_vm._v("\n          退出\n          "),_c('i',{staticClass:"icon_fn icon_fn4x1"})])],1)]),_vm._v(" "),_c('el-col',{staticClass:"main"},[_c('aside',{class:{ isCollapse: _vm.$store.state.isCollapse }},[_c('div',{staticClass:"menu-toggle",on:{"click":function($event){$event.preventDefault();return _vm.collapse($event)}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.$store.state.isCollapse),expression:"!$store.state.isCollapse"}],staticClass:"fa fa-bars"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.isCollapse),expression:"$store.state.isCollapse"}],staticClass:"fa fa-bars fa-rotate-90"})]),_vm._v(" "),_c('div',{staticClass:"navWrap"},[_c('el-menu',{attrs:{"default-active":_vm.activeRoute(_vm.$route.path),"unique-opened":"","router":"","collapse":_vm.$store.state.isCollapse},on:{"select":_vm.selectmenu}},[_vm._l((_vm.$store.state.menus),function(item,index){return (item.menuShow)?[(!item.leaf && item.children.length > 0)?_c('el-submenu',{key:index,attrs:{"index":index + ''}},[_c('template',{slot:"title"},[(item.parentId==0)?_c('i',{class:_vm.iconChange(item.iconCls)}):_vm._e(),_vm._v(" "),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(item.name))])]),_vm._v(" "),_c('menu-tree',{attrs:{"menuData":item.children}})],2):(item.children.length>0)?_c('el-menu-item',{staticStyle:{"color":"#204192"},attrs:{"index":item.path}},[_c('span',{staticStyle:{"color":"#204192"},attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(item.name))])]):_vm._e()]:_vm._e()})],2)],1)]),_vm._v(" "),_c('section',{staticClass:"content-container",class:{ iscop: _vm.$store.state.isCollapse }},[_c('div',{attrs:{"id":"page"}},[_c('layout-header'),_vm._v(" "),_c('el-main',{attrs:{"id":"elmain"}},[_c('div',{staticClass:"hp bg"},[_c('transition',{attrs:{"name":"main","mode":"out-in"}},[_c('router-view')],1)],1)])],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"org-tree-container"},[_c('div',{staticClass:"org-tree",class:{horizontal: _vm.horizontal, collapsable: _vm.collapsable}},[_c('org-tree-node',{attrs:{"data":_vm.data,"props":_vm.props,"horizontal":_vm.horizontal,"label-width":_vm.labelWidth,"collapsable":_vm.collapsable,"render-content":_vm.renderContent,"label-class-name":_vm.labelClassName},on:{"on-expand":function (e, data) {_vm.$emit('on-expand', e, data)},"on-node-click":function (e, data) {_vm.$emit('on-node-click', e, data)}}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1227:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"tabnavBox"},[_c('transition-group',{attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.$store.state.tabnavBox),function(item,index){return _c('li',{key:item.path,staticClass:"tabnav",class:{ active: _vm.$route.fullPath === item.path },on:{"contextmenu":function($event){$event.preventDefault();return _vm.openMenu(item,$event,index)}}},[_c('router-link',{attrs:{"to":item.path}},[_vm._v(_vm._s(item.title))]),_vm._v(" "),(index !== 0)?_c('i',{staticClass:"el-icon-error",on:{"click":function($event){return _vm.removeTab(item)}}}):_vm._e()],1)}),0)],1),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(this.rightMenuShow),expression:"this.rightMenuShow"}],staticClass:"menuBox",style:({left:this.left+'px',top:this.top+'px'})},[_c('li',{on:{"click":function($event){return _vm.removeTab(_vm.$store.state.rightNav)}}},[_vm._v("关闭当前页面")]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.removeOtherTab(_vm.$store.state.rightNav)}}},[_vm._v("关闭其他页面")]),_vm._v(" "),_c('li',{on:{"click":_vm.removeAllTab}},[_vm._v("关闭全部页面")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1276:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAANCAYAAACUwi84AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADESURBVChTXZAxCgIxFEQVwcLGygsIdvaCpdfwBB5CsPUCHkCs0pkiZBO3Em3sbL2B1TYWWhhnyEBYH3yyOzP//5DOP9baQYzxhkpVVe0kZ4wxPRhHmqgT/2VlQghbmt77O86h5AzMlTqfqLHkDHYt0PWB8cL3THIGwhRGg8AX51JyAYErDI7eS2pT1/Uc5pvFVZLbcLRWNLjsRHIbmBsUVz2ccyPJhZRSF90HhjDtjEfqyypQROjCEMNsklXgeK7J6+L6B4ghlh3LyeyZAAAAAElFTkSuQmCC"

/***/ }),

/***/ 1323:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icons2.fc7e77b.png";

/***/ }),

/***/ 199:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(26);



var bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

/***/ }),

/***/ 288:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1230);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    userInfo: null,
    loading: false,
    isCollapse: false,
    logoShow: false,
    uniquerouter: true,
    menus: [],
    rightNav: {},
    noMenuPages: [{
      path: '/dashboard',
      title: '首页'
    }, {
      path: '/user/profile',
      title: '个人信息'
    }, {
      path: '/user/changepwd',
      title: '修改密码'
    }, {
      path: '/safescore/scAudit',
      title: '记分审批'
    }, {
      path: '/safescore/scAuditFinal',
      title: '提级审批'
    }, {
      path: '/check/add',
      title: '新增隐患'
    }, {
      path: '/abar/abarbeitung',
      title: '隐患整改'
    }, {
      path: '/checkList/addFlow',
      title: '清单式排查'
    }, {
      path: '/review/review',
      title: '隐患复查'
    }, {
      path: '/review/reviewaudit',
      title: '隐患复查审核'
    }, {
      path: '/MajorHazard/MajorHazard',
      title: '重大隐患处理'
    }, {
      path: '/approvalList',
      title: '审批'
    }, {
      path: '/report/reportEdit',
      title: '隐患信息'
    }, {
      path: '/review/detail',
      title: '隐患详情'
    }, {
      path: '/knowledgeBase/lawList',
      title: '法律法规'
    }, {
      path: '/knowledgeBase/subList',
      title: '法律法规'
    }, {
      path: '/HotWork/preliminaryAudit',
      title: '初步审核'
    }, {
      path: '/HotWork/reportJobFire',
      title: '动火作业申请'
    }, {
      path: '/HotWork/OnSiteAudit',
      title: '现场审核'
    }, {
      path: '/HotWork/sign',
      title: '会签'
    }, {
      path: '/HotWork/workCertificate',
      title: '作业证打印'
    }, {
      path: '/HotWork/WhenHot',
      title: '动火作业'
    }, {
      path: '/HotWork/acceptance',
      title: '验收'
    }, {
      path: '/organization/user',
      title: '机构人员管理'
    }, {
      path: '/hidden/list',
      title: '隐患查询'
    }, {
      path: '/check/list',
      title: '隐患排查'
    }, {
      path: '/lgnitionTask/preliminaryAudit',
      title: '初步审核'
    }, {
      path: '/lgnitionTask/sign',
      title: '审批'
    }, {
      path: '/lgnitionTask/workCertificate',
      title: '作业证打印'
    }, {
      path: '/lgnitionTask/acceptance',
      title: '证件验收'
    }, {
      path: '/lgnitionTask/whenHot',
      title: '证件作业'
    }, {
      path: '/lgnitionTask/monitorCheck',
      title: '当班班长验票'
    }, {
      path: '/limitTask/limitAnalysisDataExamine',
      title: '有限空间数据分析'
    }, {
      path: '/limitTask/safetyMeasures',
      title: '有限空间安全措施'
    }, {
      path: '/lgnitionTask/listBase',
      title: '安全措施'
    }, {
      path: '/lgnitionTask/reportJobFire',
      title: '证件申请'
    }, {
      path: '/messageList',
      title: '消息通知'
    }, {
      path: '/sisetu',
      title: '四色图'
    }, {
      path: '/workConditionMap',
      title: '工况总览'
    }, {
      path: '/backlog',
      title: '首页待办'
    }, {
      path: '/lgnitionTask/file',
      title: '证件归档'
    }, {
      path: '/workSummary/list',
      title: '进行中的特殊作业'
    }, {
      path: '/training/trainingSituation',
      title: '教育培训'
    }, {
      path: '/EnterpriseFile/inspect',
      title: '设备点检记录'
    }, {
      path: '/EnterpriseFile/maintain',
      title: '设备保养记录'
    }, {
      path: '/trainingManagement/addProgram',
      title: '新增培训计划'
    }, {
      path: '/trainingManagement/addLatoja',
      title: '新增线下培训'
    }, {
      path: '/examination/addQuestion',
      title: '新增试题'
    }, {
      path: '/examination/addQuestion',
      title: '新增试题'
    }, {
      path: '/examination/addPaper',
      title: '新增试卷'
    }, {
      path: '/examination/issueExam',
      title: '新增试卷'
    }, {
      path: '/leftWok/workCertificate',
      title: '作业证打印'
    }, {
      path: '/lgnitionTask/safetyEducation',
      title: '安全教育人确认'
    }, {
      path: '/limitTask/preliminaryAudit',
      title: '初步审核'
    }, {
      path: '/limitTask/limitDeptExamine',
      title: '审批'
    }, {
      path: '/limitTask/workCertificate',
      title: '作业证打印'
    }, {
      path: '/limitTask/safetyEducation',
      title: '安全教育人确认'
    }, {
      path: '/limitTask/WorkAccept',
      title: '接受交底人确认'
    }, {
      path: '/limitTask/whenHot',
      title: '作业'
    },, {
      path: '/limitTask/acceptance',
      title: '验收'
    }, {
      path: '/blindTask/preliminaryAudit',
      title: '初步审核'
    }, {
      path: '/blindTask/blindDeptExamine',
      title: '会签'
    }, {
      path: '/blindTask/deptAudit',
      title: '审批'
    }, {
      path: '/blindTask/workCertificate',
      title: '作业证打印'
    }, {
      path: '/blindTask/safetyEducation',
      title: '安全教育人确认'
    }, {
      path: '/blindTask/whenHot',
      title: '作业'
    }, {
      path: '/blindTask/acceptance',
      title: '作业'
    }, {
      path: '/highTask/preliminaryAudit',
      title: '初步审核'
    }, {
      path: '/highTask/deptAudit',
      title: '审批'
    }, {
      path: '/highTask/workCertificate',
      title: '作业证打印'
    }, {
      path: '/highTask/safetyEducation',
      title: '安全教育人确认'
    }, {
      path: '/highTask/whenHot',
      title: '作业'
    }, {
      path: '/highTask/acceptance',
      title: '验收'
    }, {
      path: '/groundTask/preliminaryAudit',
      title: '初步审核'
    }, {
      path: '/groundTask/groundDeptExamine',
      title: '会签'
    }, {
      path: '/groundTask/deptAudit',
      title: '动土作业审批'
    }, {
      path: '/groundTask/workCertificate',
      title: '作业证打印'
    }, {
      path: '/groundTask/whenHot',
      title: '作业'
    }, {
      path: '/groundTask/safetyEducation',
      title: '安全教育人确认'
    }, {
      path: '/groundTask/acceptance',
      title: '验收'
    }, {
      path: '/roadBroken/whenHot',
      title: '证件作业'
    }, {
      path: '/leftWok/sign',
      title: '审批'
    }, {
      path: '/leftWok/safetyMeasures',
      title: '安全措施'
    }, {
      path: '/leftWok/safetyEducation',
      title: '安全教育人确认'
    }, {
      path: '/leftWok/WorkAccept',
      title: '接受交底人确认'
    }, {
      path: '/leftWok/assignment',
      title: '作业'
    }, {
      path: '/leftWok/acceptance',
      title: '验收'
    }, {
      path: '/roadBroken/reportJobRoad',
      title: '断路安全作业重新申请'
    }, {
      path: '/highTask/file',
      title: '证件归档'
    }, {
      path: '/highTask/blindDeptExamine',
      title: '会签'
    }, {
      path: '/highTask/safetyMeasures',
      title: '安全措施'
    }, {
      path: '/limitTask/file',
      title: '证件归档'
    }, {
      path: '/task/engineeringWork/file',
      title: '证件归档'
    }, {
      path: '/examination/course/addCourse',
      title: '新增课程'
    }, {
      path: '/trainingManagement/addTeacher',
      title: '新增培训师资'
    }, {
      path: '/trainingManagement/detailTeacher',
      title: '培训师资详情'
    }, {
      path: '/trainingManagement/updateTeacher',
      title: '编辑培训师资'
    }, {
      path: '/examination/course/addCourse',
      title: '新增培训课程'
    }, {
      path: '/trainingManagement/safetyTrainingProgramSave',
      title: '新增安全培训计划'
    }, {
      path: '/trainingManagement/safetyTrainingProgramEdit',
      title: '编辑安全培训计划'
    }, {
      path: '/safetyTrainingProgram/details',
      title: '安全培训计划详情'
    }, {
      path: '/safetyTrainingProgram/details/trainingObject',
      title: '培训对象'
    }, {
      path: '/trainingManagement/task/publishTask',
      title: '下发任务'
    }, {
      path: '/examination/examStatisticsDetail',
      title: '考试统计详情'
    }, {
      path: '/trainingManagement/updateLatoja',
      title: '编辑线下培训记录'
    }, {
      path: '/trainingManagement/detailLatoja',
      title: '线下培训记录详情'
    }, {
      path: '/examination/updateQuestion',
      title: '编辑题库'
    }, {
      path: '/examination/detailQuestion',
      title: '试题详情'
    }, {
      path: '/trainingManagement/trainingResourceAdd',
      title: '新增培训课件'
    }, {
      path: '/trainingManagement/trainingResourceUpdate',
      title: '编辑培训课件'
    }, {
      path: '/examination/course/detailCourse',
      title: '课程详情'
    }, {
      path: '/examination/course/updateCourse',
      title: '编辑课程'
    }, {
      path: '/blindTask/reportJobFire',
      title: '盲板抽堵作业重新申请'
    }, {
      path: '/highTask/reportJobFire',
      title: '高处安全作业重新申请'
    }, {
      path: '/groundTask/reportJobFire',
      title: '动土安全作业重新申请'
    }, {
      path: '/roadBroken/file',
      title: '证件归档'
    }, {
      path: '/groundTask/file',
      title: '证件归档'
    }, {
      path: '/tempEle/file',
      title: '证件归档'
    }, {
      path: '/leftWok/file',
      title: '证件归档'
    }, {
      path: '/leftWok/file',
      title: '证件归档'
    }, {
      path: '/blindTask/file',
      title: '证件归档'
    }, {
      path: '/leftWok/preliminaryAudit',
      title: '初步审核'
    }, {
      path: '/leftWok/reportJobFire',
      title: '吊装作业重新申请'
    }, {
      path: '/roadBroken/preliminaryAudit',
      title: '初步审核'
    }, {
      path: '/roadBroken/deptAudit',
      title: '审批'
    }, {
      path: '/roadBroken/workCertificate',
      title: '作业证打印'
    }, {
      path: '/roadBroken/safetyEducation',
      title: '安全教育人签字'
    }, {
      path: '/roadBroken/whenHot',
      title: '作业证作业'
    }, {
      path: '/roadBroken/acceptance',
      title: '作业证验收'
    }, {
      path: '/tempEle/reportJobFire',
      title: '临时用电作业重新申请'
    }, {
      path: '/tempEle/preliminaryAudit',
      title: '初步审核'
    }, {
      path: '/roadBroken/sign',
      title: '会签'
    }, {
      path: '/tempEle/sign',
      title: '会签'
    }, {
      path: '/tempEle/workCertificate',
      title: '作业证打印'
    }, {
      path: '/tempEle/safetyEducation',
      title: '安全教育人签字'
    }, {
      path: '/tempEle/whenHot',
      title: '作业证作业'
    }, {
      path: '/tempEle/acceptance',
      title: '作业证验收'
    }, {
      path: '/limitTask/reportJobFire',
      title: '受限空间安全作业重新申请'
    }, {
      path: '/tempEle/deptAudit',
      title: '审批'
    }, {
      path: '/fourColorMap',
      title: '编辑四色图'
    }, {
      path: '/picture/hiddenAudit',
      title: '随手拍审核'
    }, {
      path: '/archives/osof/dir',
      title: '档案目录'
    }, {
      path: '/checkSelf',
      title: '自检自查'
    }, {
      path: '/hiddenAudit/detail',
      title: '隐患审核'
    }, {
      path: '/lgnitionTask/analysisData',
      title: '分析数据'
    }, {
      path: '/lgnitionTask/safetyMeasures',
      title: '安全措施'
    }, {
      path: '/protectTask/preliminaryAudit',
      title: '劳保申请初审'
    }, {
      path: '/protectTask/protectDeptExamine',
      title: '劳保申请审批'
    }, {
      path: '/protectTask/warehouseConfirmation',
      title: '劳保发放'
    }, {
      path: '/protectTask/receiveConfirm',
      title: '劳保领用'
    }, {
      path: '/auditTask/file',
      title: '危险作业审批表'
    }, {
      path: "/tempEle/analysisData",
      title: "临时用电数据分析"
    }, {
      path: '/auditTask/hazardFile',
      title: '风险告知卡'
    }, {
      path: '/preShiftMeeting/meetingRecord',
      title: '班前会记录表'
    }, {
      path: '/lgnitionTask/WorkAccept',
      title: '动火接受交底人确认'
    }, {
      path: '/highTask/WorkAccept',
      title: '高处作业接受交底人确认'
    }, {
      path: '/workCertificatePreview_healthPromiseFile',
      title: '健康承诺书预览'
    }, {
      path: '/task/gasWork/file',
      title: '煤气作业申请表预览'
    }, {
      path: '/task/gasOperateRecord/file',
      title: '煤气操作表预览'
    }, {
      path: '/riskPatrolTaskList',
      title: '巡查任务清单'
    }],
    tabnavBox: [{
      title: '首页',
      path: '/dashboard'
    }]
  },
  mutations: {
    addTab: function addTab(state, arg) {
      for (var i = 0; i < state.tabnavBox.length; i++) {
        if (state.tabnavBox[i].path === arg.path) {
          return false;
        }
      }
      state.tabnavBox.push({
        title: arg.title,
        path: arg.path
      });
    },
    openMenu: function openMenu(state, arg) {
      state.rightNav = arg;
    },
    removeTab: function removeTab(state, arg) {
      var index = state.tabnavBox.findIndex(function (value, key) {
        return value.path === arg.tabItem.path;
      });
      state.tabnavBox.splice(index, 1);
      if (arg.tabItem.path === arg.fullPath) {
        var tabActive = state.tabnavBox[index] || state.tabnavBox[index - 1];
        arg.router.push(tabActive.path);
      }
    },
    removeOtherTab: function removeOtherTab(state, arg) {
      state.tabnavBox = [{
        title: '首页',
        path: '/dashboard'
      }];
      if (arg.all) {
        arg.router.push('/dashboard');
        return false;
      }
      state.tabnavBox.push(arg.tabItem);
      arg.router.push(arg.tabItem.path);
    },
    collapse: function collapse(state, arg) {
      state.isCollapse = !state.isCollapse;
      if (state.logoShow) {
        setTimeout(function () {
          state.logoShow = false;
        }, 300);
      } else {
        state.logoShow = true;
      }
    }
  },
  actions: {
    addTab: function addTab(_ref, arg) {
      var commit = _ref.commit;

      commit('addTab', arg);
    },
    openMenu: function openMenu(_ref2, arg) {
      var commit = _ref2.commit;

      commit('openMenu', arg);
    },
    removeTab: function removeTab(_ref3, arg) {
      var commit = _ref3.commit;

      commit('removeTab', arg);
    },
    removeOtherTab: function removeOtherTab(_ref4, arg) {
      var commit = _ref4.commit;

      commit('removeOtherTab', arg);
    },
    collapse: function collapse(_ref5, arg) {
      var commit = _ref5.commit;

      commit('collapse', arg);
    }
  }
}));

/***/ }),

/***/ 289:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_constant__ = __webpack_require__(51);




/* harmony default export */ __webpack_exports__["a"] = ({
  login: function login(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["b" /* POST */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/oauth/token', params);
  },

  logout: function logout(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/logout', params);
  },
  tokenUser: function tokenUser(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/user/currentUser', params);
  },

  changeProfile: function changeProfile(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["d" /* PATCH */]('/api/v1/users/profile', params);
  },

  findList: function findList(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/user', params);
  },

  listUserByParams: function listUserByParams(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/user/listUserByParams', params);
  },

  listAllUserByParams: function listAllUserByParams(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/user/listAllUserByParams', params);
  },

  getByDeptOrEnt: function getByDeptOrEnt(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/user/getByDeptOrEnt', params);
  },

  listNormalUser: function listNormalUser(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/user/listNormalUser', params);
  },

  listUserToChart: function listUserToChart(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/user/getUserListToChart', params);
  },

  addUser: function addUser(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["b" /* POST */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/user', params);
  },

  editUser: function editUser(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["e" /* PUT */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/user', params);
  },

  removeUser: function removeUser(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["c" /* DELETE */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/user', params);
  },

  router: function router(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/router', params);
  },

  exits: function exits(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/user/exits', params);
  },

  resetPwd: function resetPwd(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/user/resetPwd', params);
  },

  listNopagging: function listNopagging(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/user/listNopagging', params);
  },

  listByDeptIds: function listByDeptIds(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/user/listByDeptIds', params);
  },

  listOfSelfEnt: function listOfSelfEnt(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/user/listOfSelfEnt', params);
  },
  updatePwd: function updatePwd(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/user/updatePwd', params);
  },
  getUser: function getUser(id) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/user/getUser/' + id);
  },
  updateUser: function updateUser(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["b" /* POST */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/user/updateUser', params);
  },
  newUpdateUser: function newUpdateUser(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["b" /* POST */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/user/newUpdateUser', params);
  },

  getPagedByDeptOrEnt: function getPagedByDeptOrEnt(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/user/getPagedByDeptOrEnt', params);
  },

  getByDept: function getByDept(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/user/getByDept', params);
  },

  selectUserList: function selectUserList(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/user/selectUserList', params);
  },
  addRoleUsers: function addRoleUsers(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/user/addRoleUsers', params);
  },

  saveUserRole: function saveUserRole(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["b" /* POST */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/user/saveUserRole', params);
  },

  removeUserRoleById: function removeUserRoleById(id) {
    return __WEBPACK_IMPORTED_MODULE_0____["b" /* POST */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/user/removeUserRoleById?id=' + id);
  },

  selectIsShowAnnouncement: function selectIsShowAnnouncement(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/announcement/selectIsShowAnnouncement', params);
  },

  getIsLeader: function getIsLeader(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/dept/getIsLeader', params);
  },

  getUserByToken: function getUserByToken(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/user/getUserByToken');
  },

  getChildEntInnerUser: function getChildEntInnerUser(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/user/getChildEntInnerUser', params);
  },
  getUserListJtAndChild: function getUserListJtAndChild(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/user/getUserListJtAndChild', params);
  },

  getSpecialOperateUserByDeptId: function getSpecialOperateUserByDeptId(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/user/getSpecialOperateUserByDeptId', params);
  },
  userEnterpriseByUserName: function userEnterpriseByUserName(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/user/userEnterpriseByUserName', params);
  },
  removeLockUser: function removeLockUser(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/user/removeLockUser', params);
  },
  getUsulList: function getUsulList(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/user/getUsulList');
  },
  putUsulList: function putUsulList(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["b" /* POST */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/user/putUsulList', params);
  },
  getOpenId: function getOpenId(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["b" /* POST */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/user/getOpenId', params);
  },

  oaLogin: function oaLogin(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/oa/autoLogin', params);
  },
  getVeriCode: function getVeriCode(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/user/getVeriCode', params);
  },
  submitVeriCode: function submitVeriCode(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["b" /* POST */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/user/submitVeriCode', params);
  }
});

/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_deptedittree_vue__ = __webpack_require__(308);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29b41566_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_deptedittree_vue__ = __webpack_require__(1222);
function injectStyle (ssrContext) {
  __webpack_require__(1196)
}
var normalizeComponent = __webpack_require__(72)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-29b41566"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_deptedittree_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29b41566_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_deptedittree_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node__ = __webpack_require__(669);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Vue2OrgTree',
  components: {
    OrgTreeNode: {
      render: __WEBPACK_IMPORTED_MODULE_0__node__["a" /* default */],
      functional: true
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    props: {
      type: Object,
      default: function _default() {
        return {
          label: 'label',
          expand: 'expand',
          children: 'children'
        };
      }
    },
    horizontal: Boolean,
    selectedKey: String,
    collapsable: Boolean,
    renderContent: Function,
    labelWidth: [String, Number],
    labelClassName: [Function, String],
    selectedClassName: [Function, String]
  }
});

/***/ }),

/***/ 304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ 305:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_constant__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bus_js__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_api_user__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_menuTree__ = __webpack_require__(1216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_common_tabNav__ = __webpack_require__(1217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_api_version__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_api_user_js__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_security_target_api_meeting_message__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_api_enterprisebase__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_api_att__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_trainingManagement_component_exportFile_exportFile__ = __webpack_require__(1219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_js_activeRoute_js__ = __webpack_require__(665);















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  components: {
    layoutHeader: __WEBPACK_IMPORTED_MODULE_5__components_common_tabNav__["a" /* default */],
    menuTree: __WEBPACK_IMPORTED_MODULE_4__components_common_menuTree__["a" /* default */],
    exportFile: __WEBPACK_IMPORTED_MODULE_11__pages_trainingManagement_component_exportFile_exportFile__["a" /* default */]
  },
  created: function created() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_2__bus_js__["a" /* bus */].$on('setNickName', function (text) {
      _this2.nickname = text;
    });

    __WEBPACK_IMPORTED_MODULE_2__bus_js__["a" /* bus */].$on('goto', function (url) {
      if (url === '/login') {
        localStorage.removeItem('access-user');
        localStorage.removeItem('userinfo');
      }
      _this2.$router.push(url);
    });
    __WEBPACK_IMPORTED_MODULE_2__bus_js__["a" /* bus */].$on('refreshmsgcount', function () {
      _this2.getMessages();
    });
  },
  data: function data() {
    return {
      nickname: '',
      version: '',
      messageCount: 0,
      entName: '',
      logo: '',
      istangshan: true,
      sonCompanyList: [],
      parentToken: null,
      enterpriseId: JSON.parse(localStorage.getItem('userinfo')).enterpriseId,
      menuList: [],
      selectUrl: ''
    };
  },

  watch: {
    '$route.path': function $routePath(val) {
      this.selectmenu(this.$route.fullPath);
    }
  },
  methods: {
    activeRoute: function activeRoute(path) {
      return __WEBPACK_IMPORTED_MODULE_12__assets_js_activeRoute_js__["a" /* default */][path] ? __WEBPACK_IMPORTED_MODULE_12__assets_js_activeRoute_js__["a" /* default */][path] : path;
    },

    tangshan: function tangshan() {
      var userinfoStr = localStorage.getItem('userinfo');
      var userinfo = JSON.parse(userinfoStr);
      if (userinfo.enterpriseId === 122) {
        this.istangshan = false;
      }
    },
    toPage: function toPage(url) {
      this.$router.push(url);
    },
    iconChange: function iconChange(iconname) {
      switch (iconname) {
        case 'fa fa-pencil-square-o':
          iconname = 'icon_nav icon_nav1x1';

          break;
        case 'el-icon-message-solid':
          iconname = 'icon_nav icon_nav2x1';
          break;

        case 'fa fa-sitemap':
          iconname = 'icon_nav icon_nav3x1';
          break;

        case 'fa fa-universal-access':
          iconname = 'icon_nav icon_nav4x1';
          break;
        case 'fa fa-address-book':
          iconname = 'icon_nav icon_nav5x1';
          break;
        case 'fa fa-bolt':
          iconname = 'icon_nav icon_nav6x1';
          break;
        case 'fa fa-exclamation-triangle':
          iconname = 'icon_nav icon_nav7x1';
          break;
        case 'el-icon-warning':
          iconname = 'icon_nav icon_nav8x1';

          break;
        case 'fa fa-folder-o':
          iconname = 'icon_nav icon_nav9x1';
          break;
        case 'fa fa-users':
          iconname = 'icon_nav icon_nav10x1';
          break;
        case 'fa fa-fire-extinguisher':
          iconname = 'icon_nav icon_nav11x1';
          break;
        case 'el-icon-s-release':
          iconname = 'icon_nav icon_nav12x1';
          break;
        case 'fa fa-user-o':
          iconname = 'icon_nav icon_nav13x1';
          break;
      }
      return iconname;
    },
    selectmenu: function selectmenu(key) {
      var router = this.$store.state.menus;
      var name = false;
      var _this = this;

      var navTitle2 = function navTitle2(fullPath) {
        var path = '';
        if (fullPath.indexOf('?') != -1) {
          path = fullPath.slice(0, fullPath.indexOf('?'));
        } else {
          path = fullPath;
        }
        _this.$store.state.tabnavBox.forEach(function (item) {
          if (item.path.indexOf('?') != -1 && item.path.slice(0, fullPath.indexOf('?')) === path && item.path !== fullPath) {
            item.path = fullPath;
            name = item.title;
          } else {
            var p = _this.$store.state.noMenuPages.filter(function (v) {
              return v.path === path;
            });
            if (p && p.length > 0) name = p[0].title;
          }
        });
        return name;
      };

      var navTitle = function navTitle(path, routerARR) {
        for (var i = 0; i < routerARR.length; i++) {
          if (routerARR[i].children.length > 0 || routerARR[i].path === path) {
            if (routerARR[i].path === path) {
              name = routerARR[i].name;
              break;
            }
            navTitle(path, routerARR[i].children);
          }
        }
        return name;
      };

      if (!key.startsWith('http')) {
        _this.$store.dispatch('addTab', {
          title: navTitle(key, router) || navTitle2(key),
          path: key
        });
      }
    },
    collapse: function collapse() {
      this.$store.dispatch('collapse');
    },
    logout: function logout() {
      var that = this;
      this.$confirm('确认退出吗?', '提示', {
        confirmButtonClass: 'el-button--warning'
      }).then(function () {
        that.loading = true;
        var token = localStorage.getItem('access-token');
        localStorage.removeItem('access-token');
        localStorage.removeItem('menus');
        localStorage.removeItem('removeOperation');
        localStorage.removeItem("parentToken");
        localStorage.removeItem("userinfo");
        __WEBPACK_IMPORTED_MODULE_3__api_api_user__["a" /* default */].logout({
          token: token
        }).then(function (res) {});
        that.$router.go();
      }).catch(function () {});
    },
    beforeunloadFn: function beforeunloadFn(e) {
      console.log('浏览器刷新了');
      return false;
    },
    getVersion: function getVersion() {
      var than = this;
      __WEBPACK_IMPORTED_MODULE_6__api_api_version__["a" /* default */].newestData().then(function (res) {
        if (res && res.ve) {
          than.version = res.ve.version;
        }
      });
    },
    getMessages: function getMessages() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_8__api_security_target_api_meeting_message__["a" /* default */].notReadNumber().then(function (res) {
        if (res) {
          _this3.messageCount = res.count;
        }
      });
    },
    getEntName: function getEntName() {
      var than = this;
      __WEBPACK_IMPORTED_MODULE_9__api_api_enterprisebase__["a" /* default */].findEntById(JSON.parse(localStorage.getItem('userinfo')).enterpriseId).then(function (res) {
        if (res && res.code == 0) {
          than.entName = res.ent.companyName;
          __WEBPACK_IMPORTED_MODULE_10__api_api_att__["a" /* default */].getAttByIds({
            ids: res.ent.logo
          }).then(function (res) {
            if (res.code == 0 && res.list && res.list.length > 0) {
              res.list.forEach(function (o, i) {
                var file = {
                  id: o.id,
                  name: o.name,

                  url: "/apis" + '/api-base' + o.url
                };
                than.logo = file.url;
              });
            }
          });
          localStorage.setItem("enterpriseName", res.ent.companyName);
          var u = JSON.parse(localStorage.getItem("userinfo"));
          if (u.parentEnterpriseId == null || u.parentEnterpriseId == 0) {
            $('#div_jituankanban').show();
          } else {
            $('#div_jituankanban').hide();
          }
        }
      });
    },
    iniDataBoard: function iniDataBoard() {
      var pcid = window.localStorage.getItem('parent-company-id');
      if (pcid == 0) {
        $('#div_jituankanban').show();
      } else {
        $('#div_jituankanban').hide();
      }
    },
    getSonCompany: function getSonCompany() {
      var that = this;
      that.sonCompanyList = [];
      __WEBPACK_IMPORTED_MODULE_3__api_api_user__["a" /* default */].getChildEntInnerUser({}).then(function (result) {
        if (result.data && result.data.length > 0) {
          that.sonCompanyList = result.data;
        }
      });
    },
    handleCommand: function handleCommand(item) {
      localStorage.setItem("parentToken", localStorage.getItem("access-token"));
      localStorage.setItem("parentperms", localStorage.getItem('perms'));
      this.handleLogin(item.loginName, item.loginPass);
    },
    getQueryString: function getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(decodeURI(r[2]));
      return null;
    },
    getParentToken: function getParentToken() {
      if (localStorage.getItem("parentToken")) {
        this.parentToken = localStorage.getItem("parentToken");
      }
    },
    getUserByToken: function getUserByToken(func) {
      var that = this;
      __WEBPACK_IMPORTED_MODULE_3__api_api_user__["a" /* default */].getUserByToken().then(function (result) {
        console.log("result::::", result);
        func(result);
      }).catch(function () {});
    },
    returnparent: function returnparent() {
      var than = this;
      localStorage.setItem("access-token", localStorage.getItem("parentToken"));
      localStorage.setItem("perms", localStorage.getItem("parentperms"));
      localStorage.removeItem("parentToken");
      localStorage.removeItem("parentperms");
      than.getUserByToken(function (result) {
        localStorage.setItem('userinfo', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result));
        localStorage.setItem('parent-company-id', result.parentEnterpriseId);
        localStorage.setItem('oldVersion', result.version);
        window.location.href = "/dashboard";
      });
    },
    handleLogin: function handleLogin(username, password) {
      var that = this;
      this.loading = true;
      var loginParams = new FormData();
      loginParams.append('client_id', 'app');
      loginParams.append('client_secret', '123456');
      loginParams.append('grant_type', 'password');
      loginParams.append('username', username);
      loginParams.append('password', password);
      loginParams.append('type', 'pc-app');
      loginParams.append('partner', 'zhantong');
      __WEBPACK_IMPORTED_MODULE_3__api_api_user__["a" /* default */].login(loginParams).then(function (result) {
        that.loading = false;
        if (result) {
          var userInfo = JSON.parse(result.userinfo);
          localStorage.setItem('access-token', 'Bearer ' + result.access_token);
          localStorage.setItem('userinfo', result.userinfo);
          localStorage.setItem('oldVersion', userInfo.version);
          localStorage.setItem('parent-company-id', userInfo.parentEnterpriseId);
          __WEBPACK_IMPORTED_MODULE_7__api_api_user_js__["a" /* default */].tokenUser().then(function (resulttokenUser) {
            localStorage.setItem('perms', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(resulttokenUser.perms));
            window.location.href = "/dashboard";
          });
        } else {
          that.$message.error({
            showClose: true,
            message: result.msg || '登录失败',
            duration: 2000
          });
        }
      }, function (err) {
        that.loading = false;
      });
    },
    extractPaths: function extractPaths(routes) {
      var _this4 = this;

      var menuList = [];
      routes.forEach(function (route) {
        if (route.path && route.path.trim() !== "") {
          menuList.push({
            path: route.path,
            name: route.name });
        }

        if (route.children && Array.isArray(route.children)) {
          menuList = menuList.concat(_this4.extractPaths(route.children));
        }
      });
      return menuList;
    }
  },
  mounted: function mounted() {
    debugger;
    var that = this;
    that.$store.state.menus = [];
    localStorage.removeItem('removeOperation');
    __WEBPACK_IMPORTED_MODULE_3__api_api_user__["a" /* default */].router().then(function (result) {
      var userInfo = JSON.parse(localStorage.getItem('userinfo'));
      if (userInfo.roleIds) {
        var role = userInfo.roleIds.find(function (c) {
          return c == __WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].SystemInitRole.EnterpriseAdmin || c == __WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].SystemInitRole.SubEnterpriseAdmin;
        });
        if (role != null && role != undefined) {
          result.router.forEach(function (c) {
            if (c.name == '权限管理') {
              that.$store.state.menus.push(c);
            }
            if (c.name == '企业管理') {
              var modifyC = c;
              var data = c.children.filter(function (child) {
                return child.id == 160 || child.id == 95;
              });
              modifyC.children = data;
              that.$store.state.menus.push(modifyC);
            }
          });
        } else {
          that.$store.state.menus = result.router;

          that.menuList = that.extractPaths(result.router);
        }
      } else {
        that.$store.state.menus = result.router;
      }

      that.$router.push(that.$route.fullPath);
      that.selectmenu(that.$route.fullPath);
    });
    __WEBPACK_IMPORTED_MODULE_3__api_api_user__["a" /* default */].tokenUser().then(function (result) {
      that.nickname = result.username;

      localStorage.setItem('perms', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result.perms));
    }).catch(function () {
      localStorage.removeItem('access-token');
      localStorage.removeItem("userinfo");
      that.$router.go('/login');
    });
    that.getVersion();

    that.getMessages();
    that.iniDataBoard();
    that.getEntName();
    that.getSonCompany();
    that.getParentToken();
  },
  destroyed: function destroyed() {}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(196)))

/***/ }),

/***/ 306:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'menuTree',
  props: ['menuData']
});

/***/ }),

/***/ 307:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tabNav',
  data: function data() {
    return {
      rightMenuShow: false,
      left: 0,
      top: 0
    };
  },

  methods: {
    openMenu: function openMenu(item, e, index) {
      if (index === 0) {
        return false;
      }
      var l = this.$store.state.isCollapse ? 60 : 200;
      this.rightMenuShow = true;
      this.left = e.clientX - l;
      this.top = e.clientY - 55;
      this.$store.dispatch('openMenu', item);
    },
    removeTab: function removeTab(tabItem) {
      this.$store.dispatch('removeTab', { tabItem: tabItem, fullPath: this.$route.fullPath, router: this.$router });
    },
    removeOtherTab: function removeOtherTab(tabItem) {
      this.$store.dispatch('removeOtherTab', { tabItem: tabItem, router: this.$router });
    },
    removeAllTab: function removeAllTab() {
      this.$store.dispatch('removeOtherTab', { all: true, router: this.$router });
    }
  },
  watch: {
    rightMenuShow: function rightMenuShow(value) {
      var _this = this;

      if (value) {
        document.body.addEventListener('click', function () {
          _this.rightMenuShow = false;
        });
      } else {
        document.body.removeEventListener('click', function () {
          _this.rightMenuShow = false;
        });
      }
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ 308:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_api_dept__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pinyin_match__ = __webpack_require__(195);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "el-tree-select",
  props: {
    props: {
      type: Object,
      default: function _default() {
        return {
          value: 'id',
          label: 'text',
          children: 'children' };
      }

    },

    options: {
      type: Array,
      require: false,
      default: function _default() {
        return null;
      }
    },

    value: {
      default: function _default() {
        return null;
      }
    },

    clearable: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },

    disabled: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },

    accordion: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },

    placeholder: {
      type: String,
      default: function _default() {
        return '请选择';
      }
    },
    showAll: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },

    enableSelectEnt: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      valueId: this.value,
      valueTitle: '',
      defaultExpandedKey: [],

      treeData: [],
      isFirstCallClick: true,
      deptTree: []
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    console.log("this.options::::", this.options);
    if (this.options == null) {
      console.log("this.this.showAll::::", this.showAll);
      __WEBPACK_IMPORTED_MODULE_0__api_api_dept__["a" /* default */].dropDownTree({ includeEnt: true, showAll: this.showAll, enable: 1 }).then(function (result) {
        if (result && result.length > 0) {
          _this2.deptTree = result;
          _this2.initHandle(true);
          _this2.$emit('loadAfter', _this2.deptTree);
          console.log(" this.deptTree::::", _this2.deptTree);
        }
      });
    } else {
      this.deptTree = this.options;
      this.initHandle(true);
    }
  },

  methods: {
    initHandle: function initHandle(componentInit) {
      var _this3 = this;

      this.$nextTick(function () {
        var data = {};
        _this3.valueTitle = "";
        if (_this3.deptTree.length > 0 && _this3.valueId) {
          var node = _this3.$refs.selectTree.getNode(_this3.valueId);
          data = {};
          data[_this3.props.label] = '';
          data[_this3.props.value] = '';
          if (node) {
            data = node.data;
          }
          _this3.valueTitle = data[_this3.props.label];
          _this3.$refs.selectTree.setCurrentKey(_this3.valueId);
          _this3.defaultExpandedKey = [_this3.valueId];
          _this3.handleNodeClick(data, componentInit);
        }


        var scrollWrap = document.querySelectorAll('.el-scrollbar .el-select-dropdown__wrap')[0];
        var scrollBar = document.querySelectorAll('.el-scrollbar .el-scrollbar__bar');
        scrollWrap.style.cssText = 'margin: 0px; max-height: none; overflow: hidden;';
        scrollBar.forEach(function (ele) {
          return ele.style.width = 0;
        });
      });
    },
    handleNodeClick: function handleNodeClick(node, componentInit) {
      console.log("node:::", node);
      if (!this.enableSelectEnt && node.object.isEnterprise == 1) {
        this.$message.error({
          showClose: true,
          message: "请选择部门",
          duration: 2000
        });
        return;
      }
      this.valueTitle = node[this.props.label];
      this.valueId = node[this.props.value];
      var value = { id: this.valueId,
        text: this.valueTitle };
      if (node["object"]) {
        value.organizationType = node.object.isEnterprise == 1 ? "E" : "D";
      }
      if (node["parentId"]) {
        value.parentId = node["parentId"];
      }
      value.object = node["object"];
      this.$emit('getValue', value, componentInit);
      this.defaultExpandedKey = [];
      var _this = this;
      setTimeout(function () {
        _this.$refs.selectRef.blur();
      }, 50);
    },
    clearHandle: function clearHandle() {
      this.valueTitle = '';
      this.valueId = null;
      this.defaultExpandedKey = [];
      this.clearSelected();
      this.$emit('getValue', { id: '', object: {}, text: '' });
    },
    clearSelected: function clearSelected() {
      var allNode = document.querySelectorAll('#tree-option .el-tree-node');
      allNode.forEach(function (element) {
        return element.classList.remove('is-current');
      });
      if (this.treeData && this.treeData.length > 0) {
        this.deptTree = this.treeData.slice();
      }
    },
    treeFilter: function treeFilter(query, data) {
      var _this4 = this;

      if (!query) {
        return true;
      } else {
        var labelArray = query.split(',');
        return labelArray.some(function (value) {
          return value && __WEBPACK_IMPORTED_MODULE_1_pinyin_match__["a" /* default */].match(data[_this4.props.label], value);
        });
      }
    },
    reLoadTree: function reLoadTree() {
      this.selectFilter("");
    },
    selectFilter: function selectFilter(label) {
      console.log(" this.options::::", this.deptTree);
      console.log(this.deptTree.slice());
      this.treeData = this.deptTree.slice();
      this.$refs.selectTree.filter(label);
      return true;
    }
  },
  watch: {
    value: function value(newVal, oldVal) {
      if (newVal == oldVal) {
        return;
      }
      if (!newVal) {
        this.clearHandle();
        return;
      }
      this.valueId = newVal;
      this.initHandle(false);
    },
    options: function options() {
      this.deptTree = this.options;;
      this.initHandle(false);
    }
  }
});

/***/ }),

/***/ 309:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "emptyContainer",
  props: {
    width: {
      type: Number,
      default: function _default() {
        return 100;
      }
    },
    height: {
      type: Number,
      default: function _default() {
        return 100;
      }
    },
    text: {
      type: String,
      default: function _default() {
        return '暂无数据';
      }
    }
  }
});

/***/ }),

/***/ 310:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_training_api_export__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_trainingManagement_component_exportFile_exportFileConstant__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bus__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_emptyContainer__ = __webpack_require__(1218);









/* harmony default export */ __webpack_exports__["a"] = ({
  name: "exportFile",
  components: { emptyContainer: __WEBPACK_IMPORTED_MODULE_5__components_emptyContainer__["a" /* default */] },
  data: function data() {
    return {
      tasks: [],
      id: 1,
      isHidden: false,
      refreshAsyncTasksStatusInterval: undefined,
      exportFileConstant: __WEBPACK_IMPORTED_MODULE_3__pages_trainingManagement_component_exportFile_exportFileConstant__["a" /* default */]
    };
  },

  directives: {
    drag: function drag(el) {
      el.onmousedown = function (e) {
        var disx = e.pageX - el.offsetLeft;
        var disy = e.pageY - el.offsetTop;
        document.onmousemove = function (e) {
          el.style.left = e.pageX - disx + 'px';
          el.style.top = e.pageY - disy + 'px';
        };
        document.onmouseup = function () {
          document.onmousemove = document.onmouseup = null;
        };
      };
    }
  },
  methods: {
    putAsyncTask: function putAsyncTask(param) {
      this.asyncTaskRequest([param]);
    },
    putAsyncTasks: function putAsyncTasks(params) {
      this.asyncTaskRequest(params);
    },
    asyncTaskRequest: function asyncTaskRequest(files) {
      var _this = this;

      var param = {
        files: files
      };
      __WEBPACK_IMPORTED_MODULE_2__api_training_api_export__["a" /* default */].async(param).then(function (res) {
        var _tasks;

        if (!_this.tasks) {
          _this.tasks = [];
        }
        var files = res.data.files;
        (_tasks = _this.tasks).push.apply(_tasks, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(files));
        console.log('then tasks length---- %o', _this.tasks.length);
        _this.runRefreshAsyncTasksStatusInterval();

        __WEBPACK_IMPORTED_MODULE_4__bus__["a" /* bus */].$emit('putAsyncTasksSucess');

        _this.isHidden = true;
      }).catch(function (error) {
        console.log('error msg %o', error);
        _this.$message.error({
          showClose: true,
          message: error.response.data.message,
          duration: 2000
        });
        __WEBPACK_IMPORTED_MODULE_4__bus__["a" /* bus */].$emit('putAsyncTasksError', error.response.data.message);
      });
    },
    closeAll: function closeAll() {
      this.closeRefreshAsyncTasksStatusInterval();
      this.tasks = [];
    },
    shrink: function shrink() {
      this.isHidden = !this.isHidden;
    },
    refreshAsyncTasksStatus: function refreshAsyncTasksStatus() {
      var _this2 = this;

      var processingTasks = this.tasks.map(function (obj, index) {
        var mapItemObj = obj;
        mapItemObj.index = index;
        return [obj.taskId, mapItemObj];
      }).filter(function (obj) {
        return __WEBPACK_IMPORTED_MODULE_3__pages_trainingManagement_component_exportFile_exportFileConstant__["a" /* default */].taskStatus.processing == obj[1].taskState;
      });
      if (processingTasks && processingTasks.length > 0) {
        var processingTasksMap = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a(processingTasks);
        var param = {
          taskIds: processingTasks.map(function (obj) {
            return obj[1].taskId;
          })
        };
        __WEBPACK_IMPORTED_MODULE_2__api_training_api_export__["a" /* default */].asyncStatus(param).then(function (res) {
          if (res.data.files && res.data.files.length > 0) {
            res.data.files.forEach(function (obj) {
              var task = processingTasksMap.get(obj.taskId);
              if (task.taskState != obj.taskState) {
                _this2.$set(_this2.tasks, task.index, obj);
              }
            });
          }
        }).catch(function (error) {
          console.log('error msg %o', error);
          _this2.$message.error({
            showClose: true,
            message: error.message,
            duration: 2000
          });
        });
      }
    },
    runRefreshAsyncTasksStatusInterval: function runRefreshAsyncTasksStatusInterval() {
      var _this3 = this;

      if (this.refreshAsyncTasksStatusInterval) {
        return;
      }
      this.refreshAsyncTasksStatusInterval = window.setInterval(function () {
        _this3.refreshAsyncTasksStatus();
      }, 1 * 1000);
    },
    closeRefreshAsyncTasksStatusInterval: function closeRefreshAsyncTasksStatusInterval() {
      window.clearInterval(this.refreshAsyncTasksStatusInterval);
      this.refreshAsyncTasksStatusInterval = undefined;
    }
  },
  created: function created() {
    var _this4 = this;

    __WEBPACK_IMPORTED_MODULE_4__bus__["a" /* bus */].$on('putAsyncTask', function (param) {
      _this4.putAsyncTask(param);
    });
    __WEBPACK_IMPORTED_MODULE_4__bus__["a" /* bus */].$on('putAsyncTasks', function (param) {
      _this4.putAsyncTasks(param);
    });

    document.addEventListener("click", function (e) {
      var box = document.getElementById("exportFilePopover");
      var showExportBtn = document.getElementById("showExportBtn");
      if (box != null && box != undefined && showExportBtn != null && showExportBtn != undefined) {
        if (!box.contains(e.target) && !showExportBtn.contains(e.target)) {
          _this4.isHidden = false;
        }
      }
    });
  },
  mounted: function mounted() {},

  computed: {
    existTask: function existTask() {
      return this.tasks && this.tasks.length > 0;
    }
  }
});

/***/ }),

/***/ 51:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  apiServer: {
    Admin: "/api-admin",
    Base: "/api-base",
    CMS: "/api-cms",
    Activiti: "/api-activiti",
    Zuul: "/zuul",
    Tranning: "/clouddo-tranning" },

  dictionary: {
    DANGEROUS_OPERATION_TYPE: "DANGEROUS_OPERATION_TYPE",
    STANDARD_LEVEL: "STANDARD_LEVEL",
    ENTERPRISE_CATEGORY: "ENTERPRISE_CATEGORY",
    OPERATION_FORM: "OPERATION_FORM",
    TRAINING_LEVEL: "training_task_type",
    TRAINING_INDUSTRY: "0005",
    TRAINING_POST: "training_post",
    TRAINING_TYPE: "training_type"
  },

  type_dictionary: {
    OPERATING_PROCEDURES: '92793b134d4f442b9b1e0782917e395a'
  },

  HotWork: {
    LGNITION_TASK: 'LgnitionTask',
    SIGN_IMG: 'signImg',
    SCENE_IMG: "sceneImg",
    PRELIMINARY_IMG: "preliminaryImg",
    DEPTAUDIT_IMG: "deptAuditImg",
    ON_SITE_IMG: "onSiteImg",
    WORK_IMG: 'workImg',
    CHECK_IMG: 'checkImg',
    WHEN_HOT_SIGN_IMG: 'whenHotSignImg',
    WHEN_HOT_SCENE_IMG: 'whenHotSceneImg',
    ACCEPTANCE_SIGN_IMG: 'acceptanceSignImg',
    ACCEPTANCE_SCENE_IMG: 'acceptanceSceneImg',
    SAFETY_EDUCATION_IMG: 'safetyEducationImg',
    WORK_ACCEPT_IMG: 'workAcceptImg',
    OLD_LGNITION_TASK: 'OldLgnitionTask',
    LIMIT_TASK: 'LimitTask',
    BLIND_TASK: 'BlindTask',
    HIGH_TASK: 'HighTask',
    GROUND_TASK: 'GroundTask',
    TEMP_TASK: 'TempTask',
    BROKEN_TASK: 'BrokenTask',
    LIFT_TASK: 'LeftTask',
    PROTECT_TASK: 'ProtectTask',
    ENGINEERING: 'engineeringTask',
    GASWORK: 'GasTask',
    PROVIDE_SIGN_IMG: "provideSignImg",
    RECEIVE_SIGN_IMG: "receiveSignImg",
    Type: {
      FIRE_NAME: 'FIRE',
      BLIND_NAME: 'BLIND',
      GROUND_NAME: 'GROUND',
      LIFT_NAME: 'LIFT',
      LIMIT_NAME: 'LIMIT',
      TEMP_NAME: 'TEMP',
      HIGH_NAME: 'HIGH',
      BROKEN_NAME: 'BROKEN',
      PROTECT_NAME: 'PROTECT',
      ENGINEERING: 'GC',
      GASWORK: 'MQZY' }
  },

  HotWorkRole: {
    ON_SITE: 37,
    ACCEPTANCE: 38 },
  SystemInitRole: {
    EnterpriseAdmin: 45,
    SubEnterpriseAdmin: 46 },

  Activiti: 'activiti',
  FIRE_ACTION: "/apis" + '/api-activiti/task/createAttachment',

  RelevantExamineResultImpotUrl: "/apis" + '/api-cms/RelevantExamineResult/importData'
});

/***/ }),

/***/ 566:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(305);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5863e689_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(1225);
function injectStyle (ssrContext) {
  __webpack_require__(1201)
  __webpack_require__(1199)
  __webpack_require__(1200)
}
var normalizeComponent = __webpack_require__(72)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5863e689"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5863e689_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 591:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);


window.JSMpeg = { Player: null, VideoElement: null, BitBuffer: null, Source: {}, Demuxer: {}, Decoder: {}, Renderer: {}, AudioOutput: {}, Now: function Now() {
    return window.performance ? window.performance.now() / 1e3 : Date.now() / 1e3;
  }, CreateVideoElements: function CreateVideoElements() {
    var elements = document.querySelectorAll(".jsmpeg");for (var i = 0; i < elements.length; i++) {
      new JSMpeg.VideoElement(elements[i]);
    }
  }, Fill: function Fill(array, value) {
    if (array.fill) {
      array.fill(value);
    } else {
      for (var i = 0; i < array.length; i++) {
        array[i] = value;
      }
    }
  }, Base64ToArrayBuffer: function Base64ToArrayBuffer(base64) {
    var binary = window.atob(base64);var length = binary.length;var bytes = new Uint8Array(length);for (var i = 0; i < length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }return bytes.buffer;
  }, WASM_BINARY_INLINED: null };if (document.readyState === "complete") {
  JSMpeg.CreateVideoElements();
} else {
  document.addEventListener("DOMContentLoaded", JSMpeg.CreateVideoElements);
}JSMpeg.VideoElement = function () {
  "use strict";

  var VideoElement = function VideoElement(element) {
    var url = element.dataset.url;if (!url) {
      throw "VideoElement has no `data-url` attribute";
    }var addStyles = function addStyles(element, styles) {
      for (var name in styles) {
        element.style[name] = styles[name];
      }
    };this.container = element;addStyles(this.container, { display: "inline-block", position: "relative", minWidth: "80px", minHeight: "80px" });this.canvas = document.createElement("canvas");this.canvas.width = 960;this.canvas.height = 540;addStyles(this.canvas, { display: "block", width: "100%" });this.container.appendChild(this.canvas);this.playButton = document.createElement("div");this.playButton.innerHTML = VideoElement.PLAY_BUTTON;addStyles(this.playButton, { zIndex: 2, position: "absolute", top: "0", bottom: "0", left: "0", right: "0", maxWidth: "75px", maxHeight: "75px", margin: "auto", opacity: "0.7", cursor: "pointer" });this.container.appendChild(this.playButton);var options = { canvas: this.canvas };for (var option in element.dataset) {
      try {
        options[option] = JSON.parse(element.dataset[option]);
      } catch (err) {
        options[option] = element.dataset[option];
      }
    }this.player = new JSMpeg.Player(url, options);element.playerInstance = this.player;if (options.poster && !options.autoplay && !this.player.options.streaming) {
      options.decodeFirstFrame = false;this.poster = new Image();this.poster.src = options.poster;this.poster.addEventListener("load", this.posterLoaded);addStyles(this.poster, { display: "block", zIndex: 1, position: "absolute", top: 0, left: 0, bottom: 0, right: 0 });this.container.appendChild(this.poster);
    }if (!this.player.options.streaming) {
      this.container.addEventListener("click", this.onClick.bind(this));
    }if (options.autoplay || this.player.options.streaming) {
      this.playButton.style.display = "none";
    }if (this.player.audioOut && !this.player.audioOut.unlocked) {
      var unlockAudioElement = this.container;if (options.autoplay || this.player.options.streaming) {
        this.unmuteButton = document.createElement("div");this.unmuteButton.innerHTML = VideoElement.UNMUTE_BUTTON;addStyles(this.unmuteButton, { zIndex: 2, position: "absolute", bottom: "10px", right: "20px", width: "75px", height: "75px", margin: "auto", opacity: "0.7", cursor: "pointer" });this.container.appendChild(this.unmuteButton);unlockAudioElement = this.unmuteButton;
      }this.unlockAudioBound = this.onUnlockAudio.bind(this, unlockAudioElement);unlockAudioElement.addEventListener("touchstart", this.unlockAudioBound, false);unlockAudioElement.addEventListener("click", this.unlockAudioBound, true);
    }
  };VideoElement.prototype.onUnlockAudio = function (element, ev) {
    if (this.unmuteButton) {
      ev.preventDefault();ev.stopPropagation();
    }this.player.audioOut.unlock(function () {
      if (this.unmuteButton) {
        this.unmuteButton.style.display = "none";
      }element.removeEventListener("touchstart", this.unlockAudioBound);element.removeEventListener("click", this.unlockAudioBound);
    }.bind(this));
  };VideoElement.prototype.onClick = function (ev) {
    if (this.player.isPlaying) {
      this.player.pause();this.playButton.style.display = "block";
    } else {
      this.player.play();this.playButton.style.display = "none";if (this.poster) {
        this.poster.style.display = "none";
      }
    }
  };VideoElement.PLAY_BUTTON = '<svg style="max-width: 75px; max-height: 75px;" ' + 'viewBox="0 0 200 200" alt="Play video">' + '<circle cx="100" cy="100" r="90" fill="none" ' + 'stroke-width="15" stroke="#fff"/>' + '<polygon points="70, 55 70, 145 145, 100" fill="#fff"/>' + "</svg>";VideoElement.UNMUTE_BUTTON = '<svg style="max-width: 75px; max-height: 75px;" viewBox="0 0 75 75">' + '<polygon class="audio-speaker" stroke="none" fill="#fff" ' + 'points="39,13 22,28 6,28 6,47 21,47 39,62 39,13"/>' + '<g stroke="#fff" stroke-width="5">' + '<path d="M 49,50 69,26"/>' + '<path d="M 69,50 49,26"/>' + "</g>" + "</svg>";return VideoElement;
}();JSMpeg.Player = function () {
  "use strict";

  var Player = function Player(url, options) {
    this.options = options || {};if (options.source) {
      this.source = new options.source(url, options);options.streaming = !!this.source.streaming;
    } else if (url.match(/^wss?:\/\//)) {
      this.source = new JSMpeg.Source.WebSocket(url, options);options.streaming = true;
    } else if (options.progressive !== false) {
      this.source = new JSMpeg.Source.AjaxProgressive(url, options);options.streaming = false;
    } else {
      this.source = new JSMpeg.Source.Ajax(url, options);options.streaming = false;
    }this.maxAudioLag = options.maxAudioLag || .25;this.loop = options.loop !== false;this.autoplay = !!options.autoplay || options.streaming;this.demuxer = new JSMpeg.Demuxer.TS(options);this.source.connect(this.demuxer);if (!options.disableWebAssembly && JSMpeg.WASMModule.IsSupported()) {
      this.wasmModule = JSMpeg.WASMModule.GetModule();options.wasmModule = this.wasmModule;
    }if (options.video !== false) {
      this.video = options.wasmModule ? new JSMpeg.Decoder.MPEG1VideoWASM(options) : new JSMpeg.Decoder.MPEG1Video(options);this.renderer = !options.disableGl && JSMpeg.Renderer.WebGL.IsSupported() ? new JSMpeg.Renderer.WebGL(options) : new JSMpeg.Renderer.Canvas2D(options);this.demuxer.connect(JSMpeg.Demuxer.TS.STREAM.VIDEO_1, this.video);this.video.connect(this.renderer);
    }if (options.audio !== false && JSMpeg.AudioOutput.WebAudio.IsSupported()) {
      this.audio = options.wasmModule ? new JSMpeg.Decoder.MP2AudioWASM(options) : new JSMpeg.Decoder.MP2Audio(options);this.audioOut = new JSMpeg.AudioOutput.WebAudio(options);this.demuxer.connect(JSMpeg.Demuxer.TS.STREAM.AUDIO_1, this.audio);this.audio.connect(this.audioOut);
    }Object.defineProperty(this, "currentTime", { get: this.getCurrentTime, set: this.setCurrentTime });Object.defineProperty(this, "volume", { get: this.getVolume, set: this.setVolume });this.paused = true;this.unpauseOnShow = false;if (options.pauseWhenHidden !== false) {
      document.addEventListener("visibilitychange", this.showHide.bind(this));
    }if (this.wasmModule) {
      if (this.wasmModule.ready) {
        this.startLoading();
      } else if (JSMpeg.WASM_BINARY_INLINED) {
        var wasm = JSMpeg.Base64ToArrayBuffer(JSMpeg.WASM_BINARY_INLINED);this.wasmModule.loadFromBuffer(wasm, this.startLoading.bind(this));
      } else {
        this.wasmModule.loadFromFile("jsmpeg.wasm", this.startLoading.bind(this));
      }
    } else {
      this.startLoading();
    }
  };Player.prototype.startLoading = function () {
    this.source.start();if (this.autoplay) {
      this.play();
    }
  };Player.prototype.showHide = function (ev) {
    if (document.visibilityState === "hidden") {
      this.unpauseOnShow = this.wantsToPlay;this.pause();
    } else if (this.unpauseOnShow) {
      this.play();
    }
  };Player.prototype.play = function (ev) {
    if (this.animationId) {
      return;
    }this.animationId = requestAnimationFrame(this.update.bind(this));this.wantsToPlay = true;this.paused = false;
  };Player.prototype.pause = function (ev) {
    if (this.paused) {
      return;
    }cancelAnimationFrame(this.animationId);this.animationId = null;this.wantsToPlay = false;this.isPlaying = false;this.paused = true;if (this.audio && this.audio.canPlay) {
      this.audioOut.stop();this.seek(this.currentTime);
    }if (this.options.onPause) {
      this.options.onPause(this);
    }
  };Player.prototype.getVolume = function () {
    return this.audioOut ? this.audioOut.volume : 0;
  };Player.prototype.setVolume = function (volume) {
    if (this.audioOut) {
      this.audioOut.volume = volume;
    }
  };Player.prototype.stop = function (ev) {
    this.pause();this.seek(0);if (this.video && this.options.decodeFirstFrame !== false) {
      this.video.decode();
    }
  };Player.prototype.destroy = function () {
    this.pause();this.source.destroy();this.video && this.video.destroy();this.renderer && this.renderer.destroy();this.audio && this.audio.destroy();this.audioOut && this.audioOut.destroy();
  };Player.prototype.seek = function (time) {
    var startOffset = this.audio && this.audio.canPlay ? this.audio.startTime : this.video.startTime;if (this.video) {
      this.video.seek(time + startOffset);
    }if (this.audio) {
      this.audio.seek(time + startOffset);
    }this.startTime = JSMpeg.Now() - time;
  };Player.prototype.getCurrentTime = function () {
    return this.audio && this.audio.canPlay ? this.audio.currentTime - this.audio.startTime : this.video.currentTime - this.video.startTime;
  };Player.prototype.setCurrentTime = function (time) {
    this.seek(time);
  };Player.prototype.update = function () {
    this.animationId = requestAnimationFrame(this.update.bind(this));if (!this.source.established) {
      if (this.renderer) {
        this.renderer.renderProgress(this.source.progress);
      }return;
    }if (!this.isPlaying) {
      this.isPlaying = true;this.startTime = JSMpeg.Now() - this.currentTime;if (this.options.onPlay) {
        this.options.onPlay(this);
      }
    }if (this.options.streaming) {
      this.updateForStreaming();
    } else {
      this.updateForStaticFile();
    }
  };Player.prototype.updateForStreaming = function () {
    if (this.video) {
      this.video.decode();
    }if (this.audio) {
      var decoded = false;do {
        if (this.audioOut.enqueuedTime > this.maxAudioLag) {
          this.audioOut.resetEnqueuedTime();this.audioOut.enabled = false;
        }decoded = this.audio.decode();
      } while (decoded);this.audioOut.enabled = true;
    }
  };Player.prototype.nextFrame = function () {
    if (this.source.established && this.video) {
      return this.video.decode();
    }return false;
  };Player.prototype.updateForStaticFile = function () {
    var notEnoughData = false,
        headroom = 0;if (this.audio && this.audio.canPlay) {
      while (!notEnoughData && this.audio.decodedTime - this.audio.currentTime < .25) {
        notEnoughData = !this.audio.decode();
      }if (this.video && this.video.currentTime < this.audio.currentTime) {
        notEnoughData = !this.video.decode();
      }headroom = this.demuxer.currentTime - this.audio.currentTime;
    } else if (this.video) {
      var targetTime = JSMpeg.Now() - this.startTime + this.video.startTime,
          lateTime = targetTime - this.video.currentTime,
          frameTime = 1 / this.video.frameRate;if (this.video && lateTime > 0) {
        if (lateTime > frameTime * 2) {
          this.startTime += lateTime;
        }notEnoughData = !this.video.decode();
      }headroom = this.demuxer.currentTime - targetTime;
    }this.source.resume(headroom);if (notEnoughData && this.source.completed) {
      if (this.loop) {
        this.seek(0);
      } else {
        this.pause();if (this.options.onEnded) {
          this.options.onEnded(this);
        }
      }
    } else if (notEnoughData && this.options.onStalled) {
      this.options.onStalled(this);
    }
  };return Player;
}();JSMpeg.BitBuffer = function () {
  "use strict";

  var BitBuffer = function BitBuffer(bufferOrLength, mode) {
    if ((typeof bufferOrLength === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(bufferOrLength)) === "object") {
      this.bytes = bufferOrLength instanceof Uint8Array ? bufferOrLength : new Uint8Array(bufferOrLength);this.byteLength = this.bytes.length;
    } else {
      this.bytes = new Uint8Array(bufferOrLength || 1024 * 1024);this.byteLength = 0;
    }this.mode = mode || BitBuffer.MODE.EXPAND;this.index = 0;
  };BitBuffer.prototype.resize = function (size) {
    var newBytes = new Uint8Array(size);if (this.byteLength !== 0) {
      this.byteLength = Math.min(this.byteLength, size);newBytes.set(this.bytes, 0, this.byteLength);
    }this.bytes = newBytes;this.index = Math.min(this.index, this.byteLength << 3);
  };BitBuffer.prototype.evict = function (sizeNeeded) {
    var bytePos = this.index >> 3,
        available = this.bytes.length - this.byteLength;if (this.index === this.byteLength << 3 || sizeNeeded > available + bytePos) {
      this.byteLength = 0;this.index = 0;return;
    } else if (bytePos === 0) {
      return;
    }if (this.bytes.copyWithin) {
      this.bytes.copyWithin(0, bytePos, this.byteLength);
    } else {
      this.bytes.set(this.bytes.subarray(bytePos, this.byteLength));
    }this.byteLength = this.byteLength - bytePos;this.index -= bytePos << 3;return;
  };BitBuffer.prototype.write = function (buffers) {
    var isArrayOfBuffers = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(buffers[0]) === "object",
        totalLength = 0,
        available = this.bytes.length - this.byteLength;if (isArrayOfBuffers) {
      var totalLength = 0;for (var i = 0; i < buffers.length; i++) {
        totalLength += buffers[i].byteLength;
      }
    } else {
      totalLength = buffers.byteLength;
    }if (totalLength > available) {
      if (this.mode === BitBuffer.MODE.EXPAND) {
        var newSize = Math.max(this.bytes.length * 2, totalLength - available);this.resize(newSize);
      } else {
        this.evict(totalLength);
      }
    }if (isArrayOfBuffers) {
      for (var i = 0; i < buffers.length; i++) {
        this.appendSingleBuffer(buffers[i]);
      }
    } else {
      this.appendSingleBuffer(buffers);
    }return totalLength;
  };BitBuffer.prototype.appendSingleBuffer = function (buffer) {
    buffer = buffer instanceof Uint8Array ? buffer : new Uint8Array(buffer);this.bytes.set(buffer, this.byteLength);this.byteLength += buffer.length;
  };BitBuffer.prototype.findNextStartCode = function () {
    for (var i = this.index + 7 >> 3; i < this.byteLength; i++) {
      if (this.bytes[i] == 0 && this.bytes[i + 1] == 0 && this.bytes[i + 2] == 1) {
        this.index = i + 4 << 3;return this.bytes[i + 3];
      }
    }this.index = this.byteLength << 3;return -1;
  };BitBuffer.prototype.findStartCode = function (code) {
    var current = 0;while (true) {
      current = this.findNextStartCode();if (current === code || current === -1) {
        return current;
      }
    }return -1;
  };BitBuffer.prototype.nextBytesAreStartCode = function () {
    var i = this.index + 7 >> 3;return i >= this.byteLength || this.bytes[i] == 0 && this.bytes[i + 1] == 0 && this.bytes[i + 2] == 1;
  };BitBuffer.prototype.peek = function (count) {
    var offset = this.index;var value = 0;while (count) {
      var currentByte = this.bytes[offset >> 3],
          remaining = 8 - (offset & 7),
          read = remaining < count ? remaining : count,
          shift = remaining - read,
          mask = 255 >> 8 - read;value = value << read | (currentByte & mask << shift) >> shift;offset += read;count -= read;
    }return value;
  };BitBuffer.prototype.read = function (count) {
    var value = this.peek(count);this.index += count;return value;
  };BitBuffer.prototype.skip = function (count) {
    return this.index += count;
  };BitBuffer.prototype.rewind = function (count) {
    this.index = Math.max(this.index - count, 0);
  };BitBuffer.prototype.has = function (count) {
    return (this.byteLength << 3) - this.index >= count;
  };BitBuffer.MODE = { EVICT: 1, EXPAND: 2 };return BitBuffer;
}();JSMpeg.Source.Ajax = function () {
  "use strict";

  var AjaxSource = function AjaxSource(url, options) {
    this.url = url;this.destination = null;this.request = null;this.streaming = false;this.completed = false;this.established = false;this.progress = 0;this.onEstablishedCallback = options.onSourceEstablished;this.onCompletedCallback = options.onSourceCompleted;
  };AjaxSource.prototype.connect = function (destination) {
    this.destination = destination;
  };AjaxSource.prototype.start = function () {
    this.request = new XMLHttpRequest();this.request.onreadystatechange = function () {
      if (this.request.readyState === this.request.DONE && this.request.status === 200) {
        this.onLoad(this.request.response);
      }
    }.bind(this);this.request.onprogress = this.onProgress.bind(this);this.request.open("GET", this.url);this.request.responseType = "arraybuffer";this.request.send();
  };AjaxSource.prototype.resume = function (secondsHeadroom) {};AjaxSource.prototype.destroy = function () {
    this.request.abort();
  };AjaxSource.prototype.onProgress = function (ev) {
    this.progress = ev.loaded / ev.total;
  };AjaxSource.prototype.onLoad = function (data) {
    this.established = true;this.completed = true;this.progress = 1;if (this.onEstablishedCallback) {
      this.onEstablishedCallback(this);
    }if (this.onCompletedCallback) {
      this.onCompletedCallback(this);
    }if (this.destination) {
      this.destination.write(data);
    }
  };return AjaxSource;
}();JSMpeg.Source.Fetch = function () {
  "use strict";

  var FetchSource = function FetchSource(url, options) {
    this.url = url;this.destination = null;this.request = null;this.streaming = true;this.completed = false;this.established = false;this.progress = 0;this.aborted = false;this.onEstablishedCallback = options.onSourceEstablished;this.onCompletedCallback = options.onSourceCompleted;
  };FetchSource.prototype.connect = function (destination) {
    this.destination = destination;
  };FetchSource.prototype.start = function () {
    var params = { method: "GET", headers: new Headers(), cache: "default" };self.fetch(this.url, params).then(function (res) {
      if (res.ok && res.status >= 200 && res.status <= 299) {
        this.progress = 1;this.established = true;return this.pump(res.body.getReader());
      } else {}
    }.bind(this)).catch(function (err) {
      throw err;
    });
  };FetchSource.prototype.pump = function (reader) {
    return reader.read().then(function (result) {
      if (result.done) {
        this.completed = true;
      } else {
        if (this.aborted) {
          return reader.cancel();
        }if (this.destination) {
          this.destination.write(result.value.buffer);
        }return this.pump(reader);
      }
    }.bind(this)).catch(function (err) {
      throw err;
    });
  };FetchSource.prototype.resume = function (secondsHeadroom) {};FetchSource.prototype.abort = function () {
    this.aborted = true;
  };return FetchSource;
}();JSMpeg.Source.AjaxProgressive = function () {
  "use strict";

  var AjaxProgressiveSource = function AjaxProgressiveSource(url, options) {
    this.url = url;this.destination = null;this.request = null;this.streaming = false;this.completed = false;this.established = false;this.progress = 0;this.fileSize = 0;this.loadedSize = 0;this.chunkSize = options.chunkSize || 1024 * 1024;this.isLoading = false;this.loadStartTime = 0;this.throttled = options.throttled !== false;this.aborted = false;this.onEstablishedCallback = options.onSourceEstablished;this.onCompletedCallback = options.onSourceCompleted;
  };AjaxProgressiveSource.prototype.connect = function (destination) {
    this.destination = destination;
  };AjaxProgressiveSource.prototype.start = function () {
    this.request = new XMLHttpRequest();this.request.onreadystatechange = function () {
      if (this.request.readyState === this.request.DONE) {
        this.fileSize = parseInt(this.request.getResponseHeader("Content-Length"));this.loadNextChunk();
      }
    }.bind(this);this.request.onprogress = this.onProgress.bind(this);this.request.open("HEAD", this.url);this.request.send();
  };AjaxProgressiveSource.prototype.resume = function (secondsHeadroom) {
    if (this.isLoading || !this.throttled) {
      return;
    }var worstCaseLoadingTime = this.loadTime * 8 + 2;if (worstCaseLoadingTime > secondsHeadroom) {
      this.loadNextChunk();
    }
  };AjaxProgressiveSource.prototype.destroy = function () {
    this.request.abort();this.aborted = true;
  };AjaxProgressiveSource.prototype.loadNextChunk = function () {
    var start = this.loadedSize,
        end = Math.min(this.loadedSize + this.chunkSize - 1, this.fileSize - 1);if (start >= this.fileSize || this.aborted) {
      this.completed = true;if (this.onCompletedCallback) {
        this.onCompletedCallback(this);
      }return;
    }this.isLoading = true;this.loadStartTime = JSMpeg.Now();this.request = new XMLHttpRequest();this.request.onreadystatechange = function () {
      if (this.request.readyState === this.request.DONE && this.request.status >= 200 && this.request.status < 300) {
        this.onChunkLoad(this.request.response);
      } else if (this.request.readyState === this.request.DONE) {
        if (this.loadFails++ < 3) {
          this.loadNextChunk();
        }
      }
    }.bind(this);if (start === 0) {
      this.request.onprogress = this.onProgress.bind(this);
    }this.request.open("GET", this.url + "?" + start + "-" + end);this.request.setRequestHeader("Range", "bytes=" + start + "-" + end);this.request.responseType = "arraybuffer";this.request.send();
  };AjaxProgressiveSource.prototype.onProgress = function (ev) {
    this.progress = ev.loaded / ev.total;
  };AjaxProgressiveSource.prototype.onChunkLoad = function (data) {
    var isFirstChunk = !this.established;this.established = true;this.progress = 1;this.loadedSize += data.byteLength;this.loadFails = 0;this.isLoading = false;if (isFirstChunk && this.onEstablishedCallback) {
      this.onEstablishedCallback(this);
    }if (this.destination) {
      this.destination.write(data);
    }this.loadTime = JSMpeg.Now() - this.loadStartTime;if (!this.throttled) {
      this.loadNextChunk();
    }
  };return AjaxProgressiveSource;
}();JSMpeg.Source.WebSocket = function () {
  "use strict";

  var WSSource = function WSSource(url, options) {
    this.url = url;this.options = options;this.socket = null;this.streaming = true;this.callbacks = { connect: [], data: [] };this.destination = null;this.reconnectInterval = options.reconnectInterval !== undefined ? options.reconnectInterval : 5;this.shouldAttemptReconnect = !!this.reconnectInterval;this.completed = false;this.established = false;this.progress = 0;this.reconnectTimeoutId = 0;this.onEstablishedCallback = options.onSourceEstablished;this.onCompletedCallback = options.onSourceCompleted;
  };WSSource.prototype.connect = function (destination) {
    this.destination = destination;
  };WSSource.prototype.destroy = function () {
    clearTimeout(this.reconnectTimeoutId);this.shouldAttemptReconnect = false;this.socket.close();
  };WSSource.prototype.start = function () {
    this.shouldAttemptReconnect = !!this.reconnectInterval;this.progress = 0;this.established = false;this.socket = new WebSocket(this.url, this.options.protocols || null);this.socket.binaryType = "arraybuffer";this.socket.onmessage = this.onMessage.bind(this);this.socket.onopen = this.onOpen.bind(this);this.socket.onerror = this.onClose.bind(this);this.socket.onclose = this.onClose.bind(this);
  };WSSource.prototype.resume = function (secondsHeadroom) {};WSSource.prototype.onOpen = function () {
    this.progress = 1;
  };WSSource.prototype.onClose = function () {
    if (this.shouldAttemptReconnect) {
      clearTimeout(this.reconnectTimeoutId);this.reconnectTimeoutId = setTimeout(function () {
        this.start();
      }.bind(this), this.reconnectInterval * 1e3);
    }
  };WSSource.prototype.onMessage = function (ev) {
    var isFirstChunk = !this.established;this.established = true;if (isFirstChunk && this.onEstablishedCallback) {
      this.onEstablishedCallback(this);
    }if (this.destination) {
      this.destination.write(ev.data);
    }
  };return WSSource;
}();JSMpeg.Demuxer.TS = function () {
  "use strict";

  var TS = function TS(options) {
    this.bits = null;this.leftoverBytes = null;this.guessVideoFrameEnd = true;this.pidsToStreamIds = {};this.pesPacketInfo = {};this.startTime = 0;this.currentTime = 0;
  };TS.prototype.connect = function (streamId, destination) {
    this.pesPacketInfo[streamId] = { destination: destination, currentLength: 0, totalLength: 0, pts: 0, buffers: [] };
  };TS.prototype.write = function (buffer) {
    if (this.leftoverBytes) {
      var totalLength = buffer.byteLength + this.leftoverBytes.byteLength;this.bits = new JSMpeg.BitBuffer(totalLength);this.bits.write([this.leftoverBytes, buffer]);
    } else {
      this.bits = new JSMpeg.BitBuffer(buffer);
    }while (this.bits.has(188 << 3) && this.parsePacket()) {}var leftoverCount = this.bits.byteLength - (this.bits.index >> 3);this.leftoverBytes = leftoverCount > 0 ? this.bits.bytes.subarray(this.bits.index >> 3) : null;
  };TS.prototype.parsePacket = function () {
    if (this.bits.read(8) !== 71) {
      if (!this.resync()) {
        return false;
      }
    }var end = (this.bits.index >> 3) + 187;var transportError = this.bits.read(1),
        payloadStart = this.bits.read(1),
        transportPriority = this.bits.read(1),
        pid = this.bits.read(13),
        transportScrambling = this.bits.read(2),
        adaptationField = this.bits.read(2),
        continuityCounter = this.bits.read(4);var streamId = this.pidsToStreamIds[pid];if (payloadStart && streamId) {
      var pi = this.pesPacketInfo[streamId];if (pi && pi.currentLength) {
        this.packetComplete(pi);
      }
    }if (adaptationField & 1) {
      if (adaptationField & 2) {
        var adaptationFieldLength = this.bits.read(8);this.bits.skip(adaptationFieldLength << 3);
      }if (payloadStart && this.bits.nextBytesAreStartCode()) {
        this.bits.skip(24);streamId = this.bits.read(8);this.pidsToStreamIds[pid] = streamId;var packetLength = this.bits.read(16);this.bits.skip(8);var ptsDtsFlag = this.bits.read(2);this.bits.skip(6);var headerLength = this.bits.read(8);var payloadBeginIndex = this.bits.index + (headerLength << 3);var pi = this.pesPacketInfo[streamId];if (pi) {
          var pts = 0;if (ptsDtsFlag & 2) {
            this.bits.skip(4);var p32_30 = this.bits.read(3);this.bits.skip(1);var p29_15 = this.bits.read(15);this.bits.skip(1);var p14_0 = this.bits.read(15);this.bits.skip(1);pts = (p32_30 * 1073741824 + p29_15 * 32768 + p14_0) / 9e4;this.currentTime = pts;if (this.startTime === -1) {
              this.startTime = pts;
            }
          }var payloadLength = packetLength ? packetLength - headerLength - 3 : 0;this.packetStart(pi, pts, payloadLength);
        }this.bits.index = payloadBeginIndex;
      }if (streamId) {
        var pi = this.pesPacketInfo[streamId];if (pi) {
          var start = this.bits.index >> 3;var complete = this.packetAddData(pi, start, end);var hasPadding = !payloadStart && adaptationField & 2;if (complete || this.guessVideoFrameEnd && hasPadding) {
            this.packetComplete(pi);
          }
        }
      }
    }this.bits.index = end << 3;return true;
  };TS.prototype.resync = function () {
    if (!this.bits.has(188 * 6 << 3)) {
      return false;
    }var byteIndex = this.bits.index >> 3;for (var i = 0; i < 187; i++) {
      if (this.bits.bytes[byteIndex + i] === 71) {
        var foundSync = true;for (var j = 1; j < 5; j++) {
          if (this.bits.bytes[byteIndex + i + 188 * j] !== 71) {
            foundSync = false;break;
          }
        }if (foundSync) {
          this.bits.index = byteIndex + i + 1 << 3;return true;
        }
      }
    }console.warn("JSMpeg: Possible garbage data. Skipping.");this.bits.skip(187 << 3);return false;
  };TS.prototype.packetStart = function (pi, pts, payloadLength) {
    pi.totalLength = payloadLength;pi.currentLength = 0;pi.pts = pts;
  };TS.prototype.packetAddData = function (pi, start, end) {
    pi.buffers.push(this.bits.bytes.subarray(start, end));pi.currentLength += end - start;var complete = pi.totalLength !== 0 && pi.currentLength >= pi.totalLength;return complete;
  };TS.prototype.packetComplete = function (pi) {
    pi.destination.write(pi.pts, pi.buffers);pi.totalLength = 0;pi.currentLength = 0;pi.buffers = [];
  };TS.STREAM = { PACK_HEADER: 186, SYSTEM_HEADER: 187, PROGRAM_MAP: 188, PRIVATE_1: 189, PADDING: 190, PRIVATE_2: 191, AUDIO_1: 192, VIDEO_1: 224, DIRECTORY: 255 };return TS;
}();JSMpeg.Decoder.Base = function () {
  "use strict";

  var BaseDecoder = function BaseDecoder(options) {
    this.destination = null;this.canPlay = false;this.collectTimestamps = !options.streaming;this.bytesWritten = 0;this.timestamps = [];this.timestampIndex = 0;this.startTime = 0;this.decodedTime = 0;Object.defineProperty(this, "currentTime", { get: this.getCurrentTime });
  };BaseDecoder.prototype.destroy = function () {};BaseDecoder.prototype.connect = function (destination) {
    this.destination = destination;
  };BaseDecoder.prototype.bufferGetIndex = function () {
    return this.bits.index;
  };BaseDecoder.prototype.bufferSetIndex = function (index) {
    this.bits.index = index;
  };BaseDecoder.prototype.bufferWrite = function (buffers) {
    return this.bits.write(buffers);
  };BaseDecoder.prototype.write = function (pts, buffers) {
    if (this.collectTimestamps) {
      if (this.timestamps.length === 0) {
        this.startTime = pts;this.decodedTime = pts;
      }this.timestamps.push({ index: this.bytesWritten << 3, time: pts });
    }this.bytesWritten += this.bufferWrite(buffers);this.canPlay = true;
  };BaseDecoder.prototype.seek = function (time) {
    if (!this.collectTimestamps) {
      return;
    }this.timestampIndex = 0;for (var i = 0; i < this.timestamps.length; i++) {
      if (this.timestamps[i].time > time) {
        break;
      }this.timestampIndex = i;
    }var ts = this.timestamps[this.timestampIndex];if (ts) {
      this.bufferSetIndex(ts.index);this.decodedTime = ts.time;
    } else {
      this.bufferSetIndex(0);this.decodedTime = this.startTime;
    }
  };BaseDecoder.prototype.decode = function () {
    this.advanceDecodedTime(0);
  };BaseDecoder.prototype.advanceDecodedTime = function (seconds) {
    if (this.collectTimestamps) {
      var newTimestampIndex = -1;var currentIndex = this.bufferGetIndex();for (var i = this.timestampIndex; i < this.timestamps.length; i++) {
        if (this.timestamps[i].index > currentIndex) {
          break;
        }newTimestampIndex = i;
      }if (newTimestampIndex !== -1 && newTimestampIndex !== this.timestampIndex) {
        this.timestampIndex = newTimestampIndex;this.decodedTime = this.timestamps[this.timestampIndex].time;return;
      }
    }this.decodedTime += seconds;
  };BaseDecoder.prototype.getCurrentTime = function () {
    return this.decodedTime;
  };return BaseDecoder;
}();JSMpeg.Decoder.MPEG1Video = function () {
  "use strict";

  var MPEG1 = function MPEG1(options) {
    JSMpeg.Decoder.Base.call(this, options);this.onDecodeCallback = options.onVideoDecode;var bufferSize = options.videoBufferSize || 512 * 1024;var bufferMode = options.streaming ? JSMpeg.BitBuffer.MODE.EVICT : JSMpeg.BitBuffer.MODE.EXPAND;this.bits = new JSMpeg.BitBuffer(bufferSize, bufferMode);this.customIntraQuantMatrix = new Uint8Array(64);this.customNonIntraQuantMatrix = new Uint8Array(64);this.blockData = new Int32Array(64);this.currentFrame = 0;this.decodeFirstFrame = options.decodeFirstFrame !== false;
  };MPEG1.prototype = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default()(JSMpeg.Decoder.Base.prototype);MPEG1.prototype.constructor = MPEG1;MPEG1.prototype.write = function (pts, buffers) {
    JSMpeg.Decoder.Base.prototype.write.call(this, pts, buffers);if (!this.hasSequenceHeader) {
      if (this.bits.findStartCode(MPEG1.START.SEQUENCE) === -1) {
        return false;
      }this.decodeSequenceHeader();if (this.decodeFirstFrame) {
        this.decode();
      }
    }
  };MPEG1.prototype.decode = function () {
    var startTime = JSMpeg.Now();if (!this.hasSequenceHeader) {
      return false;
    }if (this.bits.findStartCode(MPEG1.START.PICTURE) === -1) {
      var bufferedBytes = this.bits.byteLength - (this.bits.index >> 3);return false;
    }this.decodePicture();this.advanceDecodedTime(1 / this.frameRate);var elapsedTime = JSMpeg.Now() - startTime;if (this.onDecodeCallback) {
      this.onDecodeCallback(this, elapsedTime);
    }return true;
  };MPEG1.prototype.readHuffman = function (codeTable) {
    var state = 0;do {
      state = codeTable[state + this.bits.read(1)];
    } while (state >= 0 && codeTable[state] !== 0);return codeTable[state + 2];
  };MPEG1.prototype.frameRate = 30;MPEG1.prototype.decodeSequenceHeader = function () {
    var newWidth = this.bits.read(12),
        newHeight = this.bits.read(12);this.bits.skip(4);this.frameRate = MPEG1.PICTURE_RATE[this.bits.read(4)];this.bits.skip(18 + 1 + 10 + 1);if (newWidth !== this.width || newHeight !== this.height) {
      this.width = newWidth;this.height = newHeight;this.initBuffers();if (this.destination) {
        this.destination.resize(newWidth, newHeight);
      }
    }if (this.bits.read(1)) {
      for (var i = 0; i < 64; i++) {
        this.customIntraQuantMatrix[MPEG1.ZIG_ZAG[i]] = this.bits.read(8);
      }this.intraQuantMatrix = this.customIntraQuantMatrix;
    }if (this.bits.read(1)) {
      for (var i = 0; i < 64; i++) {
        var idx = MPEG1.ZIG_ZAG[i];this.customNonIntraQuantMatrix[idx] = this.bits.read(8);
      }this.nonIntraQuantMatrix = this.customNonIntraQuantMatrix;
    }this.hasSequenceHeader = true;
  };MPEG1.prototype.initBuffers = function () {
    this.intraQuantMatrix = MPEG1.DEFAULT_INTRA_QUANT_MATRIX;this.nonIntraQuantMatrix = MPEG1.DEFAULT_NON_INTRA_QUANT_MATRIX;this.mbWidth = this.width + 15 >> 4;this.mbHeight = this.height + 15 >> 4;this.mbSize = this.mbWidth * this.mbHeight;this.codedWidth = this.mbWidth << 4;this.codedHeight = this.mbHeight << 4;this.codedSize = this.codedWidth * this.codedHeight;this.halfWidth = this.mbWidth << 3;this.halfHeight = this.mbHeight << 3;this.currentY = new Uint8ClampedArray(this.codedSize);this.currentY32 = new Uint32Array(this.currentY.buffer);this.currentCr = new Uint8ClampedArray(this.codedSize >> 2);this.currentCr32 = new Uint32Array(this.currentCr.buffer);this.currentCb = new Uint8ClampedArray(this.codedSize >> 2);this.currentCb32 = new Uint32Array(this.currentCb.buffer);this.forwardY = new Uint8ClampedArray(this.codedSize);this.forwardY32 = new Uint32Array(this.forwardY.buffer);this.forwardCr = new Uint8ClampedArray(this.codedSize >> 2);this.forwardCr32 = new Uint32Array(this.forwardCr.buffer);this.forwardCb = new Uint8ClampedArray(this.codedSize >> 2);this.forwardCb32 = new Uint32Array(this.forwardCb.buffer);
  };MPEG1.prototype.currentY = null;MPEG1.prototype.currentCr = null;MPEG1.prototype.currentCb = null;MPEG1.prototype.pictureType = 0;MPEG1.prototype.forwardY = null;MPEG1.prototype.forwardCr = null;MPEG1.prototype.forwardCb = null;MPEG1.prototype.fullPelForward = false;MPEG1.prototype.forwardFCode = 0;MPEG1.prototype.forwardRSize = 0;MPEG1.prototype.forwardF = 0;MPEG1.prototype.decodePicture = function (skipOutput) {
    this.currentFrame++;this.bits.skip(10);this.pictureType = this.bits.read(3);this.bits.skip(16);if (this.pictureType <= 0 || this.pictureType >= MPEG1.PICTURE_TYPE.B) {
      return;
    }if (this.pictureType === MPEG1.PICTURE_TYPE.PREDICTIVE) {
      this.fullPelForward = this.bits.read(1);this.forwardFCode = this.bits.read(3);if (this.forwardFCode === 0) {
        return;
      }this.forwardRSize = this.forwardFCode - 1;this.forwardF = 1 << this.forwardRSize;
    }var code = 0;do {
      code = this.bits.findNextStartCode();
    } while (code === MPEG1.START.EXTENSION || code === MPEG1.START.USER_DATA);while (code >= MPEG1.START.SLICE_FIRST && code <= MPEG1.START.SLICE_LAST) {
      this.decodeSlice(code & 255);code = this.bits.findNextStartCode();
    }if (code !== -1) {
      this.bits.rewind(32);
    }if (this.destination) {
      this.destination.render(this.currentY, this.currentCr, this.currentCb, true);
    }if (this.pictureType === MPEG1.PICTURE_TYPE.INTRA || this.pictureType === MPEG1.PICTURE_TYPE.PREDICTIVE) {
      var tmpY = this.forwardY,
          tmpY32 = this.forwardY32,
          tmpCr = this.forwardCr,
          tmpCr32 = this.forwardCr32,
          tmpCb = this.forwardCb,
          tmpCb32 = this.forwardCb32;this.forwardY = this.currentY;this.forwardY32 = this.currentY32;this.forwardCr = this.currentCr;this.forwardCr32 = this.currentCr32;this.forwardCb = this.currentCb;this.forwardCb32 = this.currentCb32;this.currentY = tmpY;this.currentY32 = tmpY32;this.currentCr = tmpCr;this.currentCr32 = tmpCr32;this.currentCb = tmpCb;this.currentCb32 = tmpCb32;
    }
  };MPEG1.prototype.quantizerScale = 0;MPEG1.prototype.sliceBegin = false;MPEG1.prototype.decodeSlice = function (slice) {
    this.sliceBegin = true;this.macroblockAddress = (slice - 1) * this.mbWidth - 1;this.motionFwH = this.motionFwHPrev = 0;this.motionFwV = this.motionFwVPrev = 0;this.dcPredictorY = 128;this.dcPredictorCr = 128;this.dcPredictorCb = 128;this.quantizerScale = this.bits.read(5);while (this.bits.read(1)) {
      this.bits.skip(8);
    }do {
      this.decodeMacroblock();
    } while (!this.bits.nextBytesAreStartCode());
  };MPEG1.prototype.macroblockAddress = 0;MPEG1.prototype.mbRow = 0;MPEG1.prototype.mbCol = 0;MPEG1.prototype.macroblockType = 0;MPEG1.prototype.macroblockIntra = false;MPEG1.prototype.macroblockMotFw = false;MPEG1.prototype.motionFwH = 0;MPEG1.prototype.motionFwV = 0;MPEG1.prototype.motionFwHPrev = 0;MPEG1.prototype.motionFwVPrev = 0;MPEG1.prototype.decodeMacroblock = function () {
    var increment = 0,
        t = this.readHuffman(MPEG1.MACROBLOCK_ADDRESS_INCREMENT);while (t === 34) {
      t = this.readHuffman(MPEG1.MACROBLOCK_ADDRESS_INCREMENT);
    }while (t === 35) {
      increment += 33;t = this.readHuffman(MPEG1.MACROBLOCK_ADDRESS_INCREMENT);
    }increment += t;if (this.sliceBegin) {
      this.sliceBegin = false;this.macroblockAddress += increment;
    } else {
      if (this.macroblockAddress + increment >= this.mbSize) {
        return;
      }if (increment > 1) {
        this.dcPredictorY = 128;this.dcPredictorCr = 128;this.dcPredictorCb = 128;if (this.pictureType === MPEG1.PICTURE_TYPE.PREDICTIVE) {
          this.motionFwH = this.motionFwHPrev = 0;this.motionFwV = this.motionFwVPrev = 0;
        }
      }while (increment > 1) {
        this.macroblockAddress++;this.mbRow = this.macroblockAddress / this.mbWidth | 0;this.mbCol = this.macroblockAddress % this.mbWidth;this.copyMacroblock(this.motionFwH, this.motionFwV, this.forwardY, this.forwardCr, this.forwardCb);increment--;
      }this.macroblockAddress++;
    }this.mbRow = this.macroblockAddress / this.mbWidth | 0;this.mbCol = this.macroblockAddress % this.mbWidth;var mbTable = MPEG1.MACROBLOCK_TYPE[this.pictureType];this.macroblockType = this.readHuffman(mbTable);this.macroblockIntra = this.macroblockType & 1;this.macroblockMotFw = this.macroblockType & 8;if ((this.macroblockType & 16) !== 0) {
      this.quantizerScale = this.bits.read(5);
    }if (this.macroblockIntra) {
      this.motionFwH = this.motionFwHPrev = 0;this.motionFwV = this.motionFwVPrev = 0;
    } else {
      this.dcPredictorY = 128;this.dcPredictorCr = 128;this.dcPredictorCb = 128;this.decodeMotionVectors();this.copyMacroblock(this.motionFwH, this.motionFwV, this.forwardY, this.forwardCr, this.forwardCb);
    }var cbp = (this.macroblockType & 2) !== 0 ? this.readHuffman(MPEG1.CODE_BLOCK_PATTERN) : this.macroblockIntra ? 63 : 0;for (var block = 0, mask = 32; block < 6; block++) {
      if ((cbp & mask) !== 0) {
        this.decodeBlock(block);
      }mask >>= 1;
    }
  };MPEG1.prototype.decodeMotionVectors = function () {
    var code,
        d,
        r = 0;if (this.macroblockMotFw) {
      code = this.readHuffman(MPEG1.MOTION);if (code !== 0 && this.forwardF !== 1) {
        r = this.bits.read(this.forwardRSize);d = (Math.abs(code) - 1 << this.forwardRSize) + r + 1;if (code < 0) {
          d = -d;
        }
      } else {
        d = code;
      }this.motionFwHPrev += d;if (this.motionFwHPrev > (this.forwardF << 4) - 1) {
        this.motionFwHPrev -= this.forwardF << 5;
      } else if (this.motionFwHPrev < -this.forwardF << 4) {
        this.motionFwHPrev += this.forwardF << 5;
      }this.motionFwH = this.motionFwHPrev;if (this.fullPelForward) {
        this.motionFwH <<= 1;
      }code = this.readHuffman(MPEG1.MOTION);if (code !== 0 && this.forwardF !== 1) {
        r = this.bits.read(this.forwardRSize);d = (Math.abs(code) - 1 << this.forwardRSize) + r + 1;if (code < 0) {
          d = -d;
        }
      } else {
        d = code;
      }this.motionFwVPrev += d;if (this.motionFwVPrev > (this.forwardF << 4) - 1) {
        this.motionFwVPrev -= this.forwardF << 5;
      } else if (this.motionFwVPrev < -this.forwardF << 4) {
        this.motionFwVPrev += this.forwardF << 5;
      }this.motionFwV = this.motionFwVPrev;if (this.fullPelForward) {
        this.motionFwV <<= 1;
      }
    } else if (this.pictureType === MPEG1.PICTURE_TYPE.PREDICTIVE) {
      this.motionFwH = this.motionFwHPrev = 0;this.motionFwV = this.motionFwVPrev = 0;
    }
  };MPEG1.prototype.copyMacroblock = function (motionH, motionV, sY, sCr, sCb) {
    var width, scan, H, V, oddH, oddV, src, dest, last;var dY = this.currentY32,
        dCb = this.currentCb32,
        dCr = this.currentCr32;width = this.codedWidth;scan = width - 16;H = motionH >> 1;V = motionV >> 1;oddH = (motionH & 1) === 1;oddV = (motionV & 1) === 1;src = ((this.mbRow << 4) + V) * width + (this.mbCol << 4) + H;dest = this.mbRow * width + this.mbCol << 2;last = dest + (width << 2);var x, y1, y2, y;if (oddH) {
      if (oddV) {
        while (dest < last) {
          y1 = sY[src] + sY[src + width];src++;for (x = 0; x < 4; x++) {
            y2 = sY[src] + sY[src + width];src++;y = y1 + y2 + 2 >> 2 & 255;y1 = sY[src] + sY[src + width];src++;y |= y1 + y2 + 2 << 6 & 65280;y2 = sY[src] + sY[src + width];src++;y |= y1 + y2 + 2 << 14 & 16711680;y1 = sY[src] + sY[src + width];src++;y |= y1 + y2 + 2 << 22 & 4278190080;dY[dest++] = y;
          }dest += scan >> 2;src += scan - 1;
        }
      } else {
        while (dest < last) {
          y1 = sY[src++];for (x = 0; x < 4; x++) {
            y2 = sY[src++];y = y1 + y2 + 1 >> 1 & 255;y1 = sY[src++];y |= y1 + y2 + 1 << 7 & 65280;y2 = sY[src++];y |= y1 + y2 + 1 << 15 & 16711680;y1 = sY[src++];y |= y1 + y2 + 1 << 23 & 4278190080;dY[dest++] = y;
          }dest += scan >> 2;src += scan - 1;
        }
      }
    } else {
      if (oddV) {
        while (dest < last) {
          for (x = 0; x < 4; x++) {
            y = sY[src] + sY[src + width] + 1 >> 1 & 255;src++;y |= sY[src] + sY[src + width] + 1 << 7 & 65280;src++;y |= sY[src] + sY[src + width] + 1 << 15 & 16711680;src++;y |= sY[src] + sY[src + width] + 1 << 23 & 4278190080;src++;dY[dest++] = y;
          }dest += scan >> 2;src += scan;
        }
      } else {
        while (dest < last) {
          for (x = 0; x < 4; x++) {
            y = sY[src];src++;y |= sY[src] << 8;src++;y |= sY[src] << 16;src++;y |= sY[src] << 24;src++;dY[dest++] = y;
          }dest += scan >> 2;src += scan;
        }
      }
    }width = this.halfWidth;scan = width - 8;H = motionH / 2 >> 1;V = motionV / 2 >> 1;oddH = (motionH / 2 & 1) === 1;oddV = (motionV / 2 & 1) === 1;src = ((this.mbRow << 3) + V) * width + (this.mbCol << 3) + H;dest = this.mbRow * width + this.mbCol << 1;last = dest + (width << 1);var cr1, cr2, cr, cb1, cb2, cb;if (oddH) {
      if (oddV) {
        while (dest < last) {
          cr1 = sCr[src] + sCr[src + width];cb1 = sCb[src] + sCb[src + width];src++;for (x = 0; x < 2; x++) {
            cr2 = sCr[src] + sCr[src + width];cb2 = sCb[src] + sCb[src + width];src++;cr = cr1 + cr2 + 2 >> 2 & 255;cb = cb1 + cb2 + 2 >> 2 & 255;cr1 = sCr[src] + sCr[src + width];cb1 = sCb[src] + sCb[src + width];src++;cr |= cr1 + cr2 + 2 << 6 & 65280;cb |= cb1 + cb2 + 2 << 6 & 65280;cr2 = sCr[src] + sCr[src + width];cb2 = sCb[src] + sCb[src + width];src++;cr |= cr1 + cr2 + 2 << 14 & 16711680;cb |= cb1 + cb2 + 2 << 14 & 16711680;cr1 = sCr[src] + sCr[src + width];cb1 = sCb[src] + sCb[src + width];src++;cr |= cr1 + cr2 + 2 << 22 & 4278190080;cb |= cb1 + cb2 + 2 << 22 & 4278190080;dCr[dest] = cr;dCb[dest] = cb;dest++;
          }dest += scan >> 2;src += scan - 1;
        }
      } else {
        while (dest < last) {
          cr1 = sCr[src];cb1 = sCb[src];src++;for (x = 0; x < 2; x++) {
            cr2 = sCr[src];cb2 = sCb[src++];cr = cr1 + cr2 + 1 >> 1 & 255;cb = cb1 + cb2 + 1 >> 1 & 255;cr1 = sCr[src];cb1 = sCb[src++];cr |= cr1 + cr2 + 1 << 7 & 65280;cb |= cb1 + cb2 + 1 << 7 & 65280;cr2 = sCr[src];cb2 = sCb[src++];cr |= cr1 + cr2 + 1 << 15 & 16711680;cb |= cb1 + cb2 + 1 << 15 & 16711680;cr1 = sCr[src];cb1 = sCb[src++];cr |= cr1 + cr2 + 1 << 23 & 4278190080;cb |= cb1 + cb2 + 1 << 23 & 4278190080;dCr[dest] = cr;dCb[dest] = cb;dest++;
          }dest += scan >> 2;src += scan - 1;
        }
      }
    } else {
      if (oddV) {
        while (dest < last) {
          for (x = 0; x < 2; x++) {
            cr = sCr[src] + sCr[src + width] + 1 >> 1 & 255;cb = sCb[src] + sCb[src + width] + 1 >> 1 & 255;src++;cr |= sCr[src] + sCr[src + width] + 1 << 7 & 65280;cb |= sCb[src] + sCb[src + width] + 1 << 7 & 65280;src++;cr |= sCr[src] + sCr[src + width] + 1 << 15 & 16711680;cb |= sCb[src] + sCb[src + width] + 1 << 15 & 16711680;src++;cr |= sCr[src] + sCr[src + width] + 1 << 23 & 4278190080;cb |= sCb[src] + sCb[src + width] + 1 << 23 & 4278190080;src++;dCr[dest] = cr;dCb[dest] = cb;dest++;
          }dest += scan >> 2;src += scan;
        }
      } else {
        while (dest < last) {
          for (x = 0; x < 2; x++) {
            cr = sCr[src];cb = sCb[src];src++;cr |= sCr[src] << 8;cb |= sCb[src] << 8;src++;cr |= sCr[src] << 16;cb |= sCb[src] << 16;src++;cr |= sCr[src] << 24;cb |= sCb[src] << 24;src++;dCr[dest] = cr;dCb[dest] = cb;dest++;
          }dest += scan >> 2;src += scan;
        }
      }
    }
  };MPEG1.prototype.dcPredictorY = 0;MPEG1.prototype.dcPredictorCr = 0;MPEG1.prototype.dcPredictorCb = 0;MPEG1.prototype.blockData = null;MPEG1.prototype.decodeBlock = function (block) {
    var n = 0,
        quantMatrix;if (this.macroblockIntra) {
      var predictor, dctSize;if (block < 4) {
        predictor = this.dcPredictorY;dctSize = this.readHuffman(MPEG1.DCT_DC_SIZE_LUMINANCE);
      } else {
        predictor = block === 4 ? this.dcPredictorCr : this.dcPredictorCb;dctSize = this.readHuffman(MPEG1.DCT_DC_SIZE_CHROMINANCE);
      }if (dctSize > 0) {
        var differential = this.bits.read(dctSize);if ((differential & 1 << dctSize - 1) !== 0) {
          this.blockData[0] = predictor + differential;
        } else {
          this.blockData[0] = predictor + (-1 << dctSize | differential + 1);
        }
      } else {
        this.blockData[0] = predictor;
      }if (block < 4) {
        this.dcPredictorY = this.blockData[0];
      } else if (block === 4) {
        this.dcPredictorCr = this.blockData[0];
      } else {
        this.dcPredictorCb = this.blockData[0];
      }this.blockData[0] <<= 3 + 5;quantMatrix = this.intraQuantMatrix;n = 1;
    } else {
      quantMatrix = this.nonIntraQuantMatrix;
    }var level = 0;while (true) {
      var run = 0,
          coeff = this.readHuffman(MPEG1.DCT_COEFF);if (coeff === 1 && n > 0 && this.bits.read(1) === 0) {
        break;
      }if (coeff === 65535) {
        run = this.bits.read(6);level = this.bits.read(8);if (level === 0) {
          level = this.bits.read(8);
        } else if (level === 128) {
          level = this.bits.read(8) - 256;
        } else if (level > 128) {
          level = level - 256;
        }
      } else {
        run = coeff >> 8;level = coeff & 255;if (this.bits.read(1)) {
          level = -level;
        }
      }n += run;var dezigZagged = MPEG1.ZIG_ZAG[n];n++;level <<= 1;if (!this.macroblockIntra) {
        level += level < 0 ? -1 : 1;
      }level = level * this.quantizerScale * quantMatrix[dezigZagged] >> 4;if ((level & 1) === 0) {
        level -= level > 0 ? 1 : -1;
      }if (level > 2047) {
        level = 2047;
      } else if (level < -2048) {
        level = -2048;
      }this.blockData[dezigZagged] = level * MPEG1.PREMULTIPLIER_MATRIX[dezigZagged];
    }var destArray, destIndex, scan;if (block < 4) {
      destArray = this.currentY;scan = this.codedWidth - 8;destIndex = this.mbRow * this.codedWidth + this.mbCol << 4;if ((block & 1) !== 0) {
        destIndex += 8;
      }if ((block & 2) !== 0) {
        destIndex += this.codedWidth << 3;
      }
    } else {
      destArray = block === 4 ? this.currentCb : this.currentCr;scan = (this.codedWidth >> 1) - 8;destIndex = (this.mbRow * this.codedWidth << 2) + (this.mbCol << 3);
    }if (this.macroblockIntra) {
      if (n === 1) {
        MPEG1.CopyValueToDestination(this.blockData[0] + 128 >> 8, destArray, destIndex, scan);this.blockData[0] = 0;
      } else {
        MPEG1.IDCT(this.blockData);MPEG1.CopyBlockToDestination(this.blockData, destArray, destIndex, scan);JSMpeg.Fill(this.blockData, 0);
      }
    } else {
      if (n === 1) {
        MPEG1.AddValueToDestination(this.blockData[0] + 128 >> 8, destArray, destIndex, scan);this.blockData[0] = 0;
      } else {
        MPEG1.IDCT(this.blockData);MPEG1.AddBlockToDestination(this.blockData, destArray, destIndex, scan);JSMpeg.Fill(this.blockData, 0);
      }
    }n = 0;
  };MPEG1.CopyBlockToDestination = function (block, dest, index, scan) {
    for (var n = 0; n < 64; n += 8, index += scan + 8) {
      dest[index + 0] = block[n + 0];dest[index + 1] = block[n + 1];dest[index + 2] = block[n + 2];dest[index + 3] = block[n + 3];dest[index + 4] = block[n + 4];dest[index + 5] = block[n + 5];dest[index + 6] = block[n + 6];dest[index + 7] = block[n + 7];
    }
  };MPEG1.AddBlockToDestination = function (block, dest, index, scan) {
    for (var n = 0; n < 64; n += 8, index += scan + 8) {
      dest[index + 0] += block[n + 0];dest[index + 1] += block[n + 1];dest[index + 2] += block[n + 2];dest[index + 3] += block[n + 3];dest[index + 4] += block[n + 4];dest[index + 5] += block[n + 5];dest[index + 6] += block[n + 6];dest[index + 7] += block[n + 7];
    }
  };MPEG1.CopyValueToDestination = function (value, dest, index, scan) {
    for (var n = 0; n < 64; n += 8, index += scan + 8) {
      dest[index + 0] = value;dest[index + 1] = value;dest[index + 2] = value;dest[index + 3] = value;dest[index + 4] = value;dest[index + 5] = value;dest[index + 6] = value;dest[index + 7] = value;
    }
  };MPEG1.AddValueToDestination = function (value, dest, index, scan) {
    for (var n = 0; n < 64; n += 8, index += scan + 8) {
      dest[index + 0] += value;dest[index + 1] += value;dest[index + 2] += value;dest[index + 3] += value;dest[index + 4] += value;dest[index + 5] += value;dest[index + 6] += value;dest[index + 7] += value;
    }
  };MPEG1.IDCT = function (block) {
    var b1, b3, b4, b6, b7, tmp1, tmp2, m0, x0, x1, x2, x3, x4, y3, y4, y5, y6, y7;for (var i = 0; i < 8; ++i) {
      b1 = block[4 * 8 + i];b3 = block[2 * 8 + i] + block[6 * 8 + i];b4 = block[5 * 8 + i] - block[3 * 8 + i];tmp1 = block[1 * 8 + i] + block[7 * 8 + i];tmp2 = block[3 * 8 + i] + block[5 * 8 + i];b6 = block[1 * 8 + i] - block[7 * 8 + i];b7 = tmp1 + tmp2;m0 = block[0 * 8 + i];x4 = (b6 * 473 - b4 * 196 + 128 >> 8) - b7;x0 = x4 - ((tmp1 - tmp2) * 362 + 128 >> 8);x1 = m0 - b1;x2 = ((block[2 * 8 + i] - block[6 * 8 + i]) * 362 + 128 >> 8) - b3;x3 = m0 + b1;y3 = x1 + x2;y4 = x3 + b3;y5 = x1 - x2;y6 = x3 - b3;y7 = -x0 - (b4 * 473 + b6 * 196 + 128 >> 8);block[0 * 8 + i] = b7 + y4;block[1 * 8 + i] = x4 + y3;block[2 * 8 + i] = y5 - x0;block[3 * 8 + i] = y6 - y7;block[4 * 8 + i] = y6 + y7;block[5 * 8 + i] = x0 + y5;block[6 * 8 + i] = y3 - x4;block[7 * 8 + i] = y4 - b7;
    }for (var i = 0; i < 64; i += 8) {
      b1 = block[4 + i];b3 = block[2 + i] + block[6 + i];b4 = block[5 + i] - block[3 + i];tmp1 = block[1 + i] + block[7 + i];tmp2 = block[3 + i] + block[5 + i];b6 = block[1 + i] - block[7 + i];b7 = tmp1 + tmp2;m0 = block[0 + i];x4 = (b6 * 473 - b4 * 196 + 128 >> 8) - b7;x0 = x4 - ((tmp1 - tmp2) * 362 + 128 >> 8);x1 = m0 - b1;x2 = ((block[2 + i] - block[6 + i]) * 362 + 128 >> 8) - b3;x3 = m0 + b1;y3 = x1 + x2;y4 = x3 + b3;y5 = x1 - x2;y6 = x3 - b3;y7 = -x0 - (b4 * 473 + b6 * 196 + 128 >> 8);block[0 + i] = b7 + y4 + 128 >> 8;block[1 + i] = x4 + y3 + 128 >> 8;block[2 + i] = y5 - x0 + 128 >> 8;block[3 + i] = y6 - y7 + 128 >> 8;block[4 + i] = y6 + y7 + 128 >> 8;block[5 + i] = x0 + y5 + 128 >> 8;block[6 + i] = y3 - x4 + 128 >> 8;block[7 + i] = y4 - b7 + 128 >> 8;
    }
  };MPEG1.PICTURE_RATE = [0, 23.976, 24, 25, 29.97, 30, 50, 59.94, 60, 0, 0, 0, 0, 0, 0, 0];MPEG1.ZIG_ZAG = new Uint8Array([0, 1, 8, 16, 9, 2, 3, 10, 17, 24, 32, 25, 18, 11, 4, 5, 12, 19, 26, 33, 40, 48, 41, 34, 27, 20, 13, 6, 7, 14, 21, 28, 35, 42, 49, 56, 57, 50, 43, 36, 29, 22, 15, 23, 30, 37, 44, 51, 58, 59, 52, 45, 38, 31, 39, 46, 53, 60, 61, 54, 47, 55, 62, 63]);MPEG1.DEFAULT_INTRA_QUANT_MATRIX = new Uint8Array([8, 16, 19, 22, 26, 27, 29, 34, 16, 16, 22, 24, 27, 29, 34, 37, 19, 22, 26, 27, 29, 34, 34, 38, 22, 22, 26, 27, 29, 34, 37, 40, 22, 26, 27, 29, 32, 35, 40, 48, 26, 27, 29, 32, 35, 40, 48, 58, 26, 27, 29, 34, 38, 46, 56, 69, 27, 29, 35, 38, 46, 56, 69, 83]);MPEG1.DEFAULT_NON_INTRA_QUANT_MATRIX = new Uint8Array([16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16]);MPEG1.PREMULTIPLIER_MATRIX = new Uint8Array([32, 44, 42, 38, 32, 25, 17, 9, 44, 62, 58, 52, 44, 35, 24, 12, 42, 58, 55, 49, 42, 33, 23, 12, 38, 52, 49, 44, 38, 30, 20, 10, 32, 44, 42, 38, 32, 25, 17, 9, 25, 35, 33, 30, 25, 20, 14, 7, 17, 24, 23, 20, 17, 14, 9, 5, 9, 12, 12, 10, 9, 7, 5, 2]);MPEG1.MACROBLOCK_ADDRESS_INCREMENT = new Int16Array([1 * 3, 2 * 3, 0, 3 * 3, 4 * 3, 0, 0, 0, 1, 5 * 3, 6 * 3, 0, 7 * 3, 8 * 3, 0, 9 * 3, 10 * 3, 0, 11 * 3, 12 * 3, 0, 0, 0, 3, 0, 0, 2, 13 * 3, 14 * 3, 0, 15 * 3, 16 * 3, 0, 0, 0, 5, 0, 0, 4, 17 * 3, 18 * 3, 0, 19 * 3, 20 * 3, 0, 0, 0, 7, 0, 0, 6, 21 * 3, 22 * 3, 0, 23 * 3, 24 * 3, 0, 25 * 3, 26 * 3, 0, 27 * 3, 28 * 3, 0, -1, 29 * 3, 0, -1, 30 * 3, 0, 31 * 3, 32 * 3, 0, 33 * 3, 34 * 3, 0, 35 * 3, 36 * 3, 0, 37 * 3, 38 * 3, 0, 0, 0, 9, 0, 0, 8, 39 * 3, 40 * 3, 0, 41 * 3, 42 * 3, 0, 43 * 3, 44 * 3, 0, 45 * 3, 46 * 3, 0, 0, 0, 15, 0, 0, 14, 0, 0, 13, 0, 0, 12, 0, 0, 11, 0, 0, 10, 47 * 3, -1, 0, -1, 48 * 3, 0, 49 * 3, 50 * 3, 0, 51 * 3, 52 * 3, 0, 53 * 3, 54 * 3, 0, 55 * 3, 56 * 3, 0, 57 * 3, 58 * 3, 0, 59 * 3, 60 * 3, 0, 61 * 3, -1, 0, -1, 62 * 3, 0, 63 * 3, 64 * 3, 0, 65 * 3, 66 * 3, 0, 67 * 3, 68 * 3, 0, 69 * 3, 70 * 3, 0, 71 * 3, 72 * 3, 0, 73 * 3, 74 * 3, 0, 0, 0, 21, 0, 0, 20, 0, 0, 19, 0, 0, 18, 0, 0, 17, 0, 0, 16, 0, 0, 35, 0, 0, 34, 0, 0, 33, 0, 0, 32, 0, 0, 31, 0, 0, 30, 0, 0, 29, 0, 0, 28, 0, 0, 27, 0, 0, 26, 0, 0, 25, 0, 0, 24, 0, 0, 23, 0, 0, 22]);MPEG1.MACROBLOCK_TYPE_INTRA = new Int8Array([1 * 3, 2 * 3, 0, -1, 3 * 3, 0, 0, 0, 1, 0, 0, 17]);MPEG1.MACROBLOCK_TYPE_PREDICTIVE = new Int8Array([1 * 3, 2 * 3, 0, 3 * 3, 4 * 3, 0, 0, 0, 10, 5 * 3, 6 * 3, 0, 0, 0, 2, 7 * 3, 8 * 3, 0, 0, 0, 8, 9 * 3, 10 * 3, 0, 11 * 3, 12 * 3, 0, -1, 13 * 3, 0, 0, 0, 18, 0, 0, 26, 0, 0, 1, 0, 0, 17]);MPEG1.MACROBLOCK_TYPE_B = new Int8Array([1 * 3, 2 * 3, 0, 3 * 3, 5 * 3, 0, 4 * 3, 6 * 3, 0, 8 * 3, 7 * 3, 0, 0, 0, 12, 9 * 3, 10 * 3, 0, 0, 0, 14, 13 * 3, 14 * 3, 0, 12 * 3, 11 * 3, 0, 0, 0, 4, 0, 0, 6, 18 * 3, 16 * 3, 0, 15 * 3, 17 * 3, 0, 0, 0, 8, 0, 0, 10, -1, 19 * 3, 0, 0, 0, 1, 20 * 3, 21 * 3, 0, 0, 0, 30, 0, 0, 17, 0, 0, 22, 0, 0, 26]);MPEG1.MACROBLOCK_TYPE = [null, MPEG1.MACROBLOCK_TYPE_INTRA, MPEG1.MACROBLOCK_TYPE_PREDICTIVE, MPEG1.MACROBLOCK_TYPE_B];MPEG1.CODE_BLOCK_PATTERN = new Int16Array([2 * 3, 1 * 3, 0, 3 * 3, 6 * 3, 0, 4 * 3, 5 * 3, 0, 8 * 3, 11 * 3, 0, 12 * 3, 13 * 3, 0, 9 * 3, 7 * 3, 0, 10 * 3, 14 * 3, 0, 20 * 3, 19 * 3, 0, 18 * 3, 16 * 3, 0, 23 * 3, 17 * 3, 0, 27 * 3, 25 * 3, 0, 21 * 3, 28 * 3, 0, 15 * 3, 22 * 3, 0, 24 * 3, 26 * 3, 0, 0, 0, 60, 35 * 3, 40 * 3, 0, 44 * 3, 48 * 3, 0, 38 * 3, 36 * 3, 0, 42 * 3, 47 * 3, 0, 29 * 3, 31 * 3, 0, 39 * 3, 32 * 3, 0, 0, 0, 32, 45 * 3, 46 * 3, 0, 33 * 3, 41 * 3, 0, 43 * 3, 34 * 3, 0, 0, 0, 4, 30 * 3, 37 * 3, 0, 0, 0, 8, 0, 0, 16, 0, 0, 44, 50 * 3, 56 * 3, 0, 0, 0, 28, 0, 0, 52, 0, 0, 62, 61 * 3, 59 * 3, 0, 52 * 3, 60 * 3, 0, 0, 0, 1, 55 * 3, 54 * 3, 0, 0, 0, 61, 0, 0, 56, 57 * 3, 58 * 3, 0, 0, 0, 2, 0, 0, 40, 51 * 3, 62 * 3, 0, 0, 0, 48, 64 * 3, 63 * 3, 0, 49 * 3, 53 * 3, 0, 0, 0, 20, 0, 0, 12, 80 * 3, 83 * 3, 0, 0, 0, 63, 77 * 3, 75 * 3, 0, 65 * 3, 73 * 3, 0, 84 * 3, 66 * 3, 0, 0, 0, 24, 0, 0, 36, 0, 0, 3, 69 * 3, 87 * 3, 0, 81 * 3, 79 * 3, 0, 68 * 3, 71 * 3, 0, 70 * 3, 78 * 3, 0, 67 * 3, 76 * 3, 0, 72 * 3, 74 * 3, 0, 86 * 3, 85 * 3, 0, 88 * 3, 82 * 3, 0, -1, 94 * 3, 0, 95 * 3, 97 * 3, 0, 0, 0, 33, 0, 0, 9, 106 * 3, 110 * 3, 0, 102 * 3, 116 * 3, 0, 0, 0, 5, 0, 0, 10, 93 * 3, 89 * 3, 0, 0, 0, 6, 0, 0, 18, 0, 0, 17, 0, 0, 34, 113 * 3, 119 * 3, 0, 103 * 3, 104 * 3, 0, 90 * 3, 92 * 3, 0, 109 * 3, 107 * 3, 0, 117 * 3, 118 * 3, 0, 101 * 3, 99 * 3, 0, 98 * 3, 96 * 3, 0, 100 * 3, 91 * 3, 0, 114 * 3, 115 * 3, 0, 105 * 3, 108 * 3, 0, 112 * 3, 111 * 3, 0, 121 * 3, 125 * 3, 0, 0, 0, 41, 0, 0, 14, 0, 0, 21, 124 * 3, 122 * 3, 0, 120 * 3, 123 * 3, 0, 0, 0, 11, 0, 0, 19, 0, 0, 7, 0, 0, 35, 0, 0, 13, 0, 0, 50, 0, 0, 49, 0, 0, 58, 0, 0, 37, 0, 0, 25, 0, 0, 45, 0, 0, 57, 0, 0, 26, 0, 0, 29, 0, 0, 38, 0, 0, 53, 0, 0, 23, 0, 0, 43, 0, 0, 46, 0, 0, 42, 0, 0, 22, 0, 0, 54, 0, 0, 51, 0, 0, 15, 0, 0, 30, 0, 0, 39, 0, 0, 47, 0, 0, 55, 0, 0, 27, 0, 0, 59, 0, 0, 31]);MPEG1.MOTION = new Int16Array([1 * 3, 2 * 3, 0, 4 * 3, 3 * 3, 0, 0, 0, 0, 6 * 3, 5 * 3, 0, 8 * 3, 7 * 3, 0, 0, 0, -1, 0, 0, 1, 9 * 3, 10 * 3, 0, 12 * 3, 11 * 3, 0, 0, 0, 2, 0, 0, -2, 14 * 3, 15 * 3, 0, 16 * 3, 13 * 3, 0, 20 * 3, 18 * 3, 0, 0, 0, 3, 0, 0, -3, 17 * 3, 19 * 3, 0, -1, 23 * 3, 0, 27 * 3, 25 * 3, 0, 26 * 3, 21 * 3, 0, 24 * 3, 22 * 3, 0, 32 * 3, 28 * 3, 0, 29 * 3, 31 * 3, 0, -1, 33 * 3, 0, 36 * 3, 35 * 3, 0, 0, 0, -4, 30 * 3, 34 * 3, 0, 0, 0, 4, 0, 0, -7, 0, 0, 5, 37 * 3, 41 * 3, 0, 0, 0, -5, 0, 0, 7, 38 * 3, 40 * 3, 0, 42 * 3, 39 * 3, 0, 0, 0, -6, 0, 0, 6, 51 * 3, 54 * 3, 0, 50 * 3, 49 * 3, 0, 45 * 3, 46 * 3, 0, 52 * 3, 47 * 3, 0, 43 * 3, 53 * 3, 0, 44 * 3, 48 * 3, 0, 0, 0, 10, 0, 0, 9, 0, 0, 8, 0, 0, -8, 57 * 3, 66 * 3, 0, 0, 0, -9, 60 * 3, 64 * 3, 0, 56 * 3, 61 * 3, 0, 55 * 3, 62 * 3, 0, 58 * 3, 63 * 3, 0, 0, 0, -10, 59 * 3, 65 * 3, 0, 0, 0, 12, 0, 0, 16, 0, 0, 13, 0, 0, 14, 0, 0, 11, 0, 0, 15, 0, 0, -16, 0, 0, -12, 0, 0, -14, 0, 0, -15, 0, 0, -11, 0, 0, -13]);MPEG1.DCT_DC_SIZE_LUMINANCE = new Int8Array([2 * 3, 1 * 3, 0, 6 * 3, 5 * 3, 0, 3 * 3, 4 * 3, 0, 0, 0, 1, 0, 0, 2, 9 * 3, 8 * 3, 0, 7 * 3, 10 * 3, 0, 0, 0, 0, 12 * 3, 11 * 3, 0, 0, 0, 4, 0, 0, 3, 13 * 3, 14 * 3, 0, 0, 0, 5, 0, 0, 6, 16 * 3, 15 * 3, 0, 17 * 3, -1, 0, 0, 0, 7, 0, 0, 8]);MPEG1.DCT_DC_SIZE_CHROMINANCE = new Int8Array([2 * 3, 1 * 3, 0, 4 * 3, 3 * 3, 0, 6 * 3, 5 * 3, 0, 8 * 3, 7 * 3, 0, 0, 0, 2, 0, 0, 1, 0, 0, 0, 10 * 3, 9 * 3, 0, 0, 0, 3, 12 * 3, 11 * 3, 0, 0, 0, 4, 14 * 3, 13 * 3, 0, 0, 0, 5, 16 * 3, 15 * 3, 0, 0, 0, 6, 17 * 3, -1, 0, 0, 0, 7, 0, 0, 8]);MPEG1.DCT_COEFF = new Int32Array([1 * 3, 2 * 3, 0, 4 * 3, 3 * 3, 0, 0, 0, 1, 7 * 3, 8 * 3, 0, 6 * 3, 5 * 3, 0, 13 * 3, 9 * 3, 0, 11 * 3, 10 * 3, 0, 14 * 3, 12 * 3, 0, 0, 0, 257, 20 * 3, 22 * 3, 0, 18 * 3, 21 * 3, 0, 16 * 3, 19 * 3, 0, 0, 0, 513, 17 * 3, 15 * 3, 0, 0, 0, 2, 0, 0, 3, 27 * 3, 25 * 3, 0, 29 * 3, 31 * 3, 0, 24 * 3, 26 * 3, 0, 32 * 3, 30 * 3, 0, 0, 0, 1025, 23 * 3, 28 * 3, 0, 0, 0, 769, 0, 0, 258, 0, 0, 1793, 0, 0, 65535, 0, 0, 1537, 37 * 3, 36 * 3, 0, 0, 0, 1281, 35 * 3, 34 * 3, 0, 39 * 3, 38 * 3, 0, 33 * 3, 42 * 3, 0, 40 * 3, 41 * 3, 0, 52 * 3, 50 * 3, 0, 54 * 3, 53 * 3, 0, 48 * 3, 49 * 3, 0, 43 * 3, 45 * 3, 0, 46 * 3, 44 * 3, 0, 0, 0, 2049, 0, 0, 4, 0, 0, 514, 0, 0, 2305, 51 * 3, 47 * 3, 0, 55 * 3, 57 * 3, 0, 60 * 3, 56 * 3, 0, 59 * 3, 58 * 3, 0, 61 * 3, 62 * 3, 0, 0, 0, 2561, 0, 0, 3329, 0, 0, 6, 0, 0, 259, 0, 0, 5, 0, 0, 770, 0, 0, 2817, 0, 0, 3073, 76 * 3, 75 * 3, 0, 67 * 3, 70 * 3, 0, 73 * 3, 71 * 3, 0, 78 * 3, 74 * 3, 0, 72 * 3, 77 * 3, 0, 69 * 3, 64 * 3, 0, 68 * 3, 63 * 3, 0, 66 * 3, 65 * 3, 0, 81 * 3, 87 * 3, 0, 91 * 3, 80 * 3, 0, 82 * 3, 79 * 3, 0, 83 * 3, 86 * 3, 0, 93 * 3, 92 * 3, 0, 84 * 3, 85 * 3, 0, 90 * 3, 94 * 3, 0, 88 * 3, 89 * 3, 0, 0, 0, 515, 0, 0, 260, 0, 0, 7, 0, 0, 1026, 0, 0, 1282, 0, 0, 4097, 0, 0, 3841, 0, 0, 3585, 105 * 3, 107 * 3, 0, 111 * 3, 114 * 3, 0, 104 * 3, 97 * 3, 0, 125 * 3, 119 * 3, 0, 96 * 3, 98 * 3, 0, -1, 123 * 3, 0, 95 * 3, 101 * 3, 0, 106 * 3, 121 * 3, 0, 99 * 3, 102 * 3, 0, 113 * 3, 103 * 3, 0, 112 * 3, 116 * 3, 0, 110 * 3, 100 * 3, 0, 124 * 3, 115 * 3, 0, 117 * 3, 122 * 3, 0, 109 * 3, 118 * 3, 0, 120 * 3, 108 * 3, 0, 127 * 3, 136 * 3, 0, 139 * 3, 140 * 3, 0, 130 * 3, 126 * 3, 0, 145 * 3, 146 * 3, 0, 128 * 3, 129 * 3, 0, 0, 0, 2050, 132 * 3, 134 * 3, 0, 155 * 3, 154 * 3, 0, 0, 0, 8, 137 * 3, 133 * 3, 0, 143 * 3, 144 * 3, 0, 151 * 3, 138 * 3, 0, 142 * 3, 141 * 3, 0, 0, 0, 10, 0, 0, 9, 0, 0, 11, 0, 0, 5377, 0, 0, 1538, 0, 0, 771, 0, 0, 5121, 0, 0, 1794, 0, 0, 4353, 0, 0, 4609, 0, 0, 4865, 148 * 3, 152 * 3, 0, 0, 0, 1027, 153 * 3, 150 * 3, 0, 0, 0, 261, 131 * 3, 135 * 3, 0, 0, 0, 516, 149 * 3, 147 * 3, 0, 172 * 3, 173 * 3, 0, 162 * 3, 158 * 3, 0, 170 * 3, 161 * 3, 0, 168 * 3, 166 * 3, 0, 157 * 3, 179 * 3, 0, 169 * 3, 167 * 3, 0, 174 * 3, 171 * 3, 0, 178 * 3, 177 * 3, 0, 156 * 3, 159 * 3, 0, 164 * 3, 165 * 3, 0, 183 * 3, 182 * 3, 0, 175 * 3, 176 * 3, 0, 0, 0, 263, 0, 0, 2562, 0, 0, 2306, 0, 0, 5633, 0, 0, 5889, 0, 0, 6401, 0, 0, 6145, 0, 0, 1283, 0, 0, 772, 0, 0, 13, 0, 0, 12, 0, 0, 14, 0, 0, 15, 0, 0, 517, 0, 0, 6657, 0, 0, 262, 180 * 3, 181 * 3, 0, 160 * 3, 163 * 3, 0, 196 * 3, 199 * 3, 0, 0, 0, 27, 203 * 3, 185 * 3, 0, 202 * 3, 201 * 3, 0, 0, 0, 19, 0, 0, 22, 197 * 3, 207 * 3, 0, 0, 0, 18, 191 * 3, 192 * 3, 0, 188 * 3, 190 * 3, 0, 0, 0, 20, 184 * 3, 194 * 3, 0, 0, 0, 21, 186 * 3, 193 * 3, 0, 0, 0, 23, 204 * 3, 198 * 3, 0, 0, 0, 25, 0, 0, 24, 200 * 3, 205 * 3, 0, 0, 0, 31, 0, 0, 30, 0, 0, 28, 0, 0, 29, 0, 0, 26, 0, 0, 17, 0, 0, 16, 189 * 3, 206 * 3, 0, 187 * 3, 195 * 3, 0, 218 * 3, 211 * 3, 0, 0, 0, 37, 215 * 3, 216 * 3, 0, 0, 0, 36, 210 * 3, 212 * 3, 0, 0, 0, 34, 213 * 3, 209 * 3, 0, 221 * 3, 222 * 3, 0, 219 * 3, 208 * 3, 0, 217 * 3, 214 * 3, 0, 223 * 3, 220 * 3, 0, 0, 0, 35, 0, 0, 267, 0, 0, 40, 0, 0, 268, 0, 0, 266, 0, 0, 32, 0, 0, 264, 0, 0, 265, 0, 0, 38, 0, 0, 269, 0, 0, 270, 0, 0, 33, 0, 0, 39, 0, 0, 7937, 0, 0, 6913, 0, 0, 7681, 0, 0, 4098, 0, 0, 7425, 0, 0, 7169, 0, 0, 271, 0, 0, 274, 0, 0, 273, 0, 0, 272, 0, 0, 1539, 0, 0, 2818, 0, 0, 3586, 0, 0, 3330, 0, 0, 3074, 0, 0, 3842]);MPEG1.PICTURE_TYPE = { INTRA: 1, PREDICTIVE: 2, B: 3 };MPEG1.START = { SEQUENCE: 179, SLICE_FIRST: 1, SLICE_LAST: 175, PICTURE: 0, EXTENSION: 181, USER_DATA: 178 };return MPEG1;
}();JSMpeg.Decoder.MPEG1VideoWASM = function () {
  "use strict";

  var MPEG1WASM = function MPEG1WASM(options) {
    JSMpeg.Decoder.Base.call(this, options);this.onDecodeCallback = options.onVideoDecode;this.module = options.wasmModule;this.bufferSize = options.videoBufferSize || 512 * 1024;this.bufferMode = options.streaming ? JSMpeg.BitBuffer.MODE.EVICT : JSMpeg.BitBuffer.MODE.EXPAND;this.decodeFirstFrame = options.decodeFirstFrame !== false;this.hasSequenceHeader = false;
  };MPEG1WASM.prototype = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default()(JSMpeg.Decoder.Base.prototype);MPEG1WASM.prototype.constructor = MPEG1WASM;MPEG1WASM.prototype.initializeWasmDecoder = function () {
    if (!this.module.instance) {
      console.warn("JSMpeg: WASM module not compiled yet");return;
    }this.instance = this.module.instance;this.functions = this.module.instance.exports;this.decoder = this.functions._mpeg1_decoder_create(this.bufferSize, this.bufferMode);
  };MPEG1WASM.prototype.destroy = function () {
    if (!this.decoder) {
      return;
    }this.functions._mpeg1_decoder_destroy(this.decoder);
  };MPEG1WASM.prototype.bufferGetIndex = function () {
    if (!this.decoder) {
      return;
    }return this.functions._mpeg1_decoder_get_index(this.decoder);
  };MPEG1WASM.prototype.bufferSetIndex = function (index) {
    if (!this.decoder) {
      return;
    }this.functions._mpeg1_decoder_set_index(this.decoder, index);
  };MPEG1WASM.prototype.bufferWrite = function (buffers) {
    if (!this.decoder) {
      this.initializeWasmDecoder();
    }var totalLength = 0;for (var i = 0; i < buffers.length; i++) {
      totalLength += buffers[i].length;
    }var ptr = this.functions._mpeg1_decoder_get_write_ptr(this.decoder, totalLength);for (var i = 0; i < buffers.length; i++) {
      this.instance.heapU8.set(buffers[i], ptr);ptr += buffers[i].length;
    }this.functions._mpeg1_decoder_did_write(this.decoder, totalLength);return totalLength;
  };MPEG1WASM.prototype.write = function (pts, buffers) {
    JSMpeg.Decoder.Base.prototype.write.call(this, pts, buffers);if (!this.hasSequenceHeader && this.functions._mpeg1_decoder_has_sequence_header(this.decoder)) {
      this.loadSequenceHeader();
    }
  };MPEG1WASM.prototype.loadSequenceHeader = function () {
    this.hasSequenceHeader = true;this.frameRate = this.functions._mpeg1_decoder_get_frame_rate(this.decoder);this.codedSize = this.functions._mpeg1_decoder_get_coded_size(this.decoder);if (this.destination) {
      var w = this.functions._mpeg1_decoder_get_width(this.decoder);var h = this.functions._mpeg1_decoder_get_height(this.decoder);this.destination.resize(w, h);
    }if (this.decodeFirstFrame) {
      this.decode();
    }
  };MPEG1WASM.prototype.decode = function () {
    var startTime = JSMpeg.Now();if (!this.decoder) {
      return false;
    }var didDecode = this.functions._mpeg1_decoder_decode(this.decoder);if (!didDecode) {
      return false;
    }if (this.destination) {
      var ptrY = this.functions._mpeg1_decoder_get_y_ptr(this.decoder),
          ptrCr = this.functions._mpeg1_decoder_get_cr_ptr(this.decoder),
          ptrCb = this.functions._mpeg1_decoder_get_cb_ptr(this.decoder);var dy = this.instance.heapU8.subarray(ptrY, ptrY + this.codedSize);var dcr = this.instance.heapU8.subarray(ptrCr, ptrCr + (this.codedSize >> 2));var dcb = this.instance.heapU8.subarray(ptrCb, ptrCb + (this.codedSize >> 2));this.destination.render(dy, dcr, dcb, false);
    }this.advanceDecodedTime(1 / this.frameRate);var elapsedTime = JSMpeg.Now() - startTime;if (this.onDecodeCallback) {
      this.onDecodeCallback(this, elapsedTime);
    }return true;
  };return MPEG1WASM;
}();JSMpeg.Decoder.MP2Audio = function () {
  "use strict";

  var MP2 = function MP2(options) {
    JSMpeg.Decoder.Base.call(this, options);this.onDecodeCallback = options.onAudioDecode;var bufferSize = options.audioBufferSize || 128 * 1024;var bufferMode = options.streaming ? JSMpeg.BitBuffer.MODE.EVICT : JSMpeg.BitBuffer.MODE.EXPAND;this.bits = new JSMpeg.BitBuffer(bufferSize, bufferMode);this.left = new Float32Array(1152);this.right = new Float32Array(1152);this.sampleRate = 44100;this.D = new Float32Array(1024);this.D.set(MP2.SYNTHESIS_WINDOW, 0);this.D.set(MP2.SYNTHESIS_WINDOW, 512);this.V = [new Float32Array(1024), new Float32Array(1024)];this.U = new Int32Array(32);this.VPos = 0;this.allocation = [new Array(32), new Array(32)];this.scaleFactorInfo = [new Uint8Array(32), new Uint8Array(32)];this.scaleFactor = [new Array(32), new Array(32)];this.sample = [new Array(32), new Array(32)];for (var j = 0; j < 2; j++) {
      for (var i = 0; i < 32; i++) {
        this.scaleFactor[j][i] = [0, 0, 0];this.sample[j][i] = [0, 0, 0];
      }
    }
  };MP2.prototype = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default()(JSMpeg.Decoder.Base.prototype);MP2.prototype.constructor = MP2;MP2.prototype.decode = function () {
    var startTime = JSMpeg.Now();var pos = this.bits.index >> 3;if (pos >= this.bits.byteLength) {
      return false;
    }var decoded = this.decodeFrame(this.left, this.right);this.bits.index = pos + decoded << 3;if (!decoded) {
      return false;
    }if (this.destination) {
      this.destination.play(this.sampleRate, this.left, this.right);
    }this.advanceDecodedTime(this.left.length / this.sampleRate);var elapsedTime = JSMpeg.Now() - startTime;if (this.onDecodeCallback) {
      this.onDecodeCallback(this, elapsedTime);
    }return true;
  };MP2.prototype.getCurrentTime = function () {
    var enqueuedTime = this.destination ? this.destination.enqueuedTime : 0;return this.decodedTime - enqueuedTime;
  };MP2.prototype.decodeFrame = function (left, right) {
    var sync = this.bits.read(11),
        version = this.bits.read(2),
        layer = this.bits.read(2),
        hasCRC = !this.bits.read(1);if (sync !== MP2.FRAME_SYNC || version !== MP2.VERSION.MPEG_1 || layer !== MP2.LAYER.II) {
      return 0;
    }var bitrateIndex = this.bits.read(4) - 1;if (bitrateIndex > 13) {
      return 0;
    }var sampleRateIndex = this.bits.read(2);var sampleRate = MP2.SAMPLE_RATE[sampleRateIndex];if (sampleRateIndex === 3) {
      return 0;
    }if (version === MP2.VERSION.MPEG_2) {
      sampleRateIndex += 4;bitrateIndex += 14;
    }var padding = this.bits.read(1),
        privat = this.bits.read(1),
        mode = this.bits.read(2);var bound = 0;if (mode === MP2.MODE.JOINT_STEREO) {
      bound = this.bits.read(2) + 1 << 2;
    } else {
      this.bits.skip(2);bound = mode === MP2.MODE.MONO ? 0 : 32;
    }this.bits.skip(4);if (hasCRC) {
      this.bits.skip(16);
    }var bitrate = MP2.BIT_RATE[bitrateIndex],
        sampleRate = MP2.SAMPLE_RATE[sampleRateIndex],
        frameSize = 144e3 * bitrate / sampleRate + padding | 0;var tab3 = 0;var sblimit = 0;if (version === MP2.VERSION.MPEG_2) {
      tab3 = 2;sblimit = 30;
    } else {
      var tab1 = mode === MP2.MODE.MONO ? 0 : 1;var tab2 = MP2.QUANT_LUT_STEP_1[tab1][bitrateIndex];tab3 = MP2.QUANT_LUT_STEP_2[tab2][sampleRateIndex];sblimit = tab3 & 63;tab3 >>= 6;
    }if (bound > sblimit) {
      bound = sblimit;
    }for (var sb = 0; sb < bound; sb++) {
      this.allocation[0][sb] = this.readAllocation(sb, tab3);this.allocation[1][sb] = this.readAllocation(sb, tab3);
    }for (var sb = bound; sb < sblimit; sb++) {
      this.allocation[0][sb] = this.allocation[1][sb] = this.readAllocation(sb, tab3);
    }var channels = mode === MP2.MODE.MONO ? 1 : 2;for (var sb = 0; sb < sblimit; sb++) {
      for (ch = 0; ch < channels; ch++) {
        if (this.allocation[ch][sb]) {
          this.scaleFactorInfo[ch][sb] = this.bits.read(2);
        }
      }if (mode === MP2.MODE.MONO) {
        this.scaleFactorInfo[1][sb] = this.scaleFactorInfo[0][sb];
      }
    }for (var sb = 0; sb < sblimit; sb++) {
      for (var ch = 0; ch < channels; ch++) {
        if (this.allocation[ch][sb]) {
          var sf = this.scaleFactor[ch][sb];switch (this.scaleFactorInfo[ch][sb]) {case 0:
              sf[0] = this.bits.read(6);sf[1] = this.bits.read(6);sf[2] = this.bits.read(6);break;case 1:
              sf[0] = sf[1] = this.bits.read(6);sf[2] = this.bits.read(6);break;case 2:
              sf[0] = sf[1] = sf[2] = this.bits.read(6);break;case 3:
              sf[0] = this.bits.read(6);sf[1] = sf[2] = this.bits.read(6);break;}
        }
      }if (mode === MP2.MODE.MONO) {
        this.scaleFactor[1][sb][0] = this.scaleFactor[0][sb][0];this.scaleFactor[1][sb][1] = this.scaleFactor[0][sb][1];this.scaleFactor[1][sb][2] = this.scaleFactor[0][sb][2];
      }
    }var outPos = 0;for (var part = 0; part < 3; part++) {
      for (var granule = 0; granule < 4; granule++) {
        for (var sb = 0; sb < bound; sb++) {
          this.readSamples(0, sb, part);this.readSamples(1, sb, part);
        }for (var sb = bound; sb < sblimit; sb++) {
          this.readSamples(0, sb, part);this.sample[1][sb][0] = this.sample[0][sb][0];this.sample[1][sb][1] = this.sample[0][sb][1];this.sample[1][sb][2] = this.sample[0][sb][2];
        }for (var sb = sblimit; sb < 32; sb++) {
          this.sample[0][sb][0] = 0;this.sample[0][sb][1] = 0;this.sample[0][sb][2] = 0;this.sample[1][sb][0] = 0;this.sample[1][sb][1] = 0;this.sample[1][sb][2] = 0;
        }for (var p = 0; p < 3; p++) {
          this.VPos = this.VPos - 64 & 1023;for (var ch = 0; ch < 2; ch++) {
            MP2.MatrixTransform(this.sample[ch], p, this.V[ch], this.VPos);JSMpeg.Fill(this.U, 0);var dIndex = 512 - (this.VPos >> 1);var vIndex = this.VPos % 128 >> 1;while (vIndex < 1024) {
              for (var i = 0; i < 32; ++i) {
                this.U[i] += this.D[dIndex++] * this.V[ch][vIndex++];
              }vIndex += 128 - 32;dIndex += 64 - 32;
            }vIndex = 128 - 32 + 1024 - vIndex;dIndex -= 512 - 32;while (vIndex < 1024) {
              for (var i = 0; i < 32; ++i) {
                this.U[i] += this.D[dIndex++] * this.V[ch][vIndex++];
              }vIndex += 128 - 32;dIndex += 64 - 32;
            }var outChannel = ch === 0 ? left : right;for (var j = 0; j < 32; j++) {
              outChannel[outPos + j] = this.U[j] / 2147418112;
            }
          }outPos += 32;
        }
      }
    }this.sampleRate = sampleRate;return frameSize;
  };MP2.prototype.readAllocation = function (sb, tab3) {
    var tab4 = MP2.QUANT_LUT_STEP_3[tab3][sb];var qtab = MP2.QUANT_LUT_STEP4[tab4 & 15][this.bits.read(tab4 >> 4)];return qtab ? MP2.QUANT_TAB[qtab - 1] : 0;
  };MP2.prototype.readSamples = function (ch, sb, part) {
    var q = this.allocation[ch][sb],
        sf = this.scaleFactor[ch][sb][part],
        sample = this.sample[ch][sb],
        val = 0;if (!q) {
      sample[0] = sample[1] = sample[2] = 0;return;
    }if (sf === 63) {
      sf = 0;
    } else {
      var shift = sf / 3 | 0;sf = MP2.SCALEFACTOR_BASE[sf % 3] + (1 << shift >> 1) >> shift;
    }var adj = q.levels;if (q.group) {
      val = this.bits.read(q.bits);sample[0] = val % adj;val = val / adj | 0;sample[1] = val % adj;sample[2] = val / adj | 0;
    } else {
      sample[0] = this.bits.read(q.bits);sample[1] = this.bits.read(q.bits);sample[2] = this.bits.read(q.bits);
    }var scale = 65536 / (adj + 1) | 0;adj = (adj + 1 >> 1) - 1;val = (adj - sample[0]) * scale;sample[0] = val * (sf >> 12) + (val * (sf & 4095) + 2048 >> 12) >> 12;val = (adj - sample[1]) * scale;sample[1] = val * (sf >> 12) + (val * (sf & 4095) + 2048 >> 12) >> 12;val = (adj - sample[2]) * scale;sample[2] = val * (sf >> 12) + (val * (sf & 4095) + 2048 >> 12) >> 12;
  };MP2.MatrixTransform = function (s, ss, d, dp) {
    var t01, t02, t03, t04, t05, t06, t07, t08, t09, t10, t11, t12, t13, t14, t15, t16, t17, t18, t19, t20, t21, t22, t23, t24, t25, t26, t27, t28, t29, t30, t31, t32, t33;t01 = s[0][ss] + s[31][ss];t02 = (s[0][ss] - s[31][ss]) * .500602998235;t03 = s[1][ss] + s[30][ss];t04 = (s[1][ss] - s[30][ss]) * .505470959898;t05 = s[2][ss] + s[29][ss];t06 = (s[2][ss] - s[29][ss]) * .515447309923;t07 = s[3][ss] + s[28][ss];t08 = (s[3][ss] - s[28][ss]) * .53104259109;t09 = s[4][ss] + s[27][ss];t10 = (s[4][ss] - s[27][ss]) * .553103896034;t11 = s[5][ss] + s[26][ss];t12 = (s[5][ss] - s[26][ss]) * .582934968206;t13 = s[6][ss] + s[25][ss];t14 = (s[6][ss] - s[25][ss]) * .622504123036;t15 = s[7][ss] + s[24][ss];t16 = (s[7][ss] - s[24][ss]) * .674808341455;t17 = s[8][ss] + s[23][ss];t18 = (s[8][ss] - s[23][ss]) * .744536271002;t19 = s[9][ss] + s[22][ss];t20 = (s[9][ss] - s[22][ss]) * .839349645416;t21 = s[10][ss] + s[21][ss];t22 = (s[10][ss] - s[21][ss]) * .972568237862;t23 = s[11][ss] + s[20][ss];t24 = (s[11][ss] - s[20][ss]) * 1.16943993343;t25 = s[12][ss] + s[19][ss];t26 = (s[12][ss] - s[19][ss]) * 1.48416461631;t27 = s[13][ss] + s[18][ss];t28 = (s[13][ss] - s[18][ss]) * 2.05778100995;t29 = s[14][ss] + s[17][ss];t30 = (s[14][ss] - s[17][ss]) * 3.40760841847;t31 = s[15][ss] + s[16][ss];t32 = (s[15][ss] - s[16][ss]) * 10.1900081235;t33 = t01 + t31;t31 = (t01 - t31) * .502419286188;t01 = t03 + t29;t29 = (t03 - t29) * .52249861494;t03 = t05 + t27;t27 = (t05 - t27) * .566944034816;t05 = t07 + t25;t25 = (t07 - t25) * .64682178336;t07 = t09 + t23;t23 = (t09 - t23) * .788154623451;t09 = t11 + t21;t21 = (t11 - t21) * 1.06067768599;t11 = t13 + t19;t19 = (t13 - t19) * 1.72244709824;t13 = t15 + t17;t17 = (t15 - t17) * 5.10114861869;t15 = t33 + t13;t13 = (t33 - t13) * .509795579104;t33 = t01 + t11;t01 = (t01 - t11) * .601344886935;t11 = t03 + t09;t09 = (t03 - t09) * .899976223136;t03 = t05 + t07;t07 = (t05 - t07) * 2.56291544774;t05 = t15 + t03;t15 = (t15 - t03) * .541196100146;t03 = t33 + t11;t11 = (t33 - t11) * 1.30656296488;t33 = t05 + t03;t05 = (t05 - t03) * .707106781187;t03 = t15 + t11;t15 = (t15 - t11) * .707106781187;t03 += t15;t11 = t13 + t07;t13 = (t13 - t07) * .541196100146;t07 = t01 + t09;t09 = (t01 - t09) * 1.30656296488;t01 = t11 + t07;t07 = (t11 - t07) * .707106781187;t11 = t13 + t09;t13 = (t13 - t09) * .707106781187;t11 += t13;t01 += t11;t11 += t07;t07 += t13;t09 = t31 + t17;t31 = (t31 - t17) * .509795579104;t17 = t29 + t19;t29 = (t29 - t19) * .601344886935;t19 = t27 + t21;t21 = (t27 - t21) * .899976223136;t27 = t25 + t23;t23 = (t25 - t23) * 2.56291544774;t25 = t09 + t27;t09 = (t09 - t27) * .541196100146;t27 = t17 + t19;t19 = (t17 - t19) * 1.30656296488;t17 = t25 + t27;t27 = (t25 - t27) * .707106781187;t25 = t09 + t19;t19 = (t09 - t19) * .707106781187;t25 += t19;t09 = t31 + t23;t31 = (t31 - t23) * .541196100146;t23 = t29 + t21;t21 = (t29 - t21) * 1.30656296488;t29 = t09 + t23;t23 = (t09 - t23) * .707106781187;t09 = t31 + t21;t31 = (t31 - t21) * .707106781187;t09 += t31;t29 += t09;t09 += t23;t23 += t31;t17 += t29;t29 += t25;t25 += t09;t09 += t27;t27 += t23;t23 += t19;t19 += t31;t21 = t02 + t32;t02 = (t02 - t32) * .502419286188;t32 = t04 + t30;t04 = (t04 - t30) * .52249861494;t30 = t06 + t28;t28 = (t06 - t28) * .566944034816;t06 = t08 + t26;t08 = (t08 - t26) * .64682178336;t26 = t10 + t24;t10 = (t10 - t24) * .788154623451;t24 = t12 + t22;t22 = (t12 - t22) * 1.06067768599;t12 = t14 + t20;t20 = (t14 - t20) * 1.72244709824;t14 = t16 + t18;t16 = (t16 - t18) * 5.10114861869;t18 = t21 + t14;t14 = (t21 - t14) * .509795579104;t21 = t32 + t12;t32 = (t32 - t12) * .601344886935;t12 = t30 + t24;t24 = (t30 - t24) * .899976223136;t30 = t06 + t26;t26 = (t06 - t26) * 2.56291544774;t06 = t18 + t30;t18 = (t18 - t30) * .541196100146;t30 = t21 + t12;t12 = (t21 - t12) * 1.30656296488;t21 = t06 + t30;t30 = (t06 - t30) * .707106781187;t06 = t18 + t12;t12 = (t18 - t12) * .707106781187;t06 += t12;t18 = t14 + t26;t26 = (t14 - t26) * .541196100146;t14 = t32 + t24;t24 = (t32 - t24) * 1.30656296488;t32 = t18 + t14;t14 = (t18 - t14) * .707106781187;t18 = t26 + t24;t24 = (t26 - t24) * .707106781187;t18 += t24;t32 += t18;t18 += t14;t26 = t14 + t24;t14 = t02 + t16;t02 = (t02 - t16) * .509795579104;t16 = t04 + t20;t04 = (t04 - t20) * .601344886935;t20 = t28 + t22;t22 = (t28 - t22) * .899976223136;t28 = t08 + t10;t10 = (t08 - t10) * 2.56291544774;t08 = t14 + t28;t14 = (t14 - t28) * .541196100146;t28 = t16 + t20;t20 = (t16 - t20) * 1.30656296488;t16 = t08 + t28;t28 = (t08 - t28) * .707106781187;t08 = t14 + t20;t20 = (t14 - t20) * .707106781187;t08 += t20;t14 = t02 + t10;t02 = (t02 - t10) * .541196100146;t10 = t04 + t22;t22 = (t04 - t22) * 1.30656296488;t04 = t14 + t10;t10 = (t14 - t10) * .707106781187;t14 = t02 + t22;t02 = (t02 - t22) * .707106781187;t14 += t02;t04 += t14;t14 += t10;t10 += t02;t16 += t04;t04 += t08;t08 += t14;t14 += t28;t28 += t10;t10 += t20;t20 += t02;t21 += t16;t16 += t32;t32 += t04;t04 += t06;t06 += t08;t08 += t18;t18 += t14;t14 += t30;t30 += t28;t28 += t26;t26 += t10;t10 += t12;t12 += t20;t20 += t24;t24 += t02;d[dp + 48] = -t33;d[dp + 49] = d[dp + 47] = -t21;d[dp + 50] = d[dp + 46] = -t17;d[dp + 51] = d[dp + 45] = -t16;d[dp + 52] = d[dp + 44] = -t01;d[dp + 53] = d[dp + 43] = -t32;d[dp + 54] = d[dp + 42] = -t29;d[dp + 55] = d[dp + 41] = -t04;d[dp + 56] = d[dp + 40] = -t03;d[dp + 57] = d[dp + 39] = -t06;d[dp + 58] = d[dp + 38] = -t25;d[dp + 59] = d[dp + 37] = -t08;d[dp + 60] = d[dp + 36] = -t11;d[dp + 61] = d[dp + 35] = -t18;d[dp + 62] = d[dp + 34] = -t09;d[dp + 63] = d[dp + 33] = -t14;d[dp + 32] = -t05;d[dp + 0] = t05;d[dp + 31] = -t30;d[dp + 1] = t30;d[dp + 30] = -t27;d[dp + 2] = t27;d[dp + 29] = -t28;d[dp + 3] = t28;d[dp + 28] = -t07;d[dp + 4] = t07;d[dp + 27] = -t26;d[dp + 5] = t26;d[dp + 26] = -t23;d[dp + 6] = t23;d[dp + 25] = -t10;d[dp + 7] = t10;d[dp + 24] = -t15;d[dp + 8] = t15;d[dp + 23] = -t12;d[dp + 9] = t12;d[dp + 22] = -t19;d[dp + 10] = t19;d[dp + 21] = -t20;d[dp + 11] = t20;d[dp + 20] = -t13;d[dp + 12] = t13;d[dp + 19] = -t24;d[dp + 13] = t24;d[dp + 18] = -t31;d[dp + 14] = t31;d[dp + 17] = -t02;d[dp + 15] = t02;d[dp + 16] = 0;
  };MP2.FRAME_SYNC = 2047;MP2.VERSION = { MPEG_2_5: 0, MPEG_2: 2, MPEG_1: 3 };MP2.LAYER = { III: 1, II: 2, I: 3 };MP2.MODE = { STEREO: 0, JOINT_STEREO: 1, DUAL_CHANNEL: 2, MONO: 3 };MP2.SAMPLE_RATE = new Uint16Array([44100, 48e3, 32e3, 0, 22050, 24e3, 16e3, 0]);MP2.BIT_RATE = new Uint16Array([32, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 384, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160]);MP2.SCALEFACTOR_BASE = new Uint32Array([33554432, 26632170, 21137968]);MP2.SYNTHESIS_WINDOW = new Float32Array([0, -.5, -.5, -.5, -.5, -.5, -.5, -1, -1, -1, -1, -1.5, -1.5, -2, -2, -2.5, -2.5, -3, -3.5, -3.5, -4, -4.5, -5, -5.5, -6.5, -7, -8, -8.5, -9.5, -10.5, -12, -13, -14.5, -15.5, -17.5, -19, -20.5, -22.5, -24.5, -26.5, -29, -31.5, -34, -36.5, -39.5, -42.5, -45.5, -48.5, -52, -55.5, -58.5, -62.5, -66, -69.5, -73.5, -77, -80.5, -84.5, -88, -91.5, -95, -98, -101, -104, 106.5, 109, 111, 112.5, 113.5, 114, 114, 113.5, 112, 110.5, 107.5, 104, 100, 94.5, 88.5, 81.5, 73, 63.5, 53, 41.5, 28.5, 14.5, -1, -18, -36, -55.5, -76.5, -98.5, -122, -147, -173.5, -200.5, -229.5, -259.5, -290.5, -322.5, -355.5, -389.5, -424, -459.5, -495.5, -532, -568.5, -605, -641.5, -678, -714, -749, -783.5, -817, -849, -879.5, -908.5, -935, -959.5, -981, -1000.5, -1016, -1028.5, -1037.5, -1042.5, -1043.5, -1040, -1031.5, 1018.5, 1e3, 976, 946.5, 911, 869.5, 822, 767.5, 707, 640, 565.5, 485, 397, 302.5, 201, 92.5, -22.5, -144, -272.5, -407, -547.5, -694, -846, -1003, -1165, -1331.5, -1502, -1675.5, -1852.5, -2031.5, -2212.5, -2394, -2576.5, -2758.5, -2939.5, -3118.5, -3294.5, -3467.5, -3635.5, -3798.5, -3955, -4104.5, -4245.5, -4377.5, -4499, -4609.5, -4708, -4792.5, -4863.5, -4919, -4958, -4979.5, -4983, -4967.5, -4931.5, -4875, -4796, -4694.5, -4569.5, -4420, -4246, -4046, -3820, -3567, 3287, 2979.5, 2644, 2280.5, 1888, 1467.5, 1018.5, 541, 35, -499, -1061, -1650, -2266.5, -2909, -3577, -4270, -4987.5, -5727.5, -6490, -7274, -8077.5, -8899.5, -9739, -10594.5, -11464.5, -12347, -13241, -14144.5, -15056, -15973.5, -16895.5, -17820, -18744.5, -19668, -20588, -21503, -22410.5, -23308.5, -24195, -25068.5, -25926.5, -26767, -27589, -28389, -29166.5, -29919, -30644.5, -31342, -32009.5, -32645, -33247, -33814.5, -34346, -34839.5, -35295, -35710, -36084.5, -36417.5, -36707.5, -36954, -37156.5, -37315, -37428, -37496, 37519, 37496, 37428, 37315, 37156.5, 36954, 36707.5, 36417.5, 36084.5, 35710, 35295, 34839.5, 34346, 33814.5, 33247, 32645, 32009.5, 31342, 30644.5, 29919, 29166.5, 28389, 27589, 26767, 25926.5, 25068.5, 24195, 23308.5, 22410.5, 21503, 20588, 19668, 18744.5, 17820, 16895.5, 15973.5, 15056, 14144.5, 13241, 12347, 11464.5, 10594.5, 9739, 8899.5, 8077.5, 7274, 6490, 5727.5, 4987.5, 4270, 3577, 2909, 2266.5, 1650, 1061, 499, -35, -541, -1018.5, -1467.5, -1888, -2280.5, -2644, -2979.5, 3287, 3567, 3820, 4046, 4246, 4420, 4569.5, 4694.5, 4796, 4875, 4931.5, 4967.5, 4983, 4979.5, 4958, 4919, 4863.5, 4792.5, 4708, 4609.5, 4499, 4377.5, 4245.5, 4104.5, 3955, 3798.5, 3635.5, 3467.5, 3294.5, 3118.5, 2939.5, 2758.5, 2576.5, 2394, 2212.5, 2031.5, 1852.5, 1675.5, 1502, 1331.5, 1165, 1003, 846, 694, 547.5, 407, 272.5, 144, 22.5, -92.5, -201, -302.5, -397, -485, -565.5, -640, -707, -767.5, -822, -869.5, -911, -946.5, -976, -1e3, 1018.5, 1031.5, 1040, 1043.5, 1042.5, 1037.5, 1028.5, 1016, 1000.5, 981, 959.5, 935, 908.5, 879.5, 849, 817, 783.5, 749, 714, 678, 641.5, 605, 568.5, 532, 495.5, 459.5, 424, 389.5, 355.5, 322.5, 290.5, 259.5, 229.5, 200.5, 173.5, 147, 122, 98.5, 76.5, 55.5, 36, 18, 1, -14.5, -28.5, -41.5, -53, -63.5, -73, -81.5, -88.5, -94.5, -100, -104, -107.5, -110.5, -112, -113.5, -114, -114, -113.5, -112.5, -111, -109, 106.5, 104, 101, 98, 95, 91.5, 88, 84.5, 80.5, 77, 73.5, 69.5, 66, 62.5, 58.5, 55.5, 52, 48.5, 45.5, 42.5, 39.5, 36.5, 34, 31.5, 29, 26.5, 24.5, 22.5, 20.5, 19, 17.5, 15.5, 14.5, 13, 12, 10.5, 9.5, 8.5, 8, 7, 6.5, 5.5, 5, 4.5, 4, 3.5, 3.5, 3, 2.5, 2.5, 2, 2, 1.5, 1.5, 1, 1, 1, 1, .5, .5, .5, .5, .5, .5]);MP2.QUANT_LUT_STEP_1 = [[0, 0, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2], [0, 0, 0, 0, 0, 0, 1, 1, 1, 2, 2, 2, 2, 2]];MP2.QUANT_TAB = { A: 27 | 64, B: 30 | 64, C: 8, D: 12 };MP2.QUANT_LUT_STEP_2 = [[MP2.QUANT_TAB.C, MP2.QUANT_TAB.C, MP2.QUANT_TAB.D], [MP2.QUANT_TAB.A, MP2.QUANT_TAB.A, MP2.QUANT_TAB.A], [MP2.QUANT_TAB.B, MP2.QUANT_TAB.A, MP2.QUANT_TAB.B]];MP2.QUANT_LUT_STEP_3 = [[68, 68, 52, 52, 52, 52, 52, 52, 52, 52, 52, 52], [67, 67, 67, 66, 66, 66, 66, 66, 66, 66, 66, 49, 49, 49, 49, 49, 49, 49, 49, 49, 49, 49, 49, 32, 32, 32, 32, 32, 32, 32], [69, 69, 69, 69, 52, 52, 52, 52, 52, 52, 52, 36, 36, 36, 36, 36, 36, 36, 36, 36, 36, 36, 36, 36, 36, 36, 36, 36, 36, 36]];MP2.QUANT_LUT_STEP4 = [[0, 1, 2, 17], [0, 1, 2, 3, 4, 5, 6, 17], [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 17], [0, 1, 3, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [0, 1, 2, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 17], [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]];MP2.QUANT_TAB = [{ levels: 3, group: 1, bits: 5 }, { levels: 5, group: 1, bits: 7 }, { levels: 7, group: 0, bits: 3 }, { levels: 9, group: 1, bits: 10 }, { levels: 15, group: 0, bits: 4 }, { levels: 31, group: 0, bits: 5 }, { levels: 63, group: 0, bits: 6 }, { levels: 127, group: 0, bits: 7 }, { levels: 255, group: 0, bits: 8 }, { levels: 511, group: 0, bits: 9 }, { levels: 1023, group: 0, bits: 10 }, { levels: 2047, group: 0, bits: 11 }, { levels: 4095, group: 0, bits: 12 }, { levels: 8191, group: 0, bits: 13 }, { levels: 16383, group: 0, bits: 14 }, { levels: 32767, group: 0, bits: 15 }, { levels: 65535, group: 0, bits: 16 }];return MP2;
}();JSMpeg.Decoder.MP2AudioWASM = function () {
  "use strict";

  var MP2WASM = function MP2WASM(options) {
    JSMpeg.Decoder.Base.call(this, options);this.onDecodeCallback = options.onAudioDecode;this.module = options.wasmModule;this.bufferSize = options.audioBufferSize || 128 * 1024;this.bufferMode = options.streaming ? JSMpeg.BitBuffer.MODE.EVICT : JSMpeg.BitBuffer.MODE.EXPAND;this.sampleRate = 0;
  };MP2WASM.prototype = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default()(JSMpeg.Decoder.Base.prototype);MP2WASM.prototype.constructor = MP2WASM;MP2WASM.prototype.initializeWasmDecoder = function () {
    if (!this.module.instance) {
      console.warn("JSMpeg: WASM module not compiled yet");return;
    }this.instance = this.module.instance;this.functions = this.module.instance.exports;this.decoder = this.functions._mp2_decoder_create(this.bufferSize, this.bufferMode);
  };MP2WASM.prototype.destroy = function () {
    if (!this.decoder) {
      return;
    }this.functions._mp2_decoder_destroy(this.decoder);
  };MP2WASM.prototype.bufferGetIndex = function () {
    if (!this.decoder) {
      return;
    }return this.functions._mp2_decoder_get_index(this.decoder);
  };MP2WASM.prototype.bufferSetIndex = function (index) {
    if (!this.decoder) {
      return;
    }this.functions._mp2_decoder_set_index(this.decoder, index);
  };MP2WASM.prototype.bufferWrite = function (buffers) {
    if (!this.decoder) {
      this.initializeWasmDecoder();
    }var totalLength = 0;for (var i = 0; i < buffers.length; i++) {
      totalLength += buffers[i].length;
    }var ptr = this.functions._mp2_decoder_get_write_ptr(this.decoder, totalLength);for (var i = 0; i < buffers.length; i++) {
      this.instance.heapU8.set(buffers[i], ptr);ptr += buffers[i].length;
    }this.functions._mp2_decoder_did_write(this.decoder, totalLength);return totalLength;
  };MP2WASM.prototype.decode = function () {
    var startTime = JSMpeg.Now();if (!this.decoder) {
      return false;
    }var decodedBytes = this.functions._mp2_decoder_decode(this.decoder);if (decodedBytes === 0) {
      return false;
    }if (!this.sampleRate) {
      this.sampleRate = this.functions._mp2_decoder_get_sample_rate(this.decoder);
    }if (this.destination) {
      var leftPtr = this.functions._mp2_decoder_get_left_channel_ptr(this.decoder),
          rightPtr = this.functions._mp2_decoder_get_right_channel_ptr(this.decoder);var leftOffset = leftPtr / Float32Array.BYTES_PER_ELEMENT,
          rightOffset = rightPtr / Float32Array.BYTES_PER_ELEMENT;var left = this.instance.heapF32.subarray(leftOffset, leftOffset + MP2WASM.SAMPLES_PER_FRAME),
          right = this.instance.heapF32.subarray(rightOffset, rightOffset + MP2WASM.SAMPLES_PER_FRAME);this.destination.play(this.sampleRate, left, right);
    }this.advanceDecodedTime(MP2WASM.SAMPLES_PER_FRAME / this.sampleRate);var elapsedTime = JSMpeg.Now() - startTime;if (this.onDecodeCallback) {
      this.onDecodeCallback(this, elapsedTime);
    }return true;
  };MP2WASM.prototype.getCurrentTime = function () {
    var enqueuedTime = this.destination ? this.destination.enqueuedTime : 0;return this.decodedTime - enqueuedTime;
  };MP2WASM.SAMPLES_PER_FRAME = 1152;return MP2WASM;
}();JSMpeg.Renderer.WebGL = function () {
  "use strict";

  var WebGLRenderer = function WebGLRenderer(options) {
    this.canvas = options.canvas || document.createElement("canvas");this.width = this.canvas.width;this.height = this.canvas.height;this.enabled = true;this.contextLost = false;this.hasTextureData = {};var contextCreateOptions = { preserveDrawingBuffer: !!options.preserveDrawingBuffer, alpha: false, depth: false, stencil: false, antialias: false, premultipliedAlpha: false };this.gl = this.canvas.getContext("webgl", contextCreateOptions) || this.canvas.getContext("experimental-webgl", contextCreateOptions);if (!this.gl) {
      throw new Error("Failed to get WebGL Context");
    }this.canvas.addEventListener("webglcontextlost", this.handleContextLost.bind(this), false);this.canvas.addEventListener("webglcontextrestored", this.handleContextRestored.bind(this), false);this.initGL();
  };WebGLRenderer.prototype.initGL = function () {
    this.hasTextureData = {};var gl = this.gl;var vertexAttr = null;gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);this.vertexBuffer = gl.createBuffer();var vertexCoords = new Float32Array([0, 0, 0, 1, 1, 0, 1, 1]);gl.bindBuffer(gl.ARRAY_BUFFER, this.vertexBuffer);gl.bufferData(gl.ARRAY_BUFFER, vertexCoords, gl.STATIC_DRAW);this.program = this.createProgram(WebGLRenderer.SHADER.VERTEX_IDENTITY, WebGLRenderer.SHADER.FRAGMENT_YCRCB_TO_RGBA);vertexAttr = gl.getAttribLocation(this.program, "vertex");gl.enableVertexAttribArray(vertexAttr);gl.vertexAttribPointer(vertexAttr, 2, gl.FLOAT, false, 0, 0);this.textureY = this.createTexture(0, "textureY");this.textureCb = this.createTexture(1, "textureCb");this.textureCr = this.createTexture(2, "textureCr");this.loadingProgram = this.createProgram(WebGLRenderer.SHADER.VERTEX_IDENTITY, WebGLRenderer.SHADER.FRAGMENT_LOADING);vertexAttr = gl.getAttribLocation(this.loadingProgram, "vertex");gl.enableVertexAttribArray(vertexAttr);gl.vertexAttribPointer(vertexAttr, 2, gl.FLOAT, false, 0, 0);this.shouldCreateUnclampedViews = !this.allowsClampedTextureData();
  };WebGLRenderer.prototype.handleContextLost = function (ev) {
    ev.preventDefault();this.contextLost = true;
  };WebGLRenderer.prototype.handleContextRestored = function (ev) {
    this.initGL();this.contextLost = false;
  };WebGLRenderer.prototype.destroy = function () {
    if (this.contextLost) {
      return;
    }var gl = this.gl;this.deleteTexture(gl.TEXTURE0, this.textureY);this.deleteTexture(gl.TEXTURE1, this.textureCb);this.deleteTexture(gl.TEXTURE2, this.textureCr);gl.useProgram(null);gl.deleteProgram(this.program);gl.deleteProgram(this.loadingProgram);gl.bindBuffer(gl.ARRAY_BUFFER, null);gl.deleteBuffer(this.vertexBuffer);gl.getExtension("WEBGL_lose_context").loseContext();this.canvas.remove();this.contextLost = true;
  };WebGLRenderer.prototype.resize = function (width, height) {
    this.width = width | 0;this.height = height | 0;this.canvas.width = this.width;this.canvas.height = this.height;this.gl.useProgram(this.program);var codedWidth = this.width + 15 >> 4 << 4;this.gl.viewport(0, 0, codedWidth, this.height);
  };WebGLRenderer.prototype.createTexture = function (index, name) {
    var gl = this.gl;var texture = gl.createTexture();gl.bindTexture(gl.TEXTURE_2D, texture);gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);gl.uniform1i(gl.getUniformLocation(this.program, name), index);return texture;
  };WebGLRenderer.prototype.createProgram = function (vsh, fsh) {
    var gl = this.gl;var program = gl.createProgram();gl.attachShader(program, this.compileShader(gl.VERTEX_SHADER, vsh));gl.attachShader(program, this.compileShader(gl.FRAGMENT_SHADER, fsh));gl.linkProgram(program);gl.useProgram(program);return program;
  };WebGLRenderer.prototype.compileShader = function (type, source) {
    var gl = this.gl;var shader = gl.createShader(type);gl.shaderSource(shader, source);gl.compileShader(shader);if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
      throw new Error(gl.getShaderInfoLog(shader));
    }return shader;
  };WebGLRenderer.prototype.allowsClampedTextureData = function () {
    var gl = this.gl;var texture = gl.createTexture();gl.bindTexture(gl.TEXTURE_2D, texture);gl.texImage2D(gl.TEXTURE_2D, 0, gl.LUMINANCE, 1, 1, 0, gl.LUMINANCE, gl.UNSIGNED_BYTE, new Uint8ClampedArray([0]));return gl.getError() === 0;
  };WebGLRenderer.prototype.renderProgress = function (progress) {
    var gl = this.gl;gl.useProgram(this.loadingProgram);var loc = gl.getUniformLocation(this.loadingProgram, "progress");gl.uniform1f(loc, progress);gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
  };WebGLRenderer.prototype.render = function (y, cb, cr, isClampedArray) {
    if (!this.enabled) {
      return;
    }var gl = this.gl;var w = this.width + 15 >> 4 << 4,
        h = this.height,
        w2 = w >> 1,
        h2 = h >> 1;if (isClampedArray && this.shouldCreateUnclampedViews) {
      y = new Uint8Array(y.buffer), cb = new Uint8Array(cb.buffer), cr = new Uint8Array(cr.buffer);
    }gl.useProgram(this.program);this.updateTexture(gl.TEXTURE0, this.textureY, w, h, y);this.updateTexture(gl.TEXTURE1, this.textureCb, w2, h2, cb);this.updateTexture(gl.TEXTURE2, this.textureCr, w2, h2, cr);gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
  };WebGLRenderer.prototype.updateTexture = function (unit, texture, w, h, data) {
    var gl = this.gl;gl.activeTexture(unit);gl.bindTexture(gl.TEXTURE_2D, texture);if (this.hasTextureData[unit]) {
      gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, w, h, gl.LUMINANCE, gl.UNSIGNED_BYTE, data);
    } else {
      this.hasTextureData[unit] = true;gl.texImage2D(gl.TEXTURE_2D, 0, gl.LUMINANCE, w, h, 0, gl.LUMINANCE, gl.UNSIGNED_BYTE, data);
    }
  };WebGLRenderer.prototype.deleteTexture = function (unit, texture) {
    var gl = this.gl;gl.activeTexture(unit);gl.bindTexture(gl.TEXTURE_2D, null);gl.deleteTexture(texture);
  };WebGLRenderer.IsSupported = function () {
    try {
      if (!window.WebGLRenderingContext) {
        return false;
      }var canvas = document.createElement("canvas");return !!(canvas.getContext("webgl") || canvas.getContext("experimental-webgl"));
    } catch (err) {
      return false;
    }
  };WebGLRenderer.SHADER = { FRAGMENT_YCRCB_TO_RGBA: ["precision mediump float;", "uniform sampler2D textureY;", "uniform sampler2D textureCb;", "uniform sampler2D textureCr;", "varying vec2 texCoord;", "mat4 rec601 = mat4(", "1.16438,  0.00000,  1.59603, -0.87079,", "1.16438, -0.39176, -0.81297,  0.52959,", "1.16438,  2.01723,  0.00000, -1.08139,", "0, 0, 0, 1", ");", "void main() {", "float y = texture2D(textureY, texCoord).r;", "float cb = texture2D(textureCb, texCoord).r;", "float cr = texture2D(textureCr, texCoord).r;", "gl_FragColor = vec4(y, cr, cb, 1.0) * rec601;", "}"].join("\n"), FRAGMENT_LOADING: ["precision mediump float;", "uniform float progress;", "varying vec2 texCoord;", "void main() {", "float c = ceil(progress-(1.0-texCoord.y));", "gl_FragColor = vec4(c,c,c,1);", "}"].join("\n"), VERTEX_IDENTITY: ["attribute vec2 vertex;", "varying vec2 texCoord;", "void main() {", "texCoord = vertex;", "gl_Position = vec4((vertex * 2.0 - 1.0) * vec2(1, -1), 0.0, 1.0);", "}"].join("\n") };return WebGLRenderer;
}();JSMpeg.Renderer.Canvas2D = function () {
  "use strict";

  var CanvasRenderer = function CanvasRenderer(options) {
    this.canvas = options.canvas || document.createElement("canvas");this.width = this.canvas.width;this.height = this.canvas.height;this.enabled = true;this.context = this.canvas.getContext("2d");
  };CanvasRenderer.prototype.destroy = function () {};CanvasRenderer.prototype.resize = function (width, height) {
    this.width = width | 0;this.height = height | 0;this.canvas.width = this.width;this.canvas.height = this.height;this.imageData = this.context.getImageData(0, 0, this.width, this.height);JSMpeg.Fill(this.imageData.data, 255);
  };CanvasRenderer.prototype.renderProgress = function (progress) {
    var w = this.canvas.width,
        h = this.canvas.height,
        ctx = this.context;ctx.fillStyle = "#222";ctx.fillRect(0, 0, w, h);ctx.fillStyle = "#fff";ctx.fillRect(0, h - h * progress, w, h * progress);
  };CanvasRenderer.prototype.render = function (y, cb, cr) {
    this.YCbCrToRGBA(y, cb, cr, this.imageData.data);this.context.putImageData(this.imageData, 0, 0);
  };CanvasRenderer.prototype.YCbCrToRGBA = function (y, cb, cr, rgba) {
    if (!this.enabled) {
      return;
    }var w = this.width + 15 >> 4 << 4,
        w2 = w >> 1;var yIndex1 = 0,
        yIndex2 = w,
        yNext2Lines = w + (w - this.width);var cIndex = 0,
        cNextLine = w2 - (this.width >> 1);var rgbaIndex1 = 0,
        rgbaIndex2 = this.width * 4,
        rgbaNext2Lines = this.width * 4;var cols = this.width >> 1,
        rows = this.height >> 1;var ccb, ccr, r, g, b;for (var row = 0; row < rows; row++) {
      for (var col = 0; col < cols; col++) {
        ccb = cb[cIndex];ccr = cr[cIndex];cIndex++;r = ccb + (ccb * 103 >> 8) - 179;g = (ccr * 88 >> 8) - 44 + (ccb * 183 >> 8) - 91;b = ccr + (ccr * 198 >> 8) - 227;var y1 = y[yIndex1++];var y2 = y[yIndex1++];rgba[rgbaIndex1] = y1 + r;rgba[rgbaIndex1 + 1] = y1 - g;rgba[rgbaIndex1 + 2] = y1 + b;rgba[rgbaIndex1 + 4] = y2 + r;rgba[rgbaIndex1 + 5] = y2 - g;rgba[rgbaIndex1 + 6] = y2 + b;rgbaIndex1 += 8;var y3 = y[yIndex2++];var y4 = y[yIndex2++];rgba[rgbaIndex2] = y3 + r;rgba[rgbaIndex2 + 1] = y3 - g;rgba[rgbaIndex2 + 2] = y3 + b;rgba[rgbaIndex2 + 4] = y4 + r;rgba[rgbaIndex2 + 5] = y4 - g;rgba[rgbaIndex2 + 6] = y4 + b;rgbaIndex2 += 8;
      }yIndex1 += yNext2Lines;yIndex2 += yNext2Lines;rgbaIndex1 += rgbaNext2Lines;rgbaIndex2 += rgbaNext2Lines;cIndex += cNextLine;
    }
  };return CanvasRenderer;
}();JSMpeg.AudioOutput.WebAudio = function () {
  "use strict";

  var WebAudioOut = function WebAudioOut(options) {
    this.context = WebAudioOut.CachedContext = WebAudioOut.CachedContext || new (window.AudioContext || window.webkitAudioContext)();this.gain = this.context.createGain();this.destination = this.gain;this.gain.connect(this.context.destination);this.context._connections = (this.context._connections || 0) + 1;this.startTime = 0;this.buffer = null;this.wallclockStartTime = 0;this.volume = 1;this.enabled = true;this.unlocked = !WebAudioOut.NeedsUnlocking();Object.defineProperty(this, "enqueuedTime", { get: this.getEnqueuedTime });
  };WebAudioOut.prototype.destroy = function () {
    this.gain.disconnect();this.context._connections--;if (this.context._connections === 0) {
      this.context.close();WebAudioOut.CachedContext = null;
    }
  };WebAudioOut.prototype.play = function (sampleRate, left, right) {
    if (!this.enabled) {
      return;
    }if (!this.unlocked) {
      var ts = JSMpeg.Now();if (this.wallclockStartTime < ts) {
        this.wallclockStartTime = ts;
      }this.wallclockStartTime += left.length / sampleRate;return;
    }this.gain.gain.value = this.volume;var buffer = this.context.createBuffer(2, left.length, sampleRate);buffer.getChannelData(0).set(left);buffer.getChannelData(1).set(right);var source = this.context.createBufferSource();source.buffer = buffer;source.connect(this.destination);var now = this.context.currentTime;var duration = buffer.duration;if (this.startTime < now) {
      this.startTime = now;this.wallclockStartTime = JSMpeg.Now();
    }source.start(this.startTime);this.startTime += duration;this.wallclockStartTime += duration;
  };WebAudioOut.prototype.stop = function () {
    this.gain.gain.value = 0;
  };WebAudioOut.prototype.getEnqueuedTime = function () {
    return Math.max(this.wallclockStartTime - JSMpeg.Now(), 0);
  };WebAudioOut.prototype.resetEnqueuedTime = function () {
    this.startTime = this.context.currentTime;this.wallclockStartTime = JSMpeg.Now();
  };WebAudioOut.prototype.unlock = function (callback) {
    if (this.unlocked) {
      if (callback) {
        callback();
      }return;
    }this.unlockCallback = callback;var buffer = this.context.createBuffer(1, 1, 22050);var source = this.context.createBufferSource();source.buffer = buffer;source.connect(this.destination);source.start(0);setTimeout(this.checkIfUnlocked.bind(this, source, 0), 0);
  };WebAudioOut.prototype.checkIfUnlocked = function (source, attempt) {
    if (source.playbackState === source.PLAYING_STATE || source.playbackState === source.FINISHED_STATE) {
      this.unlocked = true;if (this.unlockCallback) {
        this.unlockCallback();this.unlockCallback = null;
      }
    } else if (attempt < 10) {
      setTimeout(this.checkIfUnlocked.bind(this, source, attempt + 1), 100);
    }
  };WebAudioOut.NeedsUnlocking = function () {
    return (/iPhone|iPad|iPod/i.test(navigator.userAgent)
    );
  };WebAudioOut.IsSupported = function () {
    return window.AudioContext || window.webkitAudioContext;
  };WebAudioOut.CachedContext = null;return WebAudioOut;
}();JSMpeg.WASMModule = function () {
  "use strict";

  var WASM = function WASM() {
    this.stackSize = 5 * 1024 * 1024;this.pageSize = 64 * 1024;this.onInitCallbacks = [];this.ready = false;this.loadingFromFileStarted = false;this.loadingFromBufferStarted = false;
  };WASM.prototype.write = function (buffer) {
    this.loadFromBuffer(buffer);
  };WASM.prototype.loadFromFile = function (url, callback) {
    if (callback) {
      this.onInitCallbacks.push(callback);
    }if (this.loadingFromFileStarted) {
      return;
    }this.loadingFromFileStarted = true;this.onInitCallback = callback;var ajax = new JSMpeg.Source.Ajax(url, {});ajax.connect(this);ajax.start();
  };WASM.prototype.loadFromBuffer = function (buffer, callback) {
    if (callback) {
      this.onInitCallbacks.push(callback);
    }if (this.loadingFromBufferStarted) {
      return;
    }this.loadingFromBufferStarted = true;this.moduleInfo = this.readDylinkSection(buffer);if (!this.moduleInfo) {
      for (var i = 0; i < this.onInitCallbacks.length; i++) {
        this.onInitCallbacks[i](null);
      }return;
    }this.memory = new WebAssembly.Memory({ initial: 256 });var env = { memory: this.memory, memoryBase: 0, __memory_base: 0, table: new WebAssembly.Table({ initial: this.moduleInfo.tableSize, element: "anyfunc" }), tableBase: 0, __table_base: 0, abort: this.c_abort.bind(this), ___assert_fail: this.c_assertFail.bind(this), _sbrk: this.c_sbrk.bind(this) };this.brk = this.align(this.moduleInfo.memorySize + this.stackSize);WebAssembly.instantiate(buffer, { env: env }).then(function (results) {
      this.instance = results.instance;if (this.instance.exports.__post_instantiate) {
        this.instance.exports.__post_instantiate();
      }this.createHeapViews();this.ready = true;for (var i = 0; i < this.onInitCallbacks.length; i++) {
        this.onInitCallbacks[i](this);
      }
    }.bind(this));
  };WASM.prototype.createHeapViews = function () {
    this.instance.heapU8 = new Uint8Array(this.memory.buffer);this.instance.heapU32 = new Uint32Array(this.memory.buffer);this.instance.heapF32 = new Float32Array(this.memory.buffer);
  };WASM.prototype.align = function (addr) {
    var a = Math.pow(2, this.moduleInfo.memoryAlignment);return Math.ceil(addr / a) * a;
  };WASM.prototype.c_sbrk = function (size) {
    var previousBrk = this.brk;this.brk += size;if (this.brk > this.memory.buffer.byteLength) {
      var bytesNeeded = this.brk - this.memory.buffer.byteLength;var pagesNeeded = Math.ceil(bytesNeeded / this.pageSize);this.memory.grow(pagesNeeded);this.createHeapViews();
    }return previousBrk;
  };WASM.prototype.c_abort = function (size) {
    console.warn("JSMPeg: WASM abort", arguments);
  };WASM.prototype.c_assertFail = function (size) {
    console.warn("JSMPeg: WASM ___assert_fail", arguments);
  };WASM.prototype.readDylinkSection = function (buffer) {
    var bytes = new Uint8Array(buffer);var next = 0;var readVarUint = function readVarUint() {
      var ret = 0;var mul = 1;while (1) {
        var byte = bytes[next++];ret += (byte & 127) * mul;mul *= 128;if (!(byte & 128)) {
          return ret;
        }
      }
    };var matchNextBytes = function matchNextBytes(expected) {
      for (var i = 0; i < expected.length; i++) {
        var b = typeof expected[i] === "string" ? expected[i].charCodeAt(0) : expected[i];if (bytes[next++] !== b) {
          return false;
        }
      }return true;
    };if (!matchNextBytes([0, "a", "s", "m"])) {
      console.warn("JSMpeg: WASM header not found");return null;
    }var next = 9;var sectionSize = readVarUint();if (!matchNextBytes([6, "d", "y", "l", "i", "n", "k"])) {
      console.warn("JSMpeg: No dylink section found in WASM");return null;
    }return { memorySize: readVarUint(), memoryAlignment: readVarUint(), tableSize: readVarUint(), tableAlignment: readVarUint() };
  };WASM.IsSupported = function () {
    return !!window.WebAssembly;
  };WASM.GetModule = function () {
    WASM.CACHED_MODULE = WASM.CACHED_MODULE || new WASM();return WASM.CACHED_MODULE;
  };return WASM;
}();JSMpeg.WASM_BINARY_INLINED = "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";

/***/ }),

/***/ 592:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(1228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__newRouter__ = __webpack_require__(667);




var Dashboard = function Dashboard() {
  return __webpack_require__.e/* import() */(257).then(__webpack_require__.bind(null, 1324));
};
var BookList = function BookList() {
  return __webpack_require__.e/* import() */(130).then(__webpack_require__.bind(null, 1342));
};
var ChartsConfList = function ChartsConfList() {
  return __webpack_require__.e/* import() */(367).then(__webpack_require__.bind(null, 1332));
};
var UserList = function UserList() {
  return __webpack_require__.e/* import() */(155).then(__webpack_require__.bind(null, 1287));
};
var UserChangePwd = function UserChangePwd() {
  return __webpack_require__.e/* import() */(463).then(__webpack_require__.bind(null, 1344));
};
var UserProfile = function UserProfile() {
  return __webpack_require__.e/* import() */(523).then(__webpack_require__.bind(null, 1345));
};
var MenuList = function MenuList() {
  return __webpack_require__.e/* import() */(522).then(__webpack_require__.bind(null, 1339));
};
var Department = function Department() {
  return __webpack_require__.e/* import() */(179).then(__webpack_require__.bind(null, 1466));
};
var Custommenu = function Custommenu() {
  return __webpack_require__.e/* import() */(290).then(__webpack_require__.bind(null, 1490));
};
var Smsmanger = function Smsmanger() {
  return __webpack_require__.e/* import() */(356).then(__webpack_require__.bind(null, 1618));
};
var Ent = function Ent() {
  return __webpack_require__.e/* import() */(135).then(__webpack_require__.bind(null, 1358));
};
var Employee = function Employee() {
  return __webpack_require__.e/* import() */(161).then(__webpack_require__.bind(null, 1356));
};
var Post = function Post() {
  return __webpack_require__.e/* import() */(455).then(__webpack_require__.bind(null, 1391));
};
var Job = function Job() {
  return __webpack_require__.e/* import() */(384).then(__webpack_require__.bind(null, 1360));
};
var RiskUnit = function RiskUnit() {
  return __webpack_require__.e/* import() */(121).then(__webpack_require__.bind(null, 1476));
};
var publicRiskUnit = function publicRiskUnit() {
  return __webpack_require__.e/* import() */(162).then(__webpack_require__.bind(null, 1296));
};
var RiskPosition = function RiskPosition() {
  return __webpack_require__.e/* import() */(386).then(__webpack_require__.bind(null, 1297));
};
var RiskControl = function RiskControl() {
  return __webpack_require__.e/* import() */(106).then(__webpack_require__.bind(null, 1468));
};
var pesrsonRiskControl = function pesrsonRiskControl() {
  return __webpack_require__.e/* import() */(117).then(__webpack_require__.bind(null, 1467));
};

var BasicInfo = function BasicInfo() {
  return __webpack_require__.e/* import() */(454).then(__webpack_require__.bind(null, 1432));
};
var HRepository = function HRepository() {
  return __webpack_require__.e/* import() */(268).then(__webpack_require__.bind(null, 1435));
};
var CheckList = function CheckList() {
  return __webpack_require__.e/* import() */(85).then(__webpack_require__.bind(null, 1438));
};
var CheckAdd = function CheckAdd() {
  return __webpack_require__.e/* import() */(115).then(__webpack_require__.bind(null, 1295));
};
var Relevant = function Relevant() {
  return __webpack_require__.e/* import() */(194).then(__webpack_require__.bind(null, 1747));
};
var HaveDone = function HaveDone() {
  return __webpack_require__.e/* import() */(362).then(__webpack_require__.bind(null, 1349));
};
var Version = function Version() {
  return __webpack_require__.e/* import() */(385).then(__webpack_require__.bind(null, 1485));
};
var Operlog = function Operlog() {
  return __webpack_require__.e/* import() */(492).then(__webpack_require__.bind(null, 1484));
};
var ApprovalList = function ApprovalList() {
  return __webpack_require__.e/* import() */(107).then(__webpack_require__.bind(null, 1437));
};
var RiskEventType = function RiskEventType() {
  return __webpack_require__.e/* import() */(496).then(__webpack_require__.bind(null, 1472));
};

var WorkPlaceManage = function WorkPlaceManage() {
  return __webpack_require__.e/* import() */(364).then(__webpack_require__.bind(null, 1390));
};
var TouchHarmStation = function TouchHarmStation() {
  return __webpack_require__.e/* import() */(319).then(__webpack_require__.bind(null, 1388));
};
var DiseaseTreatment = function DiseaseTreatment() {
  return __webpack_require__.e/* import() */(274).then(__webpack_require__.bind(null, 1366));
};
var HealthSummary = function HealthSummary() {
  return __webpack_require__.e/* import() */(480).then(__webpack_require__.bind(null, 1384));
};
var LawList = function LawList() {
  return __webpack_require__.e/* import() */(133).then(__webpack_require__.bind(null, 1547));
};
var SubList = function SubList() {
  return __webpack_require__.e/* import() */(238).then(__webpack_require__.bind(null, 1548));
};
var RulesTypeList = function RulesTypeList() {
  return __webpack_require__.e/* import() */(351).then(__webpack_require__.bind(null, 1550));
};
var RulesList = function RulesList() {
  return __webpack_require__.e/* import() */(139).then(__webpack_require__.bind(null, 1549));
};
var SeTargetNameList = function SeTargetNameList() {
  return __webpack_require__.e/* import() */(113).then(__webpack_require__.bind(null, 1611));
};
var SeTargetList = function SeTargetList() {
  return __webpack_require__.e/* import() */(125).then(__webpack_require__.bind(null, 1612));
};
var SeNextList = function SeNextList() {
  return __webpack_require__.e/* import() */(153).then(__webpack_require__.bind(null, 1613));
};
var appraisal = function appraisal() {
  return __webpack_require__.e/* import() */(368).then(__webpack_require__.bind(null, 1483));
};
var EReportList = function EReportList() {
  return __webpack_require__.e/* import() */(205).then(__webpack_require__.bind(null, 1518));
};
var EReportChartList = function EReportChartList() {
  return __webpack_require__.e/* import() */(206).then(__webpack_require__.bind(null, 1517));
};
var ExpertList = function ExpertList() {
  return __webpack_require__.e/* import() */(383).then(__webpack_require__.bind(null, 1499));
};
var MaterialList = function MaterialList() {
  return __webpack_require__.e/* import() */(201).then(__webpack_require__.bind(null, 1501));
};
var TeamList = function TeamList() {
  return __webpack_require__.e/* import() */(280).then(__webpack_require__.bind(null, 1502));
};
var DrillPlanList = function DrillPlanList() {
  return __webpack_require__.e/* import() */(217).then(__webpack_require__.bind(null, 1494));
};
var EntAttList = function EntAttList() {
  return __webpack_require__.e/* import() */(279).then(__webpack_require__.bind(null, 1355));
};
var StandardList = function StandardList() {
  return __webpack_require__.e/* import() */(277).then(__webpack_require__.bind(null, 1585));
};
var IndustryList = function IndustryList() {
  return __webpack_require__.e/* import() */(278).then(__webpack_require__.bind(null, 1584));
};
var DrillList = function DrillList() {
  return __webpack_require__.e/* import() */(245).then(__webpack_require__.bind(null, 1493));
};
var DutyEmployeeList = function DutyEmployeeList() {
  return __webpack_require__.e/* import() */(242).then(__webpack_require__.bind(null, 1496));
};
var operations = function operations() {
  return __webpack_require__.e/* import() */(479).then(__webpack_require__.bind(null, 1555));
};
var ProList = function ProList() {
  return __webpack_require__.e/* import() */(304).then(__webpack_require__.bind(null, 1568));
};
var HarmfulType = function HarmfulType() {
  return __webpack_require__.e/* import() */(452).then(__webpack_require__.bind(null, 1378));
};
var HarmfulBigType = function HarmfulBigType() {
  return __webpack_require__.e/* import() */(453).then(__webpack_require__.bind(null, 1376));
};
var workFactor = function workFactor() {
  return __webpack_require__.e/* import() */(214).then(__webpack_require__.bind(null, 1389));
};
var hazardFactor = function hazardFactor() {
  return __webpack_require__.e/* import() */(272).then(__webpack_require__.bind(null, 1379));
};
var fireControl = function fireControl() {
  return __webpack_require__.e/* import() */(236).then(__webpack_require__.bind(null, 1370));
};
var fireControlInput = function fireControlInput() {
  return __webpack_require__.e/* import() */(267).then(__webpack_require__.bind(null, 1371));
};
var fireHouse = function fireHouse() {
  return __webpack_require__.e/* import() */(266).then(__webpack_require__.bind(null, 1372));
};
var sending = function sending() {
  return __webpack_require__.e/* import() */(247).then(__webpack_require__.bind(null, 1387));
};
var instructions = function instructions() {
  return __webpack_require__.e/* import() */(248).then(__webpack_require__.bind(null, 1385));
};
var handle = function handle() {
  return __webpack_require__.e/* import() */(249).then(__webpack_require__.bind(null, 1375));
};

var HarmfulFactor = function HarmfulFactor() {
  return __webpack_require__.e/* import() */(419).then(__webpack_require__.bind(null, 1293));
};
var HealthExamination = function HealthExamination() {
  return __webpack_require__.e/* import() */(255).then(__webpack_require__.bind(null, 1392));
};
var ProtectAgainstRegulation = function ProtectAgainstRegulation() {
  return __webpack_require__.e/* import() */(219).then(__webpack_require__.bind(null, 1386));
};
var ProtectiveEquipmentBasic = function ProtectiveEquipmentBasic() {
  return __webpack_require__.e/* import() */(276).then(__webpack_require__.bind(null, 1361));
};
var DictionaryList = function DictionaryList() {
  return __webpack_require__.e/* import() */(353).then(__webpack_require__.bind(null, 1581));
};
var BaseConfig = function BaseConfig() {
  return __webpack_require__.e/* import() */(456).then(__webpack_require__.bind(null, 1575));
};
var TypeDictionaryList = function TypeDictionaryList() {
  return __webpack_require__.e/* import() */(294).then(__webpack_require__.bind(null, 1617));
};
var Course = function Course() {
  return __webpack_require__.e/* import() */(216).then(__webpack_require__.bind(null, 1780));
};


var AlertComp = function AlertComp() {
  return __webpack_require__.e/* import() */(398).then(__webpack_require__.bind(null, 1482));
};

var listHiddenCheckList = function listHiddenCheckList() {
  return __webpack_require__.e/* import() */(138).then(__webpack_require__.bind(null, 1448));
};

var checkSelfList = function checkSelfList() {
  return __webpack_require__.e/* import() */(157).then(__webpack_require__.bind(null, 1447));
};

var hiddenRectification = function hiddenRectification() {
  return __webpack_require__.e/* import() */(180).then(__webpack_require__.bind(null, 1444));
};

var hiddenHandle = function hiddenHandle() {
  return __webpack_require__.e/* import() */(142).then(__webpack_require__.bind(null, 1442));
};

var hiddenRecord = function hiddenRecord() {
  return __webpack_require__.e/* import() */(283).then(__webpack_require__.bind(null, 1443));
};

var checkSelf = function checkSelf() {
  return __webpack_require__.e/* import() */(204).then(__webpack_require__.bind(null, 1446));
};

var ListWelcomeInspection = function ListWelcomeInspection() {
  return __webpack_require__.e/* import() */(182).then(__webpack_require__.bind(null, 1789));
};

var ResultWelcomeInspection = function ResultWelcomeInspection() {
  return __webpack_require__.e/* import() */(146).then(__webpack_require__.bind(null, 1791));
};

var RectifyWelcomeInspection = function RectifyWelcomeInspection() {
  return __webpack_require__.e/* import() */(147).then(__webpack_require__.bind(null, 1790));
};

var AcceptWelcomeInspection = function AcceptWelcomeInspection() {
  return __webpack_require__.e/* import() */(148).then(__webpack_require__.bind(null, 1788));
};

var ResultReport = function ResultReport() {
  return __webpack_require__.e/* import() */(145).then(__webpack_require__.bind(null, 1792));
};

var factorMaintain = function factorMaintain() {
  return __webpack_require__.e/* import() */(501).then(__webpack_require__.bind(null, 1416));
};
var factorManage = function factorManage() {
  return __webpack_require__.e/* import() */(430).then(__webpack_require__.bind(null, 1417));
};
var outfall = function outfall() {
  return __webpack_require__.e/* import() */(393).then(__webpack_require__.bind(null, 1424));
};
var radiate = function radiate() {
  return __webpack_require__.e/* import() */(334).then(__webpack_require__.bind(null, 1409));
};
var epfacilities = function epfacilities() {
  return __webpack_require__.e/* import() */(394).then(__webpack_require__.bind(null, 1414));
};
var manualMonitor = function manualMonitor() {
  return __webpack_require__.e/* import() */(395).then(__webpack_require__.bind(null, 1408));
};

var discharge = function discharge() {
  return __webpack_require__.e/* import() */(240).then(__webpack_require__.bind(null, 1322));
};
var concentration = function concentration() {
  return __webpack_require__.e/* import() */(230).then(__webpack_require__.bind(null, 1395));
};
var hourCollDay = function hourCollDay() {
  return __webpack_require__.e/* import() */(343).then(__webpack_require__.bind(null, 1397));
};

var warningset = function warningset() {
  return __webpack_require__.e/* import() */(190).then(__webpack_require__.bind(null, 1785));
};

var Login = function Login(resolve) {
  return __webpack_require__.e/* require */(312).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1330)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: "history",

  routes: [{
    path: "/Login",
    name: "登录",
    component: Login
  }, {
    path: "/datastatic",
    name: "数据看板",
    component: function component() {
      return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1325));
    }
  }, {
    path: "/operationSupervision",
    name: "作业一张图",
    component: function component() {
      return __webpack_require__.e/* import() */(90).then(__webpack_require__.bind(null, 1341));
    }
  }, {
    path: "/monitoringAlarm",
    name: "AI预警管控",
    component: function component() {
      return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 1340));
    }
  }, {
    path: "/datastatic3",
    name: "集团看板",
    component: function component() {
      return __webpack_require__.e/* import() */(108).then(__webpack_require__.bind(null, 1326));
    }
  }, {
    path: "/tsrlWelcome",
    name: "集团看板",
    component: function component() {
      return __webpack_require__.e/* import() */(517).then(__webpack_require__.bind(null, 1343));
    }
  }, {
    path: "/videoSurveillance",
    name: "视频监控",
    component: function component() {
      return __webpack_require__.e/* import() */(411).then(__webpack_require__.bind(null, 1331));
    }
  }, {
    path: "/workConditionMap",
    name: "环保总览",
    component: function component() {
      return __webpack_require__.e/* import() */(119).then(__webpack_require__.bind(null, 1327));
    }
  }, {
    path: "/envProDcsDatastatic",
    name: "环保DCS",
    component: function component() {
      return __webpack_require__.e/* import() */(132).then(__webpack_require__.bind(null, 1328));
    }
  }, {
    path: "/gassAlarm",
    name: "煤气一张图",
    component: function component() {
      return __webpack_require__.e/* import() */(136).then(__webpack_require__.bind(null, 1329));
    }
  }, {
    path: "/workCertificatePreview_LIMIT",
    name: "受限空间作业证预览",
    component: function component() {
      return __webpack_require__.e/* import() */(405).then(__webpack_require__.bind(null, 1274));
    }
  }, {
    path: "/workCertificateBookPreview_LIMIT",
    name: "受限空间告知书预览",
    component: function component() {
      return __webpack_require__.e/* import() */(418).then(__webpack_require__.bind(null, 1337));
    }
  }, {
    path: "/workCertificatePreview_FIRE",
    name: "动火作业证预览",
    component: function component() {
      return __webpack_require__.e/* import() */(400).then(__webpack_require__.bind(null, 1270));
    }
  }, {
    path: "/workCertificateBookPreview_FIRE",
    name: "动火作业告知书预览",
    component: function component() {
      return __webpack_require__.e/* import() */(406).then(__webpack_require__.bind(null, 1334));
    }
  }, {
    path: "/workCertificatePreview_HIGH",
    name: "高处安全作业证预览",
    component: function component() {
      return __webpack_require__.e/* import() */(415).then(__webpack_require__.bind(null, 1272));
    }
  }, {
    path: "/workCertificateBookPreview_HIGH",
    name: "高处作业告知书预览",
    component: function component() {
      return __webpack_require__.e/* import() */(416).then(__webpack_require__.bind(null, 1335));
    }
  }, {
    path: "/workCertificatePreview_LIFT",
    name: "吊装安全作业证预览",
    component: function component() {
      return __webpack_require__.e/* import() */(413).then(__webpack_require__.bind(null, 1273));
    }
  }, {
    path: "/workCertificateBookPreview_LIFT",
    name: "吊装作业告知书预览",
    component: function component() {
      return __webpack_require__.e/* import() */(414).then(__webpack_require__.bind(null, 1336));
    }
  }, {
    path: "/workCertificatePreview_TEMP",
    name: "临时用电安全作业证预览",
    component: function component() {
      return __webpack_require__.e/* import() */(407).then(__webpack_require__.bind(null, 1275));
    }
  }, {
    path: "/workCertificateBookPreview_TEMP",
    name: "临时用电告知书预览",
    component: function component() {
      return __webpack_require__.e/* import() */(412).then(__webpack_require__.bind(null, 1338));
    }
  }, {
    path: "/workCertificatePreview_GROUND",
    name: "动土安全作业作业证预览",
    component: function component() {
      return __webpack_require__.e/* import() */(417).then(__webpack_require__.bind(null, 1271));
    }
  }, {
    path: "/workCertificatePreview_BLIND",
    name: "盲板抽堵安全作业证预览",
    component: function component() {
      return __webpack_require__.e/* import() */(437).then(__webpack_require__.bind(null, 1268));
    }
  }, {
    path: "/workCertificatePreview_BROKEN",
    name: "断路安全作业证预览",
    component: function component() {
      return __webpack_require__.e/* import() */(434).then(__webpack_require__.bind(null, 1269));
    }
  }, {
    path: "/workCertificatePreview_Audit",
    name: "危险作业审批表预览",
    component: function component() {
      return __webpack_require__.e/* import() */(433).then(__webpack_require__.bind(null, 1281));
    }
  }, {
    path: "/workCertificateBookPreview_Audit",
    name: "风险告知卡预览",
    component: function component() {
      return __webpack_require__.e/* import() */(432).then(__webpack_require__.bind(null, 1282));
    }
  }, {
    path: "/workCertificatePreview_hyMeeting",
    name: "班前会记录预览",
    component: function component() {
      return __webpack_require__.e/* import() */(441).then(__webpack_require__.bind(null, 1290));
    }
  }, {
    path: "/workCertificatePreview_GC",
    name: "外包工程作业票预览",
    component: function component() {
      return __webpack_require__.e/* import() */(436).then(__webpack_require__.bind(null, 1283));
    }
  }, {
    path: "/workCertificatePreview_printHealthPromisePage",
    name: "健康承诺表预览",
    component: function component() {
      return __webpack_require__.e/* import() */(489).then(__webpack_require__.bind(null, 1280));
    }
  }, {
    path: "/workCertificatePreview_bind",
    name: "用户绑定公众号",
    component: function component() {
      return __webpack_require__.e/* import() */(518).then(__webpack_require__.bind(null, 1333));
    }
  }, {
    path: "/workCertificatePreview_MQZY",
    name: "煤气停送作业票预览",
    component: function component() {
      return __webpack_require__.e/* import() */(435).then(__webpack_require__.bind(null, 1285));
    }
  }, {
    path: "/workCertificatePreview_printGasOperatePage",
    name: "煤气操作票预览",
    component: function component() {
      return __webpack_require__.e/* import() */(469).then(__webpack_require__.bind(null, 1284));
    }
  }, {
    path: "/workCertificatePreview_SchemePage",
    name: "高风险检修方案预览",
    component: function component() {
      return __webpack_require__.e/* import() */(311).then(__webpack_require__.bind(null, 1286));
    }
  }, {
    path: "/",
    name: "home",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    redirect: "/dashboard",
    leaf: true,
    menuShow: true,
    iconCls: "fa fa-home",
    children: [{
      path: "/dashboard",
      component: Dashboard,
      name: "首页",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "用户管理",
    menuShow: true,
    leaf: true,
    iconCls: "fa fa-user",
    children: [{
      path: "/admin/user",
      component: UserList,
      name: "用户列表",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "流程管理",
    menuShow: true,
    leaf: true,
    iconCls: "fa fa-user",
    children: [{
      path: "/activiti/manager",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(355).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1481)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "流程绑定",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "菜单管理",
    menuShow: true,
    leaf: true,
    iconCls: "fa fa-server",
    children: [{
      path: "/admin/menu",
      component: MenuList,
      name: "菜单列表",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "应急管理",
    menuShow: true,
    leaf: true,
    iconCls: "fa fa-server",
    children: [{
      path: "/emergency/expert",
      component: ExpertList,
      name: "应急专家",
      menuShow: true
    }, {
      path: "/emergency/materials",
      component: MaterialList,
      name: "应急物资",
      menuShow: true
    }, {
      path: "/emergency/team",
      component: TeamList,
      name: "应急队伍",
      menuShow: true
    }, {
      path: "/emergency/drillplan",
      component: DrillPlanList,
      name: "演练计划",
      menuShow: true
    }, {
      path: "/emergency/drill",
      component: DrillList,
      name: "应急演练",
      menuShow: true
    }, {
      path: "/emergency/dutyemployee",
      component: DutyEmployeeList,
      name: "应急值守人员",
      menuShow: true
    }, {
      path: "/emergency/dutyevent",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(207).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1495)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "值班排班",
      menuShow: true
    }, {
      path: "/emergency/emanagement",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(141).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1498)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "应急预案",
      menuShow: true
    }, {
      path: "/emergency/eventdeal",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(127).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1497)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "应急事件处理",
      menuShow: true
    }, {
      path: "/emergency/fireEquipment",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(174).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1500)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "消防设施",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "角色管理",
    menuShow: true,
    leaf: true,
    iconCls: "fa fa-group",
    children: [{
      path: "/admin/role",
      component: BookList,
      name: "角色列表",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "报表管理",
    menuShow: true,
    leaf: true,
    iconCls: "fa fa-group",
    children: [{
      path: "/admin/chart/list",
      component: ChartsConfList,
      name: "报表列表",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "设置",
    menuShow: true,
    iconCls: "iconfont icon-setting1",
    children: [{
      path: "/user/profile",
      component: UserProfile,
      name: "个人信息1",
      menuShow: true
    }, {
      path: "/user/changepwd",
      component: UserChangePwd,
      name: "修改密码",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "注册服务",
    menuShow: true,
    iconCls: "iconfont icon-setting1",
    children: [{
      path: "/service",
      component: UserProfile,
      redirect: "http://baidu.com",
      target: "_blank",
      name: "注册服务列表",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "部门管理菜单",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/department",
      component: Department,
      name: "部门管理",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "企业管理",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/ent",
      component: Ent,
      name: "企业基本信息",
      menuShow: true
    }, {
      path: "/eFilingManagement",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(118).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1354)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "备案管理模块",
      menuShow: true
    }, {
      path: "/custommenu",
      component: Custommenu,
      name: "菜单订制",
      menuShow: true
    }, {
      path: "/smsmanger",
      component: Smsmanger,
      name: "短信管理",
      menuShow: true
    }, {
      path: "/appraisal",
      component: appraisal,
      name: "绩效考核",
      menuShow: true
    }, {
      path: "/exportFileList",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(366).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1530)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "导出文件列表",
      menuShow: true
    }, {
      path: "/employee",
      component: Employee,
      name: "员工管理",
      menuShow: true
    }, {
      path: "/warningset",
      component: warningset,
      name: "预警设置",
      menuShow: true
    }, {
      path: "/diseasesType",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(442).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1292)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "职业病种类管理",
      menuShow: true
    }, {
      path: "/workPlaceManage",
      component: WorkPlaceManage,
      name: "工作场所管理",
      menuShow: true
    }, {
      path: "/touchHarmStation",
      component: TouchHarmStation,
      name: "接害岗位备案",
      menuShow: true
    }, {
      path: "/diseaseTreatment",
      component: DiseaseTreatment,
      name: "职业病诊疗档案",
      menuShow: true
    }, {
      path: "/healthSummary",
      component: HealthSummary,
      name: "职业健康汇总",
      menuShow: true
    }, {
      path: "/healthCustodyPerson",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(271).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1381)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "个人监护档案",
      menuShow: true
    }, {
      path: "/healthMedicalRecord",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(287).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1383)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "既往病史管理",
      menuShow: true
    }, {
      path: "/healthMedicalHistory",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(273).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1382)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "职业病史管理",
      menuShow: true
    }, {
      path: "/healthContactHistory",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(288).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1380)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "职业病危害接触史管理",
      menuShow: true
    }, {
      path: "/erule/list",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(192).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1521)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "规章制度",
      menuShow: true
    }, {
      path: "/harmfulDiscern",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(481).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1377)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "职业病危害因素识别",
      menuShow: true
    }, {
      path: "/typeOfWork",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(223).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1393)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "岗位管理",
      menuShow: true
    }, {
      path: "/exposedPerson",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(303).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1367)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "职业危害人员",
      menuShow: true
    }, {
      path: "/organization",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(189).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1556)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "机构管理",
      menuShow: true
    }, {
      path: "/organization/user",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(186).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1557)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "机构人员管理",
      menuShow: true
    }, {
      path: "/eTypeDictionary/list",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(295).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1616)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "企业类型管理",
      menuShow: true
    }, {
      path: "/eRegulations/list",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(156).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1601)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "操作规程",
      menuShow: true
    }, {
      path: "/bounded/list",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(318).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1577)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "有（受）限空间管理",
      menuShow: true
    }, {
      path: "/testing/list",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(263).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1615)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "第三方检测",
      menuShow: true
    }, {
      path: "/assessment/list",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(264).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1574)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "第三方评估",
      menuShow: true
    }, {
      path: "/dust/list",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(338).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1582)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "粉尘涉爆",
      menuShow: true
    }, {
      path: "/messageNotification/message",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(203).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1364)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "消息通知",
      menuShow: true
    }, {
      path: "/messageNotification/notify",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(486).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1365)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "通知下发",
      menuShow: true
    }, {
      path: "/videoDevice/videoConfig",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(282).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1394)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "视频配置",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "制度化建设",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/complainceComment",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(332).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1489)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "合规性评价",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "消防巡查",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/fireCheckCfg",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(520).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1368)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "巡查项目",
      menuShow: true
    }, {
      path: "/fireCheckpoint",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(237).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1369)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "消防巡查点",
      menuShow: true
    }, {
      path: "/fireInspect",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(212).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1373)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "消防巡查记录表",
      menuShow: true
    }, {
      path: "/fireMaintain",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(329).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1374)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "消防维保记录",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "职业健康管理",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/harmfulType",
      component: HarmfulType,
      name: "职业病危害类型管理",
      menuShow: true
    }, {
      path: "/harmfulBigType",
      component: HarmfulBigType,
      name: "职业病大类管理",
      menuShow: true
    }, {
      path: "/workFactor",
      component: workFactor,
      name: "工作场所危害因素",
      menuShow: true
    }, {
      path: "/hazardFactor",
      component: hazardFactor,
      name: "工作场所危害因素检测",
      menuShow: true
    }, {
      path: "/fireControl",
      component: fireControl,
      name: "消防台账",
      menuShow: true
    }, {
      path: "/fireHouse",
      component: fireHouse,
      name: "消防站配置",
      menuShow: true
    }, {
      path: "/fireControlInput",
      component: fireControlInput,
      name: "消防器材点检记录",
      menuShow: true
    }, {
      path: "/sending",
      component: sending,
      name: "来文登记",
      menuShow: true
    }, {
      path: "/instructions",
      component: instructions,
      name: "来文登记",
      menuShow: true
    }, {
      path: "/handle",
      component: handle,
      name: "来文办理",
      menuShow: true
    }, {
      path: "/harmfulFactor",
      component: HarmfulFactor,
      name: "职业病危害因素管理",
      menuShow: true
    }, {
      path: "/healthExamination",
      component: HealthExamination,
      name: "职业健康检查管理",
      menuShow: true
    }, {
      path: "/protectAgainstRegulation",
      component: ProtectAgainstRegulation,
      name: "防护违章情况",
      menuShow: true
    }, {
      path: "/protectiveEquipmentBasic",
      component: ProtectiveEquipmentBasic,
      name: "劳动防护用品基础信息管理",
      menuShow: true
    }, {
      path: "/protectiveEquipmentRecord",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(320).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1362)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "劳动防护用品发放管理",
      menuShow: true
    }, {
      path: "/protectiveEquipmentReport",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(487).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1363)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "劳保用品统计报表",
      menuShow: true
    }, {
      path: "/healthPromiseBook",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(317).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1534)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "健康承诺书",
      menuShow: true
    }, {
      path: "/workAreaConfirm",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(378).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1536)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "作业区确认",
      menuShow: true
    }, {
      path: "/deptLeaderConfirm",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(379).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1535)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "部门确认",
      menuShow: true
    }, {
      path: "/laborProtection/lpCfg",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(131).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1551)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "劳保配置清单",
      menuShow: true
    }, {
      path: "/laborProtection/personLp",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(168).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1553)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "个人劳保卡",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "涉危情况管理",
    menuShow: true,
    leaf: true,
    children: []
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "ereport",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/ereport",
      component: EReportList,
      name: "事件上报",
      menuShow: true
    }, {
      path: "/ereportAudit",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(229).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1516)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "事件上报审核",
      menuShow: true
    }, {
      path: "/chart",
      component: EReportChartList,
      name: "事件展示",
      menuShow: true
    }, {
      path: "/reportDistribute",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(380).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1519)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "事件派发",
      menuShow: true
    }, {
      path: "/reportRectification",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(330).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1520)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "事件整改",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "post manager",
    menuShow: true,
    leaf: true,
    children: [{ path: "/post", component: Post, name: "职务管理", menuShow: true }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "job manager",
    menuShow: true,
    leaf: true,
    children: [{ path: "/job", component: Job, name: "岗位管理", menuShow: true }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "riskManagement public",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/publicRiskUnit",
      component: publicRiskUnit,
      name: "行业公有风险单元",
      menuShow: true
    }, {
      path: "/base/basicInfo",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(420).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1294)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "隐患基础信息管理",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "Relevant",
    menuShow: true,
    leaf: true,
    children: []
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "车辆管理",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/ecar",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(175).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1491)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "车辆登记",
      menuShow: true
    }, {
      path: "/ecar/use",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(213).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1492)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "车辆派单",
      menuShow: true
    }, {
      path: "/ecar/repair",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(227).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1299)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "车辆保险",
      menuShow: true
    }, {
      path: "/ecar/inspection",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(228).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1298)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "车辆维修",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "inspection",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/basicInfo",
      component: BasicInfo,
      name: "隐患基础信息管理",
      menuShow: true
    }, {
      path: "/hrepository",
      component: HRepository,
      name: "隐患库管理",
      menuShow: true
    }, {
      path: "/checkList/addFlow",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(100).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1434)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "listCheckAdd",
      menuShow: true
    }, {
      path: "/hidden/list",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(134).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1445)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "隐患查询列表",
      menuShow: true
    }, {
      path: "/check/list",
      component: CheckList,
      name: "排查列表",
      menuShow: true
    }, {
      path: "/checkTabList",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(341).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1436)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "制定检查表",
      menuShow: true
    }, {
      path: "/checkList",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(197).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1433)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "隐患单管理",
      menuShow: true
    }, {
      path: "/hiddenCheckList",
      component: listHiddenCheckList,
      name: "隐患单排查",
      menuShow: true
    }, {
      path: "/checkSelfList",
      component: checkSelfList,
      name: "自检自查",
      menuShow: true
    }, {
      path: "/checkSelf",
      component: checkSelf,
      name: "自检自查",
      menuShow: true
    }, {
      path: "/hiddenHandle",
      component: hiddenHandle,
      name: "隐患处理",
      menuShow: true
    }, {
      path: "/hiddenRecord",
      component: hiddenRecord,
      name: "排查记录查询",
      menuShow: true
    }, {
      path: "/hiddenApprove",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(289).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1440)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "隐患排查确认",
      menuShow: true
    }, {
      path: "/listHiddenRectification",
      component: hiddenRectification,
      name: "隐患整改",
      menuShow: true
    }, {
      path: "/check/add",
      component: CheckAdd,
      name: "排查新增",
      menuShow: true
    }, {
      path: "/picture/hiddenAudit",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(342).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1533)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "随手拍审核",
      menuShow: true
    }, {
      path: "/picture/hiddenPub",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(246).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1288)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "随手拍公共上报组件",
      menuShow: true
    }, {
      path: "/abar/abarbeitung",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(97).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1431)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "abarbeitung",
      menuShow: true
    }, {
      path: "/hiddenAudit/detail",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(86).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1441)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "hiddenAuditDetail",
      menuShow: true
    }, {
      path: "/review/review",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(110).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1450)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "review",
      menuShow: true
    }, {
      path: "/review/detail",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(111).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1449)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "/review/detail",
      menuShow: true
    }, {
      path: "/review/reviewaudit",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(101).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1451)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "reviewaudit",
      menuShow: true
    }, {
      path: "/MajorHazard/MajorHazard",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(116).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1430)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "MajorHazard",
      menuShow: true
    }, {
      path: "/report/reportEdit",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(112).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1439)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "ReportEdit",
      menuShow: true
    }, {
      path: "/sisetu",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(164).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1452)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "四色图",
      menuShow: true
    }, {
      path: "/fourColorMap",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(224).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1531)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "新四色图",
      menuShow: true
    }, {
      path: "/handPicture/list",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(337).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1532)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "随手拍",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "backlog",
    menuShow: true,
    leaf: false,
    children: [{
      path: "/backlog",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(363).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1348)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "待办事项",
      menuShow: true,
      leaf: true
    }, {
      path: "/sysRunCheck",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(259).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1636)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "预警管理",
      menuShow: true,
      leaf: true
    }, {
      path: "/analyzeList",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(254).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1635)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "预警分析",
      menuShow: true,
      leaf: true
    }, {
      path: "/relevant/payconfirm",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(258).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1637)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "外包单位缴费确认",
      menuShow: true,
      leaf: true
    }, {
      path: "/haveDone",
      component: HaveDone,
      name: "已办事项",
      menuShow: true,
      leaf: false
    }, {
      path: "/crew",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(373).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1562)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "作业区班组成员",
      menuShow: true,
      leaf: true
    }, {
      path: "/supervise",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(371).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1567)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "班前会监管人员",
      menuShow: true,
      leaf: true
    }, {
      path: "/ledge",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(170).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1565)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "班前会记录",
      menuShow: true,
      leaf: true
    }, {
      path: "/preShiftMeeting/meetingRecord",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(357).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1301)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "会议记录表",
      menuShow: true,
      leaf: true
    }, {
      path: "/dayMeet",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(335).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1563)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "日会议预警表",
      menuShow: true,
      leaf: true
    }, {
      path: "/monthlyMeet",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(372).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1566)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "月度会议汇总表",
      menuShow: true,
      leaf: true
    }, {
      path: "/preShiftMeeting/check/:type",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(624)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "班组检查内容",
      menuShow: true,
      leaf: true
    }, {
      path: "/inspect",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(296).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1564)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "班组安全检查记录表",
      menuShow: true,
      leaf: true
    }, {
      path: "/operationLog",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(470).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1620)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "系统操作记录",
      menuShow: true,
      leaf: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "riskPosition",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/riskPosition",
      component: RiskPosition,
      name: "风险点位置",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "operlog",
    menuShow: true,
    leaf: true,
    children: [{ path: "/Operlog", component: Operlog, name: "操作日志", menuShow: true }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "version",
    menuShow: true,
    leaf: true,
    children: [{ path: "/version", component: Version, name: "版本号", menuShow: true }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "approvalList",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/approvalList",
      component: ApprovalList,
      name: "审批",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "风险管控",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/riskControl",
      component: RiskControl,
      name: "风险分级管控",
      menuShow: true
    }, {
      path: "/pesrsonRiskControl",
      component: pesrsonRiskControl,
      name: "风险清单",
      menuShow: true
    }, {
      path: "/riskControlExport",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(497).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1470)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "风险巡查统计",
      menuShow: true
    }, {
      path: "/safetySignsType",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(346).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1603)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "安全标志类型管理",
      menuShow: true
    }, {
      path: "/safetySigns",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(184).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1604)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "安全标志管理",
      menuShow: true
    }, {
      path: "/riskUnit",
      component: RiskUnit,
      name: "风险单元",
      menuShow: true
    }, {
      path: "/riskControlCalerdar",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(181).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1469)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "风险管控日历",
      menuShow: true
    }, {
      path: "/riskEventType",
      component: RiskEventType,
      name: "企业事故类型管理",
      menuShow: true
    }, {
      path: "/personnelPatrol",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(495).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1475)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "人员巡查情况",
      menuShow: true
    }, {
      path: "/riskPatrol",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(299).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1473)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "风险点巡查情况",
      menuShow: true
    }, {
      path: "/riskControlInfo",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(297).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1471)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "风险管控信息",
      menuShow: true
    }, {
      path: "/riskPatrolTaskList",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(323).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1474)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "巡查任务清单",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "安全管理",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/safescore/stand",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(491).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1515)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "安全记分标准",
      menuShow: true
    }, {
      path: "/safescore/type",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(490).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1300)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "安全记分类型",
      menuShow: true
    }, {
      path: "/safescore/report",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(128).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1289)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "安全记分上报",
      menuShow: true
    }, {
      path: "/safescore/scAudit",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(193).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1513)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "安全记分上报审核",
      menuShow: true
    }, {
      path: "/safescore/scAuditFinal",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(225).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1514)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "安全记分上报提级审批",
      menuShow: true
    }, {
      path: "/safescore/ledger",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(239).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1512)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "安全记分台账",
      menuShow: true
    }, {
      path: "/meetingCommittee",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(275).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1587)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "安委会、例会",
      menuShow: true
    }, {
      path: "/meetingClass",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(285).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1586)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "班委会",
      menuShow: true
    }, {
      path: "/securityMeeting",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(327).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1605)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "安全会议",
      menuShow: true
    }, {
      path: "/hazardSources/list",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(347).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1583)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "重大危险源",
      menuShow: true
    }, {
      path: "/devicesKeyparts/list",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(348).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1580)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "关键装置和重点部位",
      menuShow: true
    }, {
      path: "/danger/list",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(349).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1579)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "危险化工工艺",
      menuShow: true
    }, {
      path: "/blame/blameList",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(302).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1576)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "追责问责清单",
      menuShow: true
    }, {
      path: "/endangeredProduct",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(331).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1357)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "涉危产品管理",
      menuShow: true
    }, {
      path: "/enterprise/hazardousmaterials/list",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(269).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1359)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "原辅助材料",
      menuShow: true
    }, {
      path: "/EnterpriseFile/Equipment",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(99).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1503)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "设备设施管理",
      menuShow: true
    }, {
      path: "/EnterpriseFile/special",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(187).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1504)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "特种设备管理",
      menuShow: true
    }, {
      path: "/EnterpriseFile/maintainPlan",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(352).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1511)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "设备设施维护保养计划",
      menuShow: true
    }, {
      path: "/EnterpriseFile/inspectBase",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(124).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1505)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "设备设施点检模板",
      menuShow: true
    }, {
      path: "/EnterpriseFile/inspect",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(75).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1506)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "设备设施点检",
      menuShow: true
    }, {
      path: "/relevant",
      component: Relevant,
      name: "相关方管理",
      menuShow: true
    }, {
      path: "/relevant/project",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(195).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1746)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "委外项目施工信息",
      menuShow: true
    }, {
      path: "/relevant/relevantDirectory",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(149).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1745)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "相关方名录",
      menuShow: true
    }, {
      path: "/relevantApproval",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(218).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1744)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "相关方审批",
      menuShow: true
    }, {
      path: "/relevantExamineBase",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(114).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1739)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "相关方考核模板",
      menuShow: true
    }, {
      path: "/relevantExamine",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(306).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1741)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "相关方考核",
      menuShow: true
    }, {
      path: "/relevantExamineFuben",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(409).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1740)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "相关方考核",
      menuShow: true
    }, {
      path: "/relevantExamineApproval",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(315).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1738)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "相关方考核审批",
      menuShow: true
    }, {
      path: "/relevantRisk",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(404).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1749)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "相关方作业行为风险评估",
      menuShow: true
    }, {
      path: "/relevantRiskBase",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(428).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1748)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "风险评估项目管理设置",
      menuShow: true
    }, {
      path: "/rel/check/1",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(624)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "检查内容",
      menuShow: true
    }, {
      path: "/rel/config",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(450).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1742)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "级别配置",
      menuShow: true
    }, {
      path: "/rel/inspect",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(281).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1743)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "监督检查表",
      menuShow: true
    }, {
      path: "/relevantCheck",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(291).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1737)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "施工方现场检查记录",
      menuShow: true
    }, {
      path: "/relevantCheckBase",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(429).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1736)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "施工方现场检查项目设置",
      menuShow: true
    }, {
      path: "/relevantSafety",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(333).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1750)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "安全告知管理",
      menuShow: true
    }, {
      path: "/meetingPlan",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(202).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1588)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "会议计划",
      menuShow: true
    }, {
      path: "/blacklist",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(493).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1735)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "黑名单",
      menuShow: true
    }, {
      path: "/assessmentRanking",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(519).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1734)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "考核排名",
      menuShow: true
    }, {
      path: "/EnterpriseFile/maintain",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(122).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1510)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "设备保养记录",
      menuShow: true
    }, {
      path: "/security/spAssManagement",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(474).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1592)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "考核标准管理",
      menuShow: true
    }, {
      path: "/security/spTempManagement",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(310).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1599)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "考核模板管理",
      menuShow: true
    }, {
      path: "/security/spPerReport",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(188).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1595)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "绩效填报",
      menuShow: true
    }, {
      path: "/security/spPermanagement",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(270).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1597)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "绩效管理",
      menuShow: true
    }, {
      path: "/security/spScoringCriteria",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(471).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1598)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "薪酬得分标准",
      menuShow: true
    }, {
      path: "/security/spDeductionDetails",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(472).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1594)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "扣分明细表",
      menuShow: true
    }, {
      path: "/security/spDeductStatistics",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(473).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1593)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "奖扣分统计表",
      menuShow: true
    }, {
      path: "/security/evaluateTable",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(439).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1590)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "安全生产责任制考评表",
      menuShow: true
    }, {
      path: "/security/spPerUser",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(361).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1596)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "自动考评人员维护",
      menuShow: true
    }, {
      path: "/security/spApprove",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(475).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1591)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "领导审批",
      menuShow: true
    }, {
      path: "/safeMonth/sTemplate",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(253).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1570)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "工作清单制定",
      menuShow: true
    }, {
      path: "/safeMonth/planList",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(172).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1569)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "工作内容录入",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "汇总统计",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/chart/inspection",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(354).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1625)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "隐患情况",
      menuShow: true
    }, {
      path: "/chart/edu",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(426).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1622)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "教育培训",
      menuShow: true
    }, {
      path: "/chart/licence",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(423).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1626)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "证照",
      menuShow: true
    }, {
      path: "/chart/equip",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(425).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1623)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "设备设施",
      menuShow: true
    }, {
      path: "/chart/specialEquip",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(421).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1628)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "特种设备",
      menuShow: true
    }, {
      path: "/chart/health",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(424).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1624)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "职业健康",
      menuShow: true
    }, {
      path: "/chart/drill",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(427).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1621)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "应急演练统计",
      menuShow: true
    }, {
      path: "/chart/risk",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(422).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1627)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "风险管控",
      menuShow: true
    }, {
      path: "/eventReport",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(381).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1629)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "事故上报",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "knowledgeBaseLawList",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/knowledgeBase/lawList",
      component: LawList,
      name: "法律法规",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "knowledgeBaseSublist",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/knowledgeBase/sublist",
      component: SubList,
      name: "法律法规（子公司）",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "knowledgeBaseRulesTypeList",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/knowledgeBase/rulesTypeList",
      component: RulesTypeList,
      name: "规程类型",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "knowledgeBaseRulesList",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/knowledgeBase/rulesList",
      component: RulesList,
      name: "规程",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "安全目标名称",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/security/seTargetName",
      component: SeTargetNameList,
      name: "安全目标名称管理",
      menuShow: true
    }, {
      path: "/security/seGroup",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(370).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1614)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "分组人员",
      menuShow: true
    }, {
      path: "/security/accessList",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(126).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1610)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "计划评价",
      menuShow: true
    }]

  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "安全目标",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/security/seTarget",
      component: SeTargetList,
      name: "安全目标管理",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "securitySeNextList",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/security/seNextList",
      component: SeNextList,
      name: "待完成安全目标",
      menuShow: true
    }]
  },, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "dangerousJobFire",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/task/auditTask/list",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1638)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "特殊作业审批表",
      menuShow: true
    }, {
      path: "/auditTask/file",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(325).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1305)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "打印审批表",
      menuShow: true
    }, {
      path: "/auditTask/hazardFile",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(324).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1306)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "风险告知卡",
      menuShow: true
    }, {
      path: "/HotWork/dangerousJobFire",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(392).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1457)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "动火作业初步申请",
      menuShow: true
    }, {
      path: "/task/lgnitionTask/list",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1699)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "动火作业证",
      menuShow: true
    }, {
      path: "/lgnitionTask/sign",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(48).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1696)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "审批",
      menuShow: true
    }, {
      path: "/lgnitionTask/preliminaryAudit",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(47).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1693)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "初审",
      menuShow: true
    }, {
      path: "/lgnitionTask/whenHot",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(43).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1697)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "证件动火",
      menuShow: true
    }, {
      path: "/lgnitionTask/monitorCheck",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(44).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1692)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "当班班长验票",
      menuShow: true
    }, {
      path: "/lgnitionTask/analysisData",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(34).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1691)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "动火分析数据",
      menuShow: true
    }, {
      path: "/lgnitionTask/safetyMeasures",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(33).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1695)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "动火安全措施落实",
      menuShow: true
    }, {
      path: "/lgnitionTask/workCertificate",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(22).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1698)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "证件打印",
      menuShow: true
    }, {
      path: "/lgnitionTask/safetyEducation",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(77).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1694)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "安全教育人确认",
      menuShow: true
    }, {
      path: "/lgnitionTask/file",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(23).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1313)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "证件归档",
      menuShow: true
    }, {
      path: "/lgnitionTask/acceptance",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(40).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1690)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "证件验收",
      menuShow: true
    }, {
      path: "/lgnitionTask/listBase",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(448).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1722)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "证件基础安全措施信息",
      menuShow: true
    }, {
      path: "/lgnitionTask/reportJobFire",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(19).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1659)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "动火作业证申请",
      menuShow: true
    }, {
      path: "/HotWork/reportJobFire",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(391).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1459)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "动火申请",
      menuShow: true
    }, {
      path: "/HotWork/dangerousJobBasics",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(459).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1456)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "动火措施基础信息",
      menuShow: true
    }, {
      path: "/HotWork/preliminaryAudit",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(215).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1458)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "初步审核",
      menuShow: true
    }, {
      path: "/HotWork/OnSiteAudit",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(220).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1453)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "现场审核",
      menuShow: true
    }, {
      path: "/HotWork/sign",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(176).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1460)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "会签",
      menuShow: true
    }, {
      path: "/HotWork/workCertificate",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(163).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1461)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "作业证打印",
      menuShow: true
    }, {
      path: "/HotWork/WhenHot",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(178).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1454)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "动火",
      menuShow: true
    }, {
      path: "/HotWork/acceptance",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(177).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1455)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "验收",
      menuShow: true
    }, {
      path: "/limitSpace/list",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1711)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "受限空间安全作业证管理",
      menuShow: true
    }, {
      path: "/highWok/list",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1674)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "高处安全作业管理",
      menuShow: true
    }, {
      path: "/blindTakeBlock",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1639)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "盲板抽堵安全作业证管理",
      menuShow: true
    }, {
      path: "/leftWok/list",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1688)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "吊装安全作业管理",
      menuShow: true
    }, {
      path: "/leftWok/leftWokAdd",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(104).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1277)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "吊装作业申请",
      menuShow: true
    }, {
      path: "/leftWok/safetyMeasures",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(91).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1684)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "吊装安全措施落实",
      menuShow: true
    }, {
      path: "/leftWok/safetyEducation",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(78).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1683)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "吊装安全教育人确认",
      menuShow: true
    }, {
      path: "/leftWok/workAccept",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(52).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1686)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "接受交底人签字",
      menuShow: true
    }, {
      path: "/leftWok/acceptance",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(55).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1679)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "吊装证件验收",
      menuShow: true
    }, {
      path: "/leftWok/preliminaryAudit",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(98).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1681)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "吊装证初步审核",
      menuShow: true
    }, {
      path: "/leftWok/sign",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(53).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1685)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "吊装证审核部门审核",
      menuShow: true
    }, {
      path: "/leftWok/assignment",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(54).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1680)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "吊装证作业",
      menuShow: true
    }, {
      path: "/leftWok/workCertificate",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(27).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1687)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "吊装作业证打印",
      menuShow: true
    }, {
      path: "/leftWok/reportJobFire",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(17).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1682)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "吊装重新申请",
      menuShow: true
    }, {
      path: "/leftWok/file",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(25).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1312)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "吊装作业证打印按钮",
      menuShow: true
    }, {
      path: "/tempEle/list",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1732)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "临时用电安全作业管理",
      menuShow: true
    }, {
      path: "/tempEle/tempEleAdd",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(109).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1279)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "临时用电作业申请",
      menuShow: true
    }, {
      path: "/tempEle/preliminaryAudit",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(102).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1726)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "临时用电初步审核",
      menuShow: true
    }, {
      path: "/tempEle/analysisData",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(32).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1724)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "临时用电数据分析",
      menuShow: true
    }, {
      path: "/tempEle/sign",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(87).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1729)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "临时用电会签",
      menuShow: true
    }, {
      path: "/tempEle/deptAudit",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(63).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1725)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "临时用电审批",
      menuShow: true
    }, {
      path: "/tempEle/workCertificate",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(30).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1731)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "临时用电作业证打印",
      menuShow: true
    }, {
      path: "/tempEle/safetyEducation",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(64).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1728)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "临时用电安全教育人签字",
      menuShow: true
    }, {
      path: "/tempEle/whenHot",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(62).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1730)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "临时用电作业证作业",
      menuShow: true
    }, {
      path: "/tempEle/acceptance",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(71).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1723)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "临时用电作业证验收",
      menuShow: true
    }, {
      path: "/tempEle/reportJobFire",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1727)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "临时用电重新申请",
      menuShow: true
    }, {
      path: "/tempEle/file",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1317)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "临时用电打印",
      menuShow: true
    }, {
      path: "/certGround",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1648)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "动土安全作业证管理",
      menuShow: true
    }, {
      path: "/emergency",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(120).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1657)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "抢修抢险",
      menuShow: true
    }, {
      path: "/roadBroken",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1712)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "断路安全作业证管理",
      menuShow: true
    }, {
      path: "/roadBroken/roadBrokenAdd",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(93).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1278)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "断路安全作业申请",
      menuShow: true
    }, {
      path: "/roadBroken/preliminaryAudit",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(103).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1715)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "断路安全初步审核",
      menuShow: true
    }, {
      path: "/roadBroken/sign",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(88).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1718)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "断路安全会签",
      menuShow: true
    }, {
      path: "/roadBroken/deptAudit",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(65).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1714)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "断路安全审批",
      menuShow: true
    }, {
      path: "/roadBroken/workCertificate",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(31).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1720)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "断路安全作业证打印",
      menuShow: true
    }, {
      path: "/roadBroken/safetyEducation",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(66).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1717)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "断路安全安全教育人签字",
      menuShow: true
    }, {
      path: "/roadBroken/whenHot",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(72).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1719)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "断路安全作业证作业",
      menuShow: true
    }, {
      path: "/roadBroken/acceptance",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(73).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1713)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "断路安全作业证验收",
      menuShow: true
    }, {
      path: "/roadBroken/reportJobRoad",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1716)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "断路安全重新申请",
      menuShow: true
    }, {
      path: "/roadBroken/file",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(28).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1316)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "断路安全打印",
      menuShow: true
    }, {
      path: "/workSummary/list",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(468).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1733)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "特殊作业汇总",
      menuShow: true
    }, {
      path: "/limitTask/reportJobFire",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1703)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "受限空间重新申请",
      menuShow: true
    }, {
      path: "/limitTask/preliminaryAudit",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(41).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1702)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "受限空间初审",
      menuShow: true
    }, {
      path: "/limitTask/limitDeptExamine",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(39).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1706)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "受限空间审批",
      menuShow: true
    }, {
      path: "/limitTask/limitDeptExamineFinal",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(67).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1707)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "受限空间终审",
      menuShow: true
    }, {
      path: "/limitTask/limitAnalysisDataExamine",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(89).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1701)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "受限空间数据分析",
      menuShow: true
    }, {
      path: "/limitTask/workCertificate",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(26).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1710)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "受限空间作业证打印",
      menuShow: true
    }, {
      path: "/limitTask/safetyMeasures",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(92).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1705)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "受限空间安全措施",
      menuShow: true
    }, {
      path: "/limitTask/safetyEducation",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(84).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1704)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "受限空间安全教育人签字",
      menuShow: true
    }, {
      path: "/limitTask/workAccept",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(50).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1709)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "接受交底人签字",
      menuShow: true
    }, {
      path: "/limitTask/whenHot",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(42).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1708)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "受限空间作业证作业",
      menuShow: true
    }, {
      path: "/limitTask/acceptance",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(51).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1700)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "受限空间作业证验收",
      menuShow: true
    }, {
      path: "/limitTask/file",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1314)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "受限空间作业证打印",
      menuShow: true
    }, {
      path: "/blindTask/preliminaryAudit",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(96).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1642)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "盲板抽堵初审",
      menuShow: true
    }, {
      path: "/blindTask/blindDeptExamine",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(82).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1645)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "盲板抽堵会签",
      menuShow: true
    }, {
      path: "/blindTask/deptAudit",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(83).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1641)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "盲板抽堵审批",
      menuShow: true
    }, {
      path: "/blindTask/workCertificate",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(36).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1647)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "盲板抽堵作业证打印",
      menuShow: true
    }, {
      path: "/blindTask/safetyEducation",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(70).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1644)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "盲板抽堵安全教育人签字",
      menuShow: true
    }, {
      path: "/blindTask/whenHot",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(60).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1646)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "盲板抽堵作业证作业",
      menuShow: true
    }, {
      path: "/blindTask/acceptance",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(61).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1640)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "盲板抽堵作业证验收",
      menuShow: true
    }, {
      path: "/blindTask/reportJobFire",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(21).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1643)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "盲板抽堵重新申请",
      menuShow: true
    }, {
      path: "/blindTask/file",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(37).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1308)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "盲板抽堵打印",
      menuShow: true
    }, {
      path: "/highTask/preliminaryAudit",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(94).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1667)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "高处安全初审",
      menuShow: true
    }, {
      path: "/highTask/blindDeptExamine",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(56).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1671)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "高处安全会签",
      menuShow: true
    }, {
      path: "/highTask/deptAudit",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(79).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1666)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "高处安全审批",
      menuShow: true
    }, {
      path: "/highTask/workCertificate",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1673)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "高处安全作业证打印",
      menuShow: true
    }, {
      path: "/highTask/safetyMeasures",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(76).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1670)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "高处安全措施落实",
      menuShow: true
    }, {
      path: "/highTask/safetyEducation",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(68).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1669)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "高处安全安全教育人签字",
      menuShow: true
    }, {
      path: "/highTask/whenHot",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(45).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1672)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "高处安全作业证作业",
      menuShow: true
    }, {
      path: "/highTask/acceptance",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(46).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1665)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "高处安全作业证验收",
      menuShow: true
    }, {
      path: "/highTask/reportJobFire",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(18).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1668)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "高处安全重新申请",
      menuShow: true
    }, {
      path: "/highTask/file",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(24).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1291)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "高处安全打印",
      menuShow: true
    }, {
      path: "/groundTask/preliminaryAudit",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(95).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1651)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "动土作业初审",
      menuShow: true
    }, {
      path: "/groundTask/groundDeptExamine",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(80).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1654)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "动土作业会签",
      menuShow: true
    }, {
      path: "/groundTask/deptAudit",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(81).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1650)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "动土作业审批",
      menuShow: true
    }, {
      path: "/groundTask/workCertificate",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(35).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1656)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "动土作业作业证打印",
      menuShow: true
    }, {
      path: "/groundTask/safetyEducation",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(69).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1653)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "动土作业安全教育人签字",
      menuShow: true
    }, {
      path: "/groundTask/whenHot",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(58).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1655)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "动土作业作业证作业",
      menuShow: true
    }, {
      path: "/groundTask/acceptance",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(59).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1649)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "动土作业作业证验收",
      menuShow: true
    }, {
      path: "/groundTask/reportJobFire",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(20).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1652)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "动土作业重新申请",
      menuShow: true
    }, {
      path: "/groundTask/file",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(29).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1309)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "动土作业打印",
      menuShow: true
    }, {
      path: "/cert/report",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(467).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1315)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "作业票台账",
      menuShow: true
    }, {
      path: "/SmsMessage",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(521).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1619)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "短信发送记录",
      menuShow: true
    }, {
      path: "/protectTask/preliminaryAudit",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(199).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1675)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "劳保申请初审",
      menuShow: true
    }, {
      path: "/protectTask/protectDeptExamine",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(198).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1677)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "劳保申请审批",
      menuShow: true
    }, {
      path: "/protectTask/warehouseConfirmation",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(233).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1678)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "劳保发放",
      menuShow: true
    }, {
      path: "/protectTask/receiveConfirm",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(234).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1676)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "劳保领用",
      menuShow: true
    }, {
      path: "/task/engineeringWork/list",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(74).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1658)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "外包工程施工作业证",
      menuShow: true
    }, {
      path: "/task/engineeringWork/file",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(143).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1310)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "外包工程施工作业证打印",
      menuShow: true
    }, {
      path: "/lgnitionTask/WorkAccept",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(49).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1689)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "动火接受交底人确认",
      menuShow: true
    }, {
      path: "/highTask/WorkAccept",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(57).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1664)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "高处作业接受交底人确认",
      menuShow: true
    }, {
      path: "/task/gasWork/list",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(123).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1663)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "煤气停引作业证",
      menuShow: true
    }, {
      path: "/task/gasWork/file",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(211).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1662)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "煤气停引作业证打印",
      menuShow: true
    }, {
      path: "/task/gasOperateRecord/list",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(200).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1661)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "煤气操作票",
      menuShow: true
    }, {
      path: "/task/gasOperateRecord/file",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(210).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1660)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "煤气操作票打印",
      menuShow: true
    }, {
      path: "/securityBaseInfo/harzdList",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(449).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1721)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "安全风险辨识 ",
      menuShow: true
    }, {
      path: "/auditTask/schemeFile",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(241).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1307)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "高风险检修方案",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "enterpriseEntAttList",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/enterprise/entAttList",
      component: EntAttList,
      name: "企业属性",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "securityStandardList",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/security/standardList",
      component: StandardList,
      name: "行业化达标",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "securityIndustryList",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/security/industryList",
      component: IndustryList,
      name: "行业资质",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "企业体系文件",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/invest/list",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(305).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1508)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "安全投入计划",
      menuShow: true
    }, {
      path: "/invest/ledger",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(226).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1507)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "安全费用使用台账",
      menuShow: true
    }, {
      path: "/invest/subjectlist",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(382).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1509)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "费用科目",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "project manager",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/project",
      component: ProList,
      name: "项目管理",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "基础库管理",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/safetySignsBase",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(185).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1602)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "安全标志基础库管理",
      menuShow: true
    }, {
      path: "/dictionary/list",
      component: DictionaryList,
      name: "基础字典管理",
      menuShow: true
    }, {
      path: "/platformLoginConfig/list",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(167).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1600)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "平台登录配置",
      menuShow: true
    }, {
      path: "/baseconfig/list",
      component: BaseConfig,
      name: "配置中心",
      menuShow: true
    }, {
      path: "/typeDictionary/list",
      component: TypeDictionaryList,
      name: "基础类别字典管理",
      menuShow: true
    }, {
      path: "/regulations/list",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(292).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1302)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "基础操作规程",
      menuShow: true
    }, {
      path: "/dangerBase/list",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(350).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1578)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "基础危险化工工艺",
      menuShow: true
    }, {
      path: "/templateMatters",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(458).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1479)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "注意事项基础信息管理",
      menuShow: true
    }, {
      path: "/templatePrecautions",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(457).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1480)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "安全措施基础信息管理",
      menuShow: true
    }, {
      path: "/operations",
      component: operations,
      name: "运维工具箱",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "培训管理",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/training/trainingPlan",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(326).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1321)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "培训计划",
      menuShow: true
    }, {
      path: "/training/trainingSituation",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(284).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1784)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "培训情况",
      menuShow: true
    }, {
      path: "/training/course",
      component: Course,
      name: "课程管理",
      menuShow: true
    }, {
      path: "/training/questionBank",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(447).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1781)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "题库管理",
      menuShow: true
    }, {
      path: "/training/topic",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(339).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1783)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "提干管理",
      menuShow: true
    }, {
      path: "/training/testPaper",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(410).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1782)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "试卷管理",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "证照管理",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/card/userCard",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(196).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1486)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "证照采集",
      menuShow: true
    }, {
      path: "/card/userCardReview",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(322).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1487)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "证照复审",
      menuShow: true
    }, {
      path: "/card/userCardWarn",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(321).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1488)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "证照过期预警",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "学习园地",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/security/staPlaList",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(260).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1609)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "标准规范",
      menuShow: true
    }, {
      path: "/security/accCasList",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(265).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1606)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "事故案例库",
      menuShow: true
    }, {
      path: "/security/safCulList",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(262).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1607)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "安全文化",
      menuShow: true
    }, {
      path: "/security/safKnoList",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(261).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1608)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "安全知识",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "系统监控",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/hystrix",
      meta: { url: "https://www.baidu.com" },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(514).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1477)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "Hystirx监控面板",
      menuShow: true
    }, {
      path: "/registry",
      meta: { url: "https://www.runoob.com" },
      component: function component(resolve) {
        return __webpack_require__.e/* require */(451).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1478)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "服务注册",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "隐患计划管理",
    menuShow: true,
    leaf: false,
    children: [{
      path: "/inspectionPlan/plan",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(158).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1538)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "隐患计划",
      menuShow: true,
      leaf: true
    }, {
      path: "/inspectionPlan/check",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(159).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1537)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "隐患计划排查",
      menuShow: true,
      leaf: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "MeetingPlanMessageList",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/messageList",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(298).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1589)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "消息列表",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "积分管理",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/point/pointSettingList",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(476).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1561)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "积分设置",
      menuShow: true
    }, {
      path: "/point/pointDetailsList",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(477).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1559)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "积分详情",
      menuShow: true
    }, {
      path: "/point/poinTrankingList",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(478).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1558)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "积分排名",
      menuShow: true
    }, {
      path: "/point/poinModularList",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(401).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1560)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "积分模块设置",
      menuShow: true
    }]
  }, {
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: 'questionnaire',
    menuShow: true,
    leaf: true,
    children: [{
      path: '/questionnaire',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(440).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1304)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: '问卷',
      menuShow: true
    }]
  }, {
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: 'qrCode',
    menuShow: true,
    leaf: true,
    children: [{
      path: '/qrCode',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(438).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1303)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: '二维码',
      menuShow: true
    }]
  }, {
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: 'tariningPrograms',
    menuShow: true,
    leaf: true,
    children: [{
      path: '/tariningProgramList',
      component: function component(resolve) {
        return __webpack_require__.e/* require */(313).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1319)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: '培训计划选择',
      menuShow: true
    }]
  }, {
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: 'alertmanagment',
    menuShow: true,
    leaf: true,
    children: [{
      path: "/alert",
      component: AlertComp,
      name: '预警模板设置',
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "工伤管理",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/jobInjury",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(513).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1545)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "工伤信息录入",
      menuShow: true
    }, {
      path: "/jobInjuryManage",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(512).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1546)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "工伤信息管理",
      menuShow: true
    }, {
      path: "/work/injury",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(152).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1543)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "工伤信息",
      menuShow: true
    }, {
      path: "/work/injuryWeek",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(150).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1544)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "工伤周报",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "welcomeInspection",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/listWelcomeInspection",
      component: ListWelcomeInspection,
      name: "迎检计划",
      menuShow: true
    }, {
      path: "/resultWelcomeInspection",
      component: ResultWelcomeInspection,
      name: "迎检结果",
      menuShow: true
    }, {
      path: "/rectifyWelcomeInspection",
      component: RectifyWelcomeInspection,
      name: "整改情况",
      menuShow: true
    }, {
      path: "/acceptWelcomeInspection",
      component: AcceptWelcomeInspection,
      name: "问题验收",
      menuShow: true
    }, {
      path: "/resultReport",
      component: ResultReport,
      name: "迎检结果",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "安全环保",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/outfall",
      component: outfall,
      name: "排口管理",
      menuShow: true
    }, {
      path: "/radiate",
      component: radiate,
      name: "辐射信息模块",
      menuShow: true
    }, {
      path: "/epfacilities",
      component: epfacilities,
      name: "环保设施台账",
      menuShow: true
    }, {
      path: "/manualMonitor",
      component: manualMonitor,
      name: "手工监测数据",
      menuShow: true
    }, {
      path: "/rainwaterMonitor",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(506).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1410)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "雨水排放口监测",
      menuShow: true
    }, {
      path: "/manualMonitorYear",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(504).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1415)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "年度排放口手工监测数据",
      menuShow: true
    }, {
      path: "/rainwaterMonitorYear",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(505).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1411)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "年度雨水排放口监测数据",
      menuShow: true
    }, {
      path: "/factorMaintain",
      component: factorMaintain,
      name: "监测因子维护",
      menuShow: true
    }, {
      path: "/factorManage",
      component: factorManage,
      name: "监测因子管理",
      menuShow: true
    }, {
      path: "/discharge",
      component: discharge,
      name: "企业排放总量",
      menuShow: true
    }, {
      path: "/concentration",
      component: concentration,
      name: "企业排放浓度",
      menuShow: true
    }, {
      path: "/hourColl/day",
      component: hourCollDay,
      name: "烟气检测日报",
      menuShow: true
    }, {
      path: "/dayHourColl",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(344).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1396)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "烟气监测小时均值报表",
      menuShow: true
    }, {
      path: "/enCollectHour/listA",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(509).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1404)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "烟气监测月报[主要]",
      menuShow: true
    }, {
      path: "/enCollectHour/listB",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(508).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1405)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "烟气监测月报[一般]",
      menuShow: true
    }, {
      path: "/enCollectDay/listA",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(309).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1399)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "烟气监测日报[主要]",
      menuShow: true
    }, {
      path: "/enCollectDay/listB",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(308).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1400)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "烟气监测日报[一般]",
      menuShow: true
    }, {
      path: "/enCollectDay/listCollect",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(510).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1403)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "环保废气监测数据",
      menuShow: true
    }, {
      path: "/enCollectDay/listQuarter",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(511).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1398)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "环保废气日均数据",
      menuShow: true
    }, {
      path: "/enCollectGraphsA",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(516).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1401)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "烟气监测曲线[主要]",
      menuShow: true
    }, {
      path: "/enCollectGraphsB",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(515).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1402)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "烟气监测曲线[一般]",
      menuShow: true
    }, {
      path: "/enCollectReport",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(397).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1406)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "小时数据完整性统计",
      menuShow: true
    }, {
      path: "/epDosingRecord",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(396).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1407)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "加药记录",
      menuShow: true
    }, {
      path: "/epTransportRecords",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(502).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1412)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "脱硫石膏运输记录",
      menuShow: true
    }, {
      path: "/epUnorganizedEmission",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(460).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1413)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "无组织排放数据录入",
      menuShow: true
    }, {
      path: "/hazWasInfoManagement/epHazardousList",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(169).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1421)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "危险化学品维护",
      menuShow: true
    }, {
      path: "/hazWasInfoManagement/epProductionWasteRecord",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(462).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1418)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "产废记录",
      menuShow: true
    }, {
      path: "/hazWasInfoManagement/epWarehousingRecord",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(461).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1420)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "入库记录",
      menuShow: true
    }, {
      path: "/hazWasInfoManagement/epTransferRecord",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(307).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1419)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "出库记录",
      menuShow: true
    }, {
      path: "/hazardousTask/audit",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(250).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1423)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "出库记录审批",
      menuShow: true
    }, {
      path: "/hazWasInfoManagement/epWasteRecord",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(507).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1422)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "库存记录",
      menuShow: true
    }, {
      path: "/epPlanMaintenance",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(369).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1426)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "计划停机维护",
      menuShow: true
    }, {
      path: "/epMonitorOutUpper",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(503).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1425)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "有组织监测超标数据",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "接口管理",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/DataPoints",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(498).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1429)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "对接数据点",
      menuShow: true
    }, {
      path: "/DataInfo",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(500).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1427)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "对接信息",
      menuShow: true
    }, {
      path: "/DataLog",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(499).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1428)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "发送日志",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "劳保管理",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/sulPurchase",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(183).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1311)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "劳保申领",
      menuShow: true
    }, {
      path: "/laborProtection/ncRecord",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(488).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1552)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "劳保出库记录",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "有毒气体",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/basicData/toxicGasMaintenance",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(465).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1754)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "有毒气体维护",
      menuShow: true
    }, {
      path: "/basicData/fixedMonitoringDevice",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(209).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1753)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "固定监测装置",
      menuShow: true
    }, {
      path: "/basicData/MonitoringPositionAlarmConfig",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(466).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1752)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "监测位置报警配置",
      menuShow: true
    }, {
      path: "/basicData/MAlarmPointManagement",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(431).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1751)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "监测报警点管理",
      menuShow: true
    }, {
      path: "/txAlarm/list",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(244).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1755)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "煤气报警监测数据",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "智能应用",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/intelligentApp/equipmentInfo",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(340).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1542)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "设备信息",
      menuShow: true
    }, {
      path: "/intelligentApp/equipmentFlow",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(365).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1541)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "设备流转",
      menuShow: true
    }, {
      path: "/intelligentApp/alarm",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(105).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1539)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "告警记录",
      menuShow: true
    }, {
      path: "/intelligentApp/alarmSta",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(243).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1540)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "告警统计",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "平台数据",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/userData/userList",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(494).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1554)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "平台数据",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "安全责任书管理",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/safetyResponsibilityLetter/spSafetyBook",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(328).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1572)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "签订模板维护",
      menuShow: true
    }, {
      path: "/safetyResponsibilityLetter/spSafetySign",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(235).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1573)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "安全责任书签订",
      menuShow: true
    }, {
      path: "/safetyResponsibilityLetter/spSafertPromise",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(286).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1571)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "安全承诺书签订",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "周报统计",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/weekly/weeklyReport",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(446).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1787)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "周报填报",
      menuShow: true
    }, {
      path: "/weekly/weeklyCollect",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(464).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1786)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "周报汇总",
      menuShow: true
    }]
  }, {
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home__["a" /* default */],
    name: "系统报表",
    menuShow: true,
    leaf: true,
    children: [{
      path: "/riskPatrol/report",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(387).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1465)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "风险巡查报表",
      menuShow: true
    }, {
      path: "/firePoint/report",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(389).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1463)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "防火巡查报表",
      menuShow: true
    }, {
      path: "/fireControl/report",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(390).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1462)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "消防设施点检报表",
      menuShow: true
    }, {
      path: "/inspectCompare/report",
      component: function component(resolve) {
        return __webpack_require__.e/* require */(388).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1464)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      },
      name: "隐患整改对比表",
      menuShow: true
    }]
  }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_4__newRouter__["a" /* default */]))
});

router.beforeEach(function (to, from, next) {
  if (to.path.startsWith("/login") || to.path.startsWith("/oaLogin")) {
    window.localStorage.removeItem("access-token");
    next();
  } else if (to.path.startsWith("/index")) {
    next();
  } else if (to.path.includes("http")) {
    window.open(to.fullPath.substr(1));
  } else if (to.path.indexOf("workCertificatePreview") != -1) {
    next();
  } else {
    var user = window.localStorage.getItem("access-token");
    if (!user) {
      next({ path: "/login" });
    } else {
      next();
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 596:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 597:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 598:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 599:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 600:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 601:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 602:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 605:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(304);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_069a4326_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(1220);
function injectStyle (ssrContext) {
  __webpack_require__(1194)
}
var normalizeComponent = __webpack_require__(72)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_069a4326_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 607:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_constant__ = __webpack_require__(51);




/* harmony default export */ __webpack_exports__["a"] = ({
  save: function save(params, config, action) {
    if (!action) {
      action = __WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Base + '/sysAtt/save';
    }
    return __WEBPACK_IMPORTED_MODULE_0____["b" /* POST */](action, params, config);
  },

  delAttById: function delAttById(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Base + '/sysAtt/delAttById', params);
  },

  getAttByIds: function getAttByIds(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Base + '/sysAtt/getAttByIds', params);
  },

  delAttByIds: function delAttByIds(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Base + '/sysAtt/delAttByIds', params);
  }

});

/***/ }),

/***/ 609:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_constant__ = __webpack_require__(51);




/* harmony default export */ __webpack_exports__["a"] = ({
  getTree: function getTree(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/dept/tree', params);
  },
  getNewTree: function getNewTree(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/new/dept/tree', params);
  },
  dropDownTree: function dropDownTree(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/new/dept/dropDownTree', params);
  },
  getDeptTreeWithSubsidiary: function getDeptTreeWithSubsidiary(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/dept/treeWithSubsidiary', params);
  },
  update: function update(params, config) {
    return __WEBPACK_IMPORTED_MODULE_0____["b" /* POST */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/dept/update', params, config);
  },
  save: function save(params, config) {
    return __WEBPACK_IMPORTED_MODULE_0____["b" /* POST */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/dept/save', params, config);
  },
  remove: function remove(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/dept/remove', params);
  },
  getIdsByUserId: function getIdsByUserId(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/dept/getIdsByUserId', params);
  },
  getStructureUrl: function getStructureUrl(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/dept/getStructureUrl', params);
  },
  getDeptByUserId: function getDeptByUserId(id) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/dept/getDeptByUserId?userId=' + id);
  },
  getlistAll: function getlistAll(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/dept/listAll', params);
  },
  getlistAllNew: function getlistAllNew(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/dept/list', params);
  },

  getTreeByUserId: function getTreeByUserId(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/dept/treeByUserId', params);
  },

  getUserList: function getUserList(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/user/getEnterpriseIdUser', params);
  },
  getOrganizationTree: function getOrganizationTree(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/dept/getOrganizationTree', params);
  },
  getTreeDeptAndUser: function getTreeDeptAndUser(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/dept/getTreeDeptAndUser', params);
  },
  getDeptNodeById: function getDeptNodeById(id) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/dept/getById?id=' + id);
  },
  listUserAllDeptTree: function listUserAllDeptTree() {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/dept/listUserAllDeptTree');
  },
  putdeptfileter: function putdeptfileter(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/dept/putdeptfileter', params);
  },
  getdeptfileter: function getdeptfileter(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/dept/getdeptfileter', params);
  },
  getEnableRemoveDept: function getEnableRemoveDept(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/dept/getEnableRemoveDept', params);
  },
  getByEmployee: function getByEmployee(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.CMS + '/employee/getByEmployee', params);
  },
  deptSaveValid: function deptSaveValid(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["b" /* POST */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/dept/deptSaveValid', params);
  },
  getSafeUser: function getSafeUser(deptId) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/new/dept/getSafeUser?deptId=' + deptId);
  }

});

/***/ }),

/***/ 612:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_constant__ = __webpack_require__(51);




/* harmony default export */ __webpack_exports__["a"] = ({
  getTree: function getTree(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/enterprisebase/getTree', params);
  },

  findTree: function findTree(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/enterprisebase/findTree', params);
  },

  checkCompanyCode: function checkCompanyCode(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/enterprisebase/checkCompanyCode', params);
  },

  getTreeById: function getTreeById(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/enterprisebase/getTreeById', params);
  },

  findList: function findList(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/enterprisebase/list', params);
  },

  findById: function findById(id) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/enterprisebase/findById/' + id);
  },

  save: function save(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["b" /* POST */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/enterprisebase/save', params);
  },

  update: function update(id, params) {
    return __WEBPACK_IMPORTED_MODULE_0____["e" /* PUT */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/enterprisebase/update', params);
  },

  remove: function remove(id) {
    return __WEBPACK_IMPORTED_MODULE_0____["c" /* DELETE */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/enterprisebase/remove?id=' + id);
  },

  batchRemove: function batchRemove(ids) {
    return __WEBPACK_IMPORTED_MODULE_0____["c" /* DELETE */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/enterprisebase/batchRemove/' + ids);
  },

  getEnterType: function getEnterType() {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/enterprisebase/getEnterType');
  },

  getEnterNature: function getEnterNature() {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/enterprisebase/getEnterNature');
  },

  getArea: function getArea(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/enterprisebase/getArea', params);
  },

  getAreaByCode: function getAreaByCode(areaCode) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/enterprisebase/getAreaByCode?areaCode=' + areaCode);
  },

  getPost: function getPost(enterpriseId) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/enterprisebase/getPost?enterpriseId=' + enterpriseId);
  },

  getIndustry: function getIndustry(parentId, level) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/enterprisebase/getIndustry?parentId=' + parentId + '&level=' + level);
  },
  getIndustryTree: function getIndustryTree(parentCode) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/enterprisebase/getIndustryTree?parentCode=' + parentCode);
  },

  findIndustrysListByEntId: function findIndustrysListByEntId(id) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/enterprisebase/findIndustrysListByEntId?id=' + id);
  },

  findEntById: function findEntById(id) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/enterprisebase/findById?id=' + id);
  },

  getSunCompanyTree: function getSunCompanyTree(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Admin + '/enterprisebase/getSunCompanyTree', params);
  }
});

/***/ }),

/***/ 619:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_constant__ = __webpack_require__(51);




/* harmony default export */ __webpack_exports__["a"] = ({
  findList: function findList(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Base + '/version/list', params);
  },

  findById: function findById(id) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Base + '/version/getById?id=' + id);
  },

  add: function add(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["b" /* POST */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Base + '/version/add', params);
  },
  update: function update(id, params) {
    return __WEBPACK_IMPORTED_MODULE_0____["e" /* PUT */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Base + '/version/update', params);
  },

  save: function save(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["b" /* POST */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Base + '/version/save', params);
  },

  remove: function remove(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["c" /* DELETE */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Base + '/version/remove', params);
  },
  newestData: function newestData() {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Base + '/version/newestData');
  }
});

/***/ }),

/***/ 6194:
/***/ (function(module, exports) {

module.exports = math;

/***/ }),

/***/ 620:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_constant__ = __webpack_require__(51);




/* harmony default export */ __webpack_exports__["a"] = ({

  listByUser: function listByUser(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.CMS + '/eMeetingMessage/listByUser', params);
  },

  notReadNumber: function notReadNumber() {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.CMS + '/eMeetingMessage/notReadNumber');
  },
  getById: function getById(id) {
    return __WEBPACK_IMPORTED_MODULE_0____["a" /* GET */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.CMS + '/eMeetingMessage/getById?id=' + id);
  },
  updateIsSee: function updateIsSee(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["b" /* POST */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.CMS + '/eMeetingMessage/updateIsSee', params);
  }
});

/***/ }),

/***/ 622:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  taskStatus: {
    processing: 1,
    sucess: 2,
    failure: 3,
    expired: 4 },
  asyncFileExportType: {
    proofOfHoursByTask: 1,
    trainingRecordByTask: 2 }
});

/***/ }),

/***/ 664:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_constant__ = __webpack_require__(51);




/* harmony default export */ __webpack_exports__["a"] = ({
  async: function async(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["b" /* POST */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Tranning + '/export/async', params);
  },

  asyncStatus: function asyncStatus(params) {
    return __WEBPACK_IMPORTED_MODULE_0____["b" /* POST */](__WEBPACK_IMPORTED_MODULE_1__common_constant__["a" /* default */].apiServer.Tranning + '/export/async/status', params);
  }
});

/***/ }),

/***/ 665:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
    '/examination/addQuestion': '/examination/questionBankManagenment',
    '/examination/addPaper': '/examination/paperManagement',
    '/trainingManagement/trainingResourceAdd': '/trainingManagement/trainingResource',
    '/examination/course/addCourse': '/examination/course/courseManagement',
    '/trainingManagement/addTeacher': '/trainingManagement/teacherManagement',
    '/trainingManagement/safetyTrainingProgramSave': '/trainingManagement/safetyTrainingProgramList',
    '/trainingManagement/addLatoja': '/trainingManagement/latojaManagement'
});

/***/ }),

/***/ 666:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_store_js__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_constant_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_baidu_map_v3__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_baidu_map_v3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_baidu_map_v3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_EZUIKit_js_jsmpeg1_min__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pinyin_match__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_iconfont_css__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_iconfont_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_iconfont_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_styles_main_scss__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_styles_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_styles_main_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_styles_base_scss__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_styles_base_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_styles_base_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_css_font_awesome_min_css__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_zdfont_iconfont_css__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_zdfont_iconfont_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_zdfont_iconfont_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue2_org_tree__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_gemini_scrollbar__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_gemini_scrollbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_gemini_scrollbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_jquery__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_print_nb__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_print_nb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_print_nb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_amap__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_amap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vue_amap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_driver_js__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_driver_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_driver_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_driver_js_dist_driver_min_css__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_driver_js_dist_driver_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_driver_js_dist_driver_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_dept_deptedittree__ = __webpack_require__(296);




















__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17_vue2_org_tree__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18_vue_gemini_scrollbar___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_baidu_map_v3___default.a, {
  ak: 'Fvtako1U7b2ZHIfHC8FErBu2wmidUGxo'
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_20_vue_print_nb___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21_vue_amap___default.a);
__WEBPACK_IMPORTED_MODULE_21_vue_amap___default.a.initAMapApiLoader({
  key: '9fafa396fab6d7527b22203b77befb18',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', "AMap.MouseTool", "AMap.RectangleEditor"],

  v: '1.4.4'
});




__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$moment = __WEBPACK_IMPORTED_MODULE_24_moment___default.a;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$driver = new __WEBPACK_IMPORTED_MODULE_22_driver_js___default.a();
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$echarts = __WEBPACK_IMPORTED_MODULE_7_echarts___default.a;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$const = __WEBPACK_IMPORTED_MODULE_5__common_constant_js__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$checkPhone = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$checkPhoneNew = /^((1[0-9]{10})|([0-9]{3,4})?[0-9]{7,8})$/g;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$checkName = /^([一-龥]{1,20}|[a-zA-Z\\.\\s]{1,20})$/;
__WEBPACK_IMPORTED_MODULE_6_element_ui___default.a.Dialog.props.closeOnClickModal.default = false;

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_25__components_dept_deptedittree__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('deptedittree', __WEBPACK_IMPORTED_MODULE_25__components_dept_deptedittree__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui___default.a, { zIndex: 1000 });

var _this = this;

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].directive('has', {
  inserted: function inserted(el, binding) {
    if (!__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$_has(binding.value)) {
      el.parentNode.removeChild(el);
    }
  },
  update: function update(el, binding, vnode) {},
  componentUpdated: function componentUpdated(el, binding, vnode) {}
});

__WEBPACK_IMPORTED_MODULE_19_jquery___default()(".number").click(function () {
  console.log(".................................................................................");
});
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].directive("input-limit", {
  bind: function bind(el, binding) {
    var wins_0 = /[^\d]/g;
    var wins_1 = /[^\d^\.]/g;
    var flag = true;
    var points = 0;
    var lengths = 0;
    var remainder = 0;
    var no_int = 0;
    var target = el instanceof HTMLInputElement ? el : el.querySelector("input");
    target.addEventListener("compositionstart", function (e) {
      flag = false;
    });
    target.addEventListener("compositionend", function (e) {
      flag = true;
    });
    target.addEventListener("input", function (e) {
      setTimeout(function () {
        if (flag) {
          if (binding.value == 0) {
            if (wins_0.test(e.target.value)) {
              e.target.value = e.target.value.replace(wins_0, "");
              e.target.dispatchEvent(new Event("input"));
            }
          }
          if (binding.value == 1) {
            if (wins_0.test(e.target.value.toString().replace(/\d+\.(\d*)/, '$1'))) {
              remainder = true;
            }
            if (e.target.value.split('.').length - 1 > 1) {
              points = true;
            }
            if (e.target.value.toString().split(".")[1] != undefined) {
              if (e.target.value.toString().split(".")[1].length > 1) {
                lengths = true;
              }
            }
            if (e.target.value.toString().indexOf(".") != -1) {
              no_int = false;
            } else {
              no_int = true;
            }
            if (wins_1.test(e.target.value) || lengths || points || remainder) {
              if (!no_int) {
                e.target.value = e.target.value.replace(wins_1, "").replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').substring(0, e.target.value.indexOf(".") + 2);
              } else {
                e.target.value = e.target.value.replace(wins_0, "");
              }
              e.target.dispatchEvent(new Event("input"));
            }
          }

          if (binding.value == 2) {
            if (wins_0.test(e.target.value.toString().replace(/\d+\.(\d*)/, '$1'))) {
              remainder = true;
            }
            if (e.target.value.split('.').length - 1 > 1) {
              points = true;
            }
            if (e.target.value.toString().split(".")[1] != undefined) {
              if (e.target.value.toString().split(".")[1].length > 2) {
                lengths = true;
              }
            }
            if (e.target.value.toString().indexOf(".") != -1) {
              no_int = false;
            } else {
              no_int = true;
            }
            if (wins_1.test(e.target.value) || lengths || points || remainder) {
              if (!no_int) {
                e.target.value = e.target.value.replace(wins_1, "").replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').substring(0, e.target.value.indexOf(".") + 3);
              } else {
                e.target.value = e.target.value.replace(wins_0, "");
              }
              e.target.dispatchEvent(new Event("input"));
            }
          }
        }
      }, 0);
    });
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].directive('frequency', {
  bind: function bind(el, binding) {
    el.addEventListener('click', function (e) {
      el.setAttribute('disabled', 'disabled');
      setTimeout(function () {
        el.removeAttribute('disabled');
      }, binding.value || 300);
    });
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].directive('delsp', {
  bind: function bind(el, binding) {
    el.addEventListener('input', function (e) {
      var reg = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、\s]/g,
          returnStr = e.target.value.replace(reg, '');
      e.target.value = returnStr;
      e.target.dispatchEvent(new Event("input"));
    });
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$_has = function (value) {
  var isExist = false;
  var buttonpermsStr = localStorage.getItem("perms");
  if (buttonpermsStr == undefined || buttonpermsStr == null) {
    return false;
  }
  var buttonperms = JSON.parse(buttonpermsStr);
  for (var i = 0; i < buttonperms.length; i++) {
    if (buttonperms[i].authority.indexOf(value) > -1) {
      isExist = true;
      break;
    }
  }
  return isExist;
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.isNormalUser = function () {
  var isNormalUser = false;
  var userinfoStr = localStorage.getItem("userinfo");
  var userinfo = JSON.parse(userinfoStr);
  return userinfo.isNormalUser;
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('format', function (val, arg) {
  if (!val) return;
  var pattern = 'yyyy-MM-dd HH:mm:ss';
  if (arg) {
    pattern = arg;
  }

  val = val.replace(/-/g, "/").substring(0, 19);
  return new Date(val).format(pattern);
});

Date.prototype.format = function (format) {
  var o = {
    "M+": this.getMonth() + 1,
    "d+": this.getDate(),
    "H+": this.getHours(),
    "m+": this.getMinutes(),
    "s+": this.getSeconds(),
    "q+": Math.floor((this.getMonth() + 3) / 3),
    "S": this.getMilliseconds() };
  if (/(y+)/i.test(format)) {
    format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
    }
  }
  return format;
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$formatTimeStr = function (timestamp) {
  var date = new Date(timestamp);
  var year = date.getFullYear();
  var month = (date.getMonth() + 1).toString().padStart(2, '0');
  var day = date.getDate().toString().padStart(2, '0');
  var hours = date.getHours().toString().padStart(2, '0');
  var minutes = date.getMinutes().toString().padStart(2, '0');
  return year + '\u5E74' + month + '\u6708' + day + '\u65E5 ' + hours + '\u65F6' + minutes + '\u5206';
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$formatTimePt = function (str) {
  if (typeof str !== 'string') {
    return '';
  }
  return str.length > 16 ? str.substring(0, 16) : str;
};

new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__vuex_store_js__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */]
  }
});

/***/ }),

/***/ 667:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Home__ = __webpack_require__(566);


var teacherManagement = function teacherManagement() {
  return __webpack_require__.e/* import() */(482).then(__webpack_require__.bind(null, 1776));
};
var addTeacher = function addTeacher() {
  return __webpack_require__.e/* import() */(166).then(__webpack_require__.bind(null, 1758));
};

var trainingResource = function trainingResource() {
  return __webpack_require__.e/* import() */(252).then(__webpack_require__.bind(null, 1778));
};
var addProgram = function addProgram() {
  return __webpack_require__.e/* import() */(154).then(__webpack_require__.bind(null, 1757));
};
var latojaManagement = function latojaManagement() {
  return __webpack_require__.e/* import() */(358).then(__webpack_require__.bind(null, 1768));
};

var trainingTask = function trainingTask() {
  return __webpack_require__.e/* import() */(160).then(__webpack_require__.bind(null, 1775));
};
var publishTask = function publishTask() {
  return __webpack_require__.e/* import() */(171).then(__webpack_require__.bind(null, 1774));
};
var selectCourse = function selectCourse() {
  return __webpack_require__.e/* import() */(251).then(__webpack_require__.bind(null, 1320));
};

var trainingResourceDetail = function trainingResourceDetail() {
  return __webpack_require__.e/* import() */(165).then(__webpack_require__.bind(null, 1779));
};
var trainingDetail = function trainingDetail() {
  return __webpack_require__.e/* import() */(402).then(__webpack_require__.bind(null, 1777));
};
var addLatoja = function addLatoja() {
  return __webpack_require__.e/* import() */(129).then(__webpack_require__.bind(null, 1756));
};
var examInfo = function examInfo() {
  return __webpack_require__.e/* import() */(483).then(__webpack_require__.bind(null, 1767));
};
var questionBankManagenment = function questionBankManagenment() {
  return __webpack_require__.e/* import() */(375).then(__webpack_require__.bind(null, 1529));
};
var paperManagement = function paperManagement() {
  return __webpack_require__.e/* import() */(359).then(__webpack_require__.bind(null, 1528));
};
var examManagement = function examManagement() {
  return __webpack_require__.e/* import() */(485).then(__webpack_require__.bind(null, 1524));
};
var examStatistics = function examStatistics() {
  return __webpack_require__.e/* import() */(484).then(__webpack_require__.bind(null, 1525));
};
var issueExam = function issueExam() {
  return __webpack_require__.e/* import() */(191).then(__webpack_require__.bind(null, 1527));
};
var directory = function directory() {
  return __webpack_require__.e/* import() */(408).then(__webpack_require__.bind(null, 1764));
};
var examStatisticsDetail = function examStatisticsDetail() {
  return __webpack_require__.e/* import() */(445).then(__webpack_require__.bind(null, 1526));
};
var addPaper = function addPaper() {
  return __webpack_require__.e/* import() */(232).then(__webpack_require__.bind(null, 1522));
};
var addQuestion = function addQuestion() {
  return __webpack_require__.e/* import() */(221).then(__webpack_require__.bind(null, 1523));
};

var courseManagement = function courseManagement() {
  return __webpack_require__.e/* import() */(208).then(__webpack_require__.bind(null, 1763));
};
var addCourse = function addCourse() {
  return __webpack_require__.e/* import() */(137).then(__webpack_require__.bind(null, 1762));
};

var safetyTrainingProgramList = function safetyTrainingProgramList() {
  return __webpack_require__.e/* import() */(314).then(__webpack_require__.bind(null, 1772));
};
var safetyTrainingProgramSave = function safetyTrainingProgramSave() {
  return __webpack_require__.e/* import() */(256).then(__webpack_require__.bind(null, 1773));
};
var safetyTrainingProgramDetails = function safetyTrainingProgramDetails() {
  return __webpack_require__.e/* import() */(173).then(__webpack_require__.bind(null, 1771));
};

var trainingObject = function trainingObject() {
  return __webpack_require__.e/* import() */(377).then(__webpack_require__.bind(null, 1770));
};

var offlineTrainingObjects = function offlineTrainingObjects() {
  return __webpack_require__.e/* import() */(316).then(__webpack_require__.bind(null, 1769));
};

var myTrain = function myTrain() {
  return __webpack_require__.e/* import() */(336).then(__webpack_require__.bind(null, 1633));
};
var myExam = function myExam() {
  return __webpack_require__.e/* import() */(444).then(__webpack_require__.bind(null, 1632));
};
var train = function train() {
  return __webpack_require__.e/* import() */(222).then(__webpack_require__.bind(null, 1634));
};
var exam = function exam() {
  return __webpack_require__.e/* import() */(403).then(__webpack_require__.bind(null, 1630));
};
var lookExam = function lookExam() {
  return __webpack_require__.e/* import() */(376).then(__webpack_require__.bind(null, 1631));
};

var archivesEnterprise = function archivesEnterprise() {
  return __webpack_require__.e/* import() */(151).then(__webpack_require__.bind(null, 1759));
};

var osofList = function osofList() {
  return __webpack_require__.e/* import() */(443).then(__webpack_require__.bind(null, 1761));
};
var osofDir = function osofDir() {
  return __webpack_require__.e/* import() */(140).then(__webpack_require__.bind(null, 1760));
};

var entOpenCourse = function entOpenCourse() {
  return __webpack_require__.e/* import() */(360).then(__webpack_require__.bind(null, 1765));
};
var entOpentPlay = function entOpentPlay() {
  return __webpack_require__.e/* import() */(293).then(__webpack_require__.bind(null, 1766));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Home__["a" /* default */],
  name: '新培训管理',
  menuShow: true,
  leaf: true,
  children: [{
    path: '/trainingManagement/trainingResource',
    component: trainingResource,
    name: '培训资源管理',
    menuShow: true
  }, {
    path: '/trainingManagement/latojaManagement',
    component: latojaManagement,
    name: '线下培训管理',
    menuShow: true
  }, {
    path: '/trainingManagement/safetyTrainingProgramList',
    component: safetyTrainingProgramList,
    name: '安全培训计划',
    menuShow: true
  }, {
    path: '/trainingManagement/safetyTrainingProgramSave',
    component: safetyTrainingProgramSave,
    name: '安全培训计划',
    menuShow: true
  }, {
    path: '/trainingManagement/safetyTrainingProgramEdit',
    component: safetyTrainingProgramSave,
    name: '编辑安全培训计划',
    menuShow: true
  }, {
    path: '/safetyTrainingProgram/details',
    component: safetyTrainingProgramDetails,
    name: '计划详情',
    menuShow: true
  }, {
    path: '/safetyTrainingProgram/details/trainingObject',
    component: trainingObject,
    name: '培训对象',
    menuShow: true
  }, {
    path: '/safetyTrainingProgram/details/offlineTrainingObjects',
    component: offlineTrainingObjects,
    name: '培训对象',
    menuShow: true
  }, {
    path: '/trainingManagement/trainingTask',
    component: trainingTask,
    name: '培训任务',
    menuShow: true
  }, {
    path: '/trainingManagement/offlineTrainingTasks',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(374).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1318)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    name: '线下培训任务',
    menuShow: true
  }, {
    path: '/trainingManagement/trainingResourceDetail',
    component: trainingResourceDetail,
    name: '课件详情',
    menuShow: true
  }, {
    path: '/trainingManagement/trainingResourceAdd',
    component: trainingResourceDetail,
    name: '新增课件',
    menuShow: true
  }, {
    path: '/trainingManagement/trainingResourceUpdate',
    component: trainingResourceDetail,
    name: '编辑课件',
    menuShow: true
  }, {
    path: '/trainingManagement/addProgram',
    component: addProgram,
    name: '添加培训计划',
    menuShow: true
  }, {
    path: '/trainingManagement/task/publishTask',
    component: publishTask,
    name: '下发任务',
    menuShow: true
  }, {
    path: '/trainingManagement/task/selectCourse',
    component: selectCourse,
    name: '选择下发课程',
    menuShow: true
  }, {
    path: '/trainingManagement/trainingDetail',
    component: trainingDetail,
    name: '培训任务详情',
    menuShow: true
  }, {
    path: '/trainingManagement/addLatoja',
    component: addLatoja,
    name: '添加线下培训',
    menuShow: true
  }, {
    path: '/trainingManagement/detailLatoja',
    component: addLatoja,
    name: '线下培训详情',
    menuShow: true
  }, {
    path: '/trainingManagement/updateLatoja',
    component: addLatoja,
    name: '编辑线下培训',
    menuShow: true
  }, {
    path: '/trainingManagement/examInfo',
    component: examInfo,
    name: '关联考试信息',
    menuShow: true
  }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Home__["a" /* default */],
  name: '安全教育考试',
  menuShow: true,
  leaf: true,
  children: [{
    path: '/examination/questionBankManagenment',
    component: questionBankManagenment,
    name: '题库管理',
    menuShow: true
  }, {
    path: '/examination/paperManagement',
    component: paperManagement,
    name: '试卷管理',
    menuShow: true
  }, {
    path: '/examination/examManagement',
    component: examManagement,
    name: '考试管理',
    menuShow: true
  }, {
    path: '/examination/examStatistics',
    component: examStatistics,
    name: '考试统计',
    menuShow: true
  }, {
    path: '/examination/examStatisticsDetail',
    component: examStatisticsDetail,
    name: '考试统计详情',
    menuShow: true
  }, {
    path: '/examination/addPaper',
    component: addPaper,
    name: '试卷信息',
    menuShow: true
  }, {
    path: '/examination/addQuestion',
    component: addQuestion,
    name: '新建题库',
    menuShow: true
  },, {
    path: '/examination/detailQuestion',
    component: addQuestion,
    name: '题库详情',
    menuShow: true
  },, {
    path: '/examination/updateQuestion',
    component: addQuestion,
    name: '编辑题库',
    menuShow: true
  }, {
    path: '/examination/issueExam',
    component: issueExam,
    name: '发布考试',
    menuShow: true
  }, {
    path: '/examination/directory',
    component: directory,
    name: '目录',
    menuShow: true
  }, {
    path: '/trainingManagement/teacherManagement',
    component: teacherManagement,
    name: '师资管理',
    menuShow: true
  }, {
    path: '/trainingManagement/detailTeacher',
    component: addTeacher,
    name: '师资信息',
    menuShow: true
  }, {
    path: '/trainingManagement/addTeacher',
    component: addTeacher,
    name: '新建师资',
    menuShow: true
  }, {
    path: '/trainingManagement/updateTeacher',
    component: addTeacher,
    name: '编辑师资',
    menuShow: true
  }, {
    path: '/examination/course/courseManagement',
    component: courseManagement,
    name: '课程管理',
    menuShow: true
  }, {
    path: '/examination/course/addCourse',
    component: addCourse,
    name: '新增课程',
    menuShow: true
  }, {
    path: '/examination/course/updateCourse',
    component: addCourse,
    name: '编辑课程',
    menuShow: true
  }, {
    path: '/examination/course/detailCourse',
    component: addCourse,
    name: '课程信息',
    menuShow: true
  }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Home__["a" /* default */],
  name: '档案管理',
  menuShow: true,
  leaf: true,
  children: [{
    path: '/archives/ent',
    component: archivesEnterprise,
    name: '企业档案',
    menuShow: true
  }, {
    path: '/archives/osof/list',
    component: osofList,
    name: '一期一档',
    menuShow: true
  }, {
    path: '/archives/osof/dir',
    component: osofDir,
    name: '一期一档:档案目录',
    menuShow: true
  }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Home__["a" /* default */],
  name: '学员',
  menuShow: true,
  leaf: true,
  children: [{
    path: '/student/myTrain',
    component: myTrain,
    name: '我的培训',
    menuShow: true
  }, {
    path: '/student/myExam',
    component: myExam,
    name: '我的考试',
    menuShow: true
  }]
}, {
  path: '/student/train',
  component: train,
  name: '开始学习',
  leaf: true,
  menuShow: true
}, {
  path: '/student/exam',
  component: exam,
  name: '开始考试'
}, {
  path: '/student/lookExam',
  component: lookExam,
  name: '查看试卷'
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Home__["a" /* default */],
  name: '开放资源',
  menuShow: true,
  leaf: true,
  children: [{
    path: '/ent-open/course',
    component: entOpenCourse,
    name: '开放课程',
    menuShow: true
  }, {
    path: '/ent-open/play',
    component: entOpentPlay,
    name: '视频播放',
    menuShow: true
  }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Home__["a" /* default */],
  name: '预警管理',
  menuShow: true,
  leaf: true,
  children: [{
    path: '/warningModuleSetting',
    component: function component() {
      return __webpack_require__.e/* import() */(144).then(__webpack_require__.bind(null, 1353));
    },
    name: '预警模板设置',
    menuShow: true
  }, {
    path: '/warningDetail',
    component: function component() {
      return __webpack_require__.e/* import() */(345).then(__webpack_require__.bind(null, 1350));
    },
    name: '预警详情',
    menuShow: true
  }, {
    path: '/ewarning/sms',
    component: function component() {
      return __webpack_require__.e/* import() */(399).then(__webpack_require__.bind(null, 1352));
    },
    name: '短信充值',
    menuShow: true
  }, {
    path: '/ewarning/order',
    component: function component() {
      return __webpack_require__.e/* import() */(301).then(__webpack_require__.bind(null, 1351));
    },
    name: '充值订单',
    menuShow: true
  }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Home__["a" /* default */],
  name: '权限管理',
  menuShow: true,
  leaf: true,
  children: [{
    path: '/warningBuildTemp',
    component: function component() {
      return __webpack_require__.e/* import() */(231).then(__webpack_require__.bind(null, 1346));
    },
    name: '系统内置模板',
    menuShow: true
  }, {
    path: '/builtInAlert',
    component: function component() {
      return __webpack_require__.e/* import() */(300).then(__webpack_require__.bind(null, 1347));
    },
    name: '预警内置对象',
    menuShow: true
  }]
}]);

/***/ }),

/***/ 84:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return POST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GETBLOB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GET; });
/* unused harmony export actiGET */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GET_BYTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PATCH; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_store__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bus_js__ = __webpack_require__(199);








__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.withCredentials = true;

var service = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create();

var userInfo = JSON.parse(window.localStorage.getItem('userinfo'));

service.defaults.timeout = 10000;

service.interceptors.request.use(function (config) {
  config.headers = {
    "X-Content-Type-Options": "nosniff",
    "X-Frame-Options": "SAMEORIGIN",
    "X-XSS-Protection": 1,
    "mode": "block"

  };
  if (window.localStorage.getItem('access-token')) {
    config.headers.Authorization = window.localStorage.getItem('access-token');
  }
  if (config.method == 'post' && userInfo && config.data) {

    if (config.data.enterpriseId != userInfo.enterpriseId) {
      config.data.enterpriseId = config.data.enterpriseId;
    } else {
      config.data.enterpriseId = userInfo.enterpriseId;
    }
  } else if (config.method == 'get' && userInfo && config.params) {
    if (config.params.enterpriseId != userInfo.enterpriseId) {
      config.params.enterpriseId = config.params.enterpriseId;
    } else {
      config.params.enterpriseId = userInfo.enterpriseId;
    }
  }
  __WEBPACK_IMPORTED_MODULE_3__vuex_store__["a" /* default */].state.loading = true;
  return config;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

service.interceptors.response.use(function (response) {
  __WEBPACK_IMPORTED_MODULE_3__vuex_store__["a" /* default */].state.loading = false;
  console.log(response);

  if (response.data && response.data.code) {
    if (parseInt(response.data.code) === 401) {
      __WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* bus */].$emit('goto', '/login');
    }
    if (parseInt(response.data.code) === 204) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_element_ui__["Message"])('授权已过期，请联系服务提供商');
    }
  }

  return response;
}, function (error) {
  console.log(error);
  if (parseInt(error.response.status) === 401 && error.response.data.error == 'invalid_token') {
    __WEBPACK_IMPORTED_MODULE_4__bus_js__["a" /* bus */].$emit('goto', '/login');
  } else {

    __WEBPACK_IMPORTED_MODULE_3__vuex_store__["a" /* default */].state.loading = false;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  }
});

var base = "/apis";

var POST = function POST(url, params) {

  return service.post("" + base + url, params).then(function (res) {
    return res.data;
  });
};

var GETBLOB = function GETBLOB(url, params) {
  return service.get("" + base + url, {
    params: params,
    responseType: "blob"
  }).then(function (res) {
    return res.data;
  });
};

var GET = function GET(url, params) {
  return service.get("" + base + url, {
    params: params
  }).then(function (res) {
    return res.data;
  });
};

var actiGET = function actiGET(url, params) {
  console.error("" + url);
  return service.get("" + url, {
    params: params
  }).then(function (res) {
    return res.data;
  });
};

var GET_BYTE = function GET_BYTE(url, params) {
  return service.get("" + base + url, {
    responseType: 'arraybuffer',
    params: params
  }).then(function (res) {
    return res.data;
  });
};

var PUT = function PUT(url, params) {
  return service.put("" + base + url, params).then(function (res) {
    return res.data;
  });
};

var DELETE = function DELETE(url, params) {
  return service.delete("" + base + url, {
    params: params
  }).then(function (res) {
    return res.data;
  });
};

var PATCH = function PATCH(url, params) {
  return service.patch("" + base + url, params).then(function (res) {
    return res.data;
  });
};

/***/ })

},[666]);


// WEBPACK FOOTER //
// static/js/main.c165dfe4920f2bb89dfc.js